// import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
// import { Plus, Download, SlidersHorizontal, Filter, Search, Upload, Loader, Share2, Sparkles, Heart, X, Bookmark, Trash2, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   CANDIDATE_STATUS_OPTIONS, REMOTE_STATUS_OPTIONS, DATE_OPTIONS, formatDate,
//   WORK_AUTHORIZATION_OPTIONS, EMPLOYMENT_TYPE_OPTIONS, SECURITY_CLEARANCE_OPTIONS,
//   RATE_TYPE_OPTIONS, MARITAL_STATUS_OPTIONS, INDUSTRY_OPTIONS
// } from '../utils/mockData';
// import CandidateTable from './CandidateTable';
// import AddModal from './AddModal';
// import FilterModal from './FilterModal';
// import ShareResumeModal from './ShareResumeModal';
// import { CandidateJobsModal, ScheduleInterviewModal } from './ScheduleInterviewModals';
// import { SubmitProfileModal } from './SubmitProfileModal';
// import { ConfirmParseModal, ParsingLoadingModal, DuplicateResumeModal } from './ParseFlowModals';
// import ColumnFilterSidebar from './ColumnFilterSidebar';
// import CandidateFilterSidebar from './CandidateFilterSidebar';
// import AskAiSidebar from './AskAiSidebar';
// import '../styles/Dashboard.css';
// import '../styles/CandidateTableCustom.css';
// import '../styles/AddModalCustom.css';
// import Swal from 'sweetalert2';
// import * as XLSX from 'xlsx';
// import BASE_URL, { RESUME_PARSER_URL } from "../../url";
// import { formatName, formatJobTitle, formatNameFields, formatFullName } from '../utils/nameFormatter';
// import {
//   countriesData,
//   getCountryCode,
//   getStateCode
// } from '../../erprecruitment/config/locationConfig';

// // ─── Helper to get auth headers ──────────────────────────────────────────────
// const getAuthHeaders = () => {
//   const token = localStorage.getItem('token');
//   return {
//     'Authorization': `Bearer ${token}`,
//   };
// };

// // ─── Module-level cache so multiple mounts don't re-fetch ─────────────────────
// let _cachedCandidates = null;
// let _cachedSearchTerm = '';
// let _cachedStatusFilter = 'all';
// let _cachedAiSearchResults = null;
// let _cachedUseAiSearch = true;
// let _cachedItemsPerPage = 30;
// let _cachedView = null;
// // ──────────────────────────────────────────────────────────────────────────────

// const formatToMonth = (dateStr) => {
//   if (!dateStr) return '';
//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return typeof dateStr === 'string' && dateStr.length >= 7 ? dateStr.substring(0, 7) : dateStr;
//   return d.toISOString().substring(0, 7);
// };

// // ── Transform a raw API candidate object into the shape the UI needs ──────────
// const transformCandidate = (candidate) => {
//   const isEmployee = !!candidate.employee_id;
//   const empId = candidate.employee_id || '';

//   return {
//     CandidateId: candidate.candidate_id,
//     CandidateCode: candidate.candidate_code || `CAN-${String(candidate.candidate_id).padStart(6, '0')}`,
//     EmployeeCode: empId,
//     IsEmployee: isEmployee,
//     FirstName: formatName(candidate.first_name || ''),
//     LastName: formatName(candidate.last_name || ''),
//     MiddleName: formatName(candidate.middle_name || ''),
//     JobTitle: formatJobTitle(candidate.job_title || ''),
//     YearsOfExperience: candidate.years_exp,
//     CandidateStatus: candidate.status || 'Available',
//     RemoteStatus: candidate.remote_status || 'OnSite',
//     CreatedDt: candidate.created_on,
//     ProfileSummary: candidate.profile_summary || '',
//     LinkedInUrl: candidate.linkedin_url || '',
//     GitHubUrl: candidate.github_url || '',
//     TwitterUrl: candidate.twitter_url || '',
//     VideoResumeUrl: candidate.video_resume_url || '',
//     Gender: candidate.gender || '',
//     CurrentLocation: candidate.current_location || '',
//     Source: candidate.source || '',

//     // NEW FIELDS from backend
//     WorkAuthorization: candidate.work_authorization || '',
//     SecurityClearance: candidate.security_clearance || '',
//     WillingToRelocate: candidate.willing_to_relocate || false,
//     IsBench: candidate.is_bench || false,
//     EmploymentType: candidate.employment_type || '',
//     ExpectedRateFrom: candidate.expected_rate_from || '',
//     ExpectedRateTo: candidate.expected_rate_to || '',
//     ExpectedRateType: candidate.expected_rate_type || 'Hourly',
//     CurrentRate: candidate.current_rate || '',
//     CurrentRateType: candidate.current_rate_type || 'Hourly',
//     MaritalStatus: candidate.marital_status || '',
//     Industry: candidate.industry || '',
//     Mobile: candidate.mobile || '',

//     Contact: {
//       Email: candidate.email || '',
//       Phone: candidate.phone || '',
//       Mobile: candidate.mobile || '',
//     },
//     Phones: candidate.phones || [],
//     Emails: candidate.emails || [],
//     Skills: (candidate.skills || []).map(s =>
//       typeof s === 'string'
//         ? { SkillName: s, SkillType: 'HARD' }
//         : { SkillName: s.skill_name || s.SkillName || '', SkillType: s.skill_type || s.SkillType || 'HARD' }
//     ),
//     Education: (candidate.education || []).map(e => ({
//       Institution: formatName(e.Institution || e.institution || ''),
//       Degree: formatName(e.Degree || e.degree || ''),
//       FieldOfStudy: e.FieldOfStudy || e.fieldOfStudy || '',
//       StartDate: formatToMonth(e.StartDate || e.startDate),
//       EndDate: formatToMonth(e.EndDate || e.endDate),
//       GPA: e.GPA || e.gpa || '',
//     })),
//     WorkExperience: (candidate.work_experience || []).map(w => ({
//       Company: w.Company || w.company || '',
//       JobTitle: formatJobTitle(w.JobTitle || w.jobTitle || ''),
//       StartDate: formatToMonth(w.StartDate || w.startDate),
//       EndDate: formatToMonth(w.EndDate || w.endDate),
//       IsCurrent: w.IsCurrent ?? w.isCurrent ?? false,
//       Description: w.Description || w.description || '',
//     })),
//     Certifications: (candidate.certifications || []).map(c => ({
//       CertificationName: formatName(c.CertificationName || c.name || ''),
//       IssuingOrganization: c.IssuingOrganization || c.issuingOrg || '',
//       IssueDate: formatToMonth(c.IssueDate || c.issueDate),
//       ExpiryDate: formatToMonth(c.ExpiryDate || c.expiryDate),
//       CredentialId: c.CredentialId || c.credentialId || '',
//       CredentialUrl: c.CredentialUrl || c.credentialUrl || '',
//     })),
//     Document: candidate.document ? {
//       DocumentId: candidate.document.DocumentId,
//       FileNameOriginal: candidate.document.FileNameOriginal,
//       FileExtension: candidate.document.FileExtension,
//       MimeType: candidate.document.MimeType,
//       FileSizeBytes: candidate.document.FileSizeBytes,
//       StorageLocator: candidate.document.StorageLocator,
//       ParseStatus: candidate.document.ParseStatus,
//       DownloadUrl: candidate.document.DownloadUrl,
//     } : null,
//     Documents: (candidate.documents || []).map(d => ({
//       DocumentId: d.DocumentId || d.documentId,
//       DocumentType: d.DocumentType || d.documentType || 'Certificate',
//       DocumentName: d.FileNameOriginal ? d.FileNameOriginal.replace(/\.[^/.]+$/, "") : (d.DocumentName || ''),
//       FileNameOriginal: d.FileNameOriginal || d.fileNameOriginal,
//       FileExtension: d.FileExtension || d.fileExtension,
//       MimeType: d.MimeType || d.mimeType,
//       FileSizeBytes: d.FileSizeBytes || d.fileSizeBytes,
//       UploadedOn: d.UploadedOn || d.uploadedOn,
//       VersionNo: d.VersionNo || d.versionNo,
//       IsPrimary: d.IsPrimary || d.isPrimary,
//     })),
//   };
// };

// const ResumeDashboard = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const currentView = queryParams.get('view') || 'all';
//   const [candidates, setCandidates] = useState(_cachedCandidates || []);
//   const [loading, setLoading] = useState(_cachedCandidates === null);
//   const isFetchingRef = useRef(false);
//   const [searchTerm, setSearchTerm] = useState(_cachedSearchTerm);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [sortConfig, setSortConfig] = useState({ key: 'CreatedOn', direction: 'desc' });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(_cachedItemsPerPage);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [showColumnSidebar, setShowColumnSidebar] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [showFilterModal, setShowFilterModal] = useState(false);
//   const [advancedFilters, setAdvancedFilters] = useState({ rows: [], logic: 'AND' });
//   const [showAiSidebar, setShowAiSidebar] = useState(false);
//   const [uploadingResume, setUploadingResume] = useState(false);
//   const [useAiSearch, setUseAiSearch] = useState(_cachedUseAiSearch);
//   const [isAiSearching, setIsAiSearching] = useState(false);
//   const [aiSearchResults, setAiSearchResults] = useState(_cachedAiSearchResults);

//   // Parse Flow States
//   const [parsedResumeData, setParsedResumeData] = useState(null);
//   const [parsingFromToolbar, setParsingFromToolbar] = useState(false);
//   const [pendingParseFile, setPendingParseFile] = useState(null);
//   const [showConfirmParse, setShowConfirmParse] = useState(false);
//   const [showParsingLoading, setShowParsingLoading] = useState(false);
//   const [showDuplicateModal, setShowDuplicateModal] = useState(false);
//   const [duplicateCandidate, setDuplicateCandidate] = useState(null);
//   const [statusFilter, setStatusFilter] = useState(_cachedStatusFilter);
//   const [showFilterSidebar, setShowFilterSidebar] = useState(true);

//   // Sidebar Filter State
//   const [sidebarFilters, setSidebarFilters] = useState({
//     search: '',
//     status: [],
//     workType: [],
//     experience: 'all',
//     country: '',
//     state: '',
//     city: '',
//     sources: [],
//     employmentTypes: [],
//     industries: [],
//     isBench: 'all',
//     personType: 'all',
//     gender: [],
//     relocate: 'all',
//     workAuth: []
//   });

//   // Visible Sidebar Filters (Dynamic filter visibility)
//   const [visibleSidebarFilters, setVisibleSidebarFilters] = useState([
//     'CandidateStatus', 'PersonType', 'IsBench', 'RemoteStatus', 'Experience',
//     'Gender', 'Relocation', 'WorkAuthorization', 'EmploymentType', 'Industry', 'CurrentLocation'
//   ]);

//   // Sync top search TO sidebar search only once on mount or when searchTerm changes externally
//   useEffect(() => {
//     setSidebarFilters(prev => ({ ...prev, search: searchTerm }));
//   }, [searchTerm]);

//   // Auto-save active search filters
//   useEffect(() => {
//     _cachedSearchTerm = searchTerm;
//   }, [searchTerm]);

//   useEffect(() => {
//     _cachedStatusFilter = statusFilter;
//   }, [statusFilter]);

//   useEffect(() => {
//     _cachedAiSearchResults = aiSearchResults;
//   }, [aiSearchResults]);

//   useEffect(() => {
//     _cachedUseAiSearch = useAiSearch;
//   }, [useAiSearch]);

//   useEffect(() => {
//     _cachedItemsPerPage = itemsPerPage;
//   }, [itemsPerPage]);

//   // Share Resume State
//   const [showShareModal, setShowShareModal] = useState(false);
//   const [shareModalCandidates, setShareModalCandidates] = useState([]);
//   const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

//   // Schedule Interview State
//   const [showJobsModal, setShowJobsModal] = useState(false);
//   const [showScheduleModal, setShowScheduleModal] = useState(false);
//   const [scheduleCandidate, setScheduleCandidate] = useState(null);
//   const [selectedJobForInterview, setSelectedJobForInterview] = useState(null);

//   // Submit Profile State
//   const [showSubmitModal, setShowSubmitModal] = useState(false);
//   const [submitCandidate, setSubmitCandidate] = useState(null);

//   const parseFileInputRef = useRef(null);

//   // Saved Searches State
//   const [savedSearches, setSavedSearches] = useState([]);

//   useEffect(() => {
//     const saved = localStorage.getItem('erp_saved_searches');
//     if (saved) {
//       try {
//         setSavedSearches(JSON.parse(saved));
//       } catch (e) { }
//     }
//   }, []);

//   const handleSaveSearch = () => {
//     if (!searchTerm && statusFilter === 'all') return;

//     const exists = savedSearches.some(s => s.term === searchTerm && s.status === statusFilter);
//     if (exists) return;

//     const newSaved = [...savedSearches, { term: searchTerm, status: statusFilter, id: Date.now() }];
//     setSavedSearches(newSaved);
//     localStorage.setItem('erp_saved_searches', JSON.stringify(newSaved));

//     Swal.fire({
//       title: 'Search Saved!',
//       text: 'Your current search and filters have been saved.',
//       icon: 'success',
//       timer: 1500,
//       showConfirmButton: false
//     });
//   };

//   const handleLoadSearch = (search) => {
//     setSearchTerm(search.term);
//     setStatusFilter(search.status || 'all');
//     setCurrentPage(1);

//     if (useAiSearch && search.term) {
//       handleAiSearch(search.term);
//     } else {
//       setAiSearchResults(null);
//     }
//   };

//   const removeSavedSearch = (id) => {
//     const updated = savedSearches.filter(s => s.id !== id);
//     setSavedSearches(updated);
//     localStorage.setItem('erp_saved_searches', JSON.stringify(updated));
//   };

//   // ─── Column Configuration ────────────────────────────────────────────────
//   const availableColumns = [
//     { key: 'CandidateCode', label: 'Candidate ID' },
//     { key: 'EmployeeCode', label: 'Employee ID' },
//     { key: 'Candidate', label: 'Name' },
//     { key: 'Email', label: 'Email' },
//     { key: 'Phone', label: 'Phone' },
//     { key: 'Mobile', label: 'Mobile' },
//     { key: 'JobTitle', label: 'Job Title' },
//     { key: 'YearsOfExperience', label: 'Years of Exp.' },
//     { key: 'Skills', label: 'Skills' },
//     { key: 'CandidateStatus', label: 'Status' },
//     { key: 'RemoteStatus', label: 'Work Type' },
//     { key: 'CreatedDate', label: 'Created Date' },
//     { key: 'LinkedInUrl', label: 'LinkedIn URL' },
//     { key: 'GitHubUrl', label: 'GitHub URL' },
//     { key: 'CurrentLocation', label: 'Location' },
//     { key: 'Gender', label: 'Gender' },
//     { key: 'ProfileSummary', label: 'Profile Summary' },
//     { key: 'PersonType', label: 'Type' },
//     { key: 'IsBench', label: 'Bench Status' },
//     { key: 'Experience', label: 'Experience' },
//     { key: 'Relocation', label: 'Relocation' },
//     { key: 'Source', label: 'Source' },
//     { key: 'Actions', label: 'Actions' },
//   ];

//   const availableSidebarFilters = [
//     { key: 'CandidateStatus', label: 'Status' },
//     { key: 'PersonType', label: 'Type' },
//     { key: 'IsBench', label: 'Bench Status' },
//     { key: 'RemoteStatus', label: 'Work Type' },
//     { key: 'Experience', label: 'Experience' },
//     { key: 'Gender', label: 'Gender' },
//     { key: 'Relocation', label: 'Relocation' },
//     { key: 'CurrentLocation', label: 'Location' },
//     { key: 'Skills', label: 'Skills (Search)' },
//     { key: 'Email', label: 'Email (Search)' },
//     { key: 'Phone', label: 'Phone (Search)' },
//     { key: 'JobTitle', label: 'Job Title (Search)' },
//   ];

//   const [visibleColumns, setVisibleColumns] = useState([
//     'CandidateCode', 'EmployeeCode', 'Candidate', 'Email', 'Phone', 'JobTitle',
//     'YearsOfExperience', 'Skills', 'CandidateStatus', 'RemoteStatus', 'CreatedDate', 'Actions',
//   ]);

//   // ── Fetch candidate list ──────────────────────────────────────────────────
//   const fetchCandidates = useCallback(async (force = false) => {
//     if (_cachedCandidates && !force) {
//       setCandidates(_cachedCandidates);
//       setLoading(false);
//       return;
//     }
//     if (isFetchingRef.current) return;
//     isFetchingRef.current = true;
//     setLoading(true);

//     try {
//       const response = await fetch(`${BASE_URL}/api/resumes`, {
//         headers: getAuthHeaders(),
//       });
//       if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);

//       const raw = await response.json();
//       const data = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.data) ? raw.data
//           : Array.isArray(raw?.candidates) ? raw.candidates
//             : [];

//       const transformedCandidates = data.map(transformCandidate);

//       // De-duplicate by CandidateId
//       const uniqueItems = [];
//       const seenIds = new Set();
//       transformedCandidates.forEach(c => {
//         const id = String(c.CandidateId);
//         if (!seenIds.has(id)) {
//           seenIds.add(id);
//           uniqueItems.push(c);
//         }
//       });

//       _cachedCandidates = uniqueItems;
//       setCandidates(uniqueItems);

//     } catch (error) {
//       console.error('[ResumeDashboard] Error fetching candidates:', error);
//       Swal.fire({
//         title: 'Connection Error',
//         html: `<p>Could not load candidates from the server.</p>
//                <small style="color:#888">Make sure the backend server is running and reachable.</small>`,
//         icon: 'error',
//         confirmButtonText: 'OK',
//       });
//       setCandidates([]);
//     } finally {
//       isFetchingRef.current = false;
//       setLoading(false);
//     }
//   }, []);

//   const handleAiSearch = useCallback(async (query) => {
//     if (!query || !query.trim()) {
//       setAiSearchResults(null);
//       return;
//     }

//     setIsAiSearching(true);
//     try {
//       const countMatch = query.match(/(\d+)\s*(?:candidates|results|people)/i);
//       const requestedLimit = countMatch ? parseInt(countMatch[1]) : 50;

//       const response = await fetch(`${BASE_URL}/api/resumes/search`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           ...getAuthHeaders()
//         },
//         body: JSON.stringify({
//           query: query.trim(),
//           top_k: requestedLimit,
//           limit: requestedLimit,
//           size: requestedLimit
//         }),
//       });

//       if (!response.ok) throw new Error('AI Search failed');
//       const data = await response.json();

//       if (data && data.results) {
//         console.log(`🔍 AI Search returned ${data.results.length} results (Requested: ${requestedLimit})`);

//         const seenIds = new Set();
//         const mappedResults = data.results
//           .filter(res => {
//             const id = String(res.candidate_id);
//             if (seenIds.has(id)) return false;
//             seenIds.add(id);
//             return true;
//           })
//           .map(res => {
//             const localMatch = candidates.find(c => String(c.CandidateId) === String(res.candidate_id));

//             if (localMatch) {
//               return {
//                 ...localMatch,
//                 aiScore: res.score,
//                 aiRank: res.rank,
//                 matchReason: res.match_reason
//               };
//             }

//             return {
//               CandidateId: res.candidate_id,
//               FirstName: res.name?.split(' ')[0] || 'Unknown',
//               LastName: res.name?.split(' ').slice(1).join(' ') || '',
//               JobTitle: res.job_title || 'N/A',
//               YearsOfExperience: res.years_experience,
//               Skills: (res.skills || []).map(s => ({ SkillName: s, SkillType: 'HARD' })),
//               CandidateStatus: 'Available',
//               RemoteStatus: res.remote_status || 'OnSite',
//               Contact: {
//                 Email: '',
//                 Phone: '',
//                 Mobile: ''
//               },
//               matchReason: res.match_reason,
//               aiScore: res.score,
//               aiRank: res.rank
//             };
//           });

//         setAiSearchResults(mappedResults);
//         setCurrentPage(1);
//       }
//     } catch (error) {
//       console.error('AI Search Error:', error);
//       Swal.fire({
//         title: 'Search Error',
//         text: 'The AI search service is currently unavailable.',
//         icon: 'error',
//         timer: 2000,
//         showConfirmButton: false
//       });
//     } finally {
//       setIsAiSearching(false);
//     }
//   }, [candidates]);

//   // ── Debounced AI Search Flow ─────────────────────────────────────────────
//   useEffect(() => {
//     if (!useAiSearch || !searchTerm || !searchTerm.trim()) {
//       if (!searchTerm) {
//         setAiSearchResults(null);
//       }
//       // If we cleared the search, we stop searching
//       if (!searchTerm) setIsAiSearching(false);
//       return;
//     }

//     // Immediately indicate searching state to trigger animation
//     setIsAiSearching(true);

//     const timer = setTimeout(() => {
//       handleAiSearch(searchTerm);
//     }, 1200); // Slightly longer debounce for semantic analysis

//     return () => clearTimeout(timer);
//   }, [searchTerm, useAiSearch, handleAiSearch]);

//   // Reset search and filters when view changes
//   useEffect(() => {
//     setSearchTerm('');
//     setAiSearchResults(null);
//     setAdvancedFilters({ rows: [], logic: 'AND' });
//     setCurrentPage(1);
//     fetchCandidates(true);
//   }, [currentView, fetchCandidates]);

//   // ── Navigate to full candidate detail page ────────────────────────────
//   const viewCandidate = (id) => {
//     navigate(`/candidates/${id}`);
//   };

//   // ── Get field value from candidate ──
//   const getFieldValue = useCallback((candidate, field) => {
//     switch (field) {
//       case 'FirstName':
//         return formatFullName(candidate.FirstName, candidate.MiddleName, candidate.LastName);
//       case 'Email': return candidate.Contact?.Email || '';
//       case 'Phone': return candidate.Contact?.Phone || '';
//       case 'Skills':
//         return (candidate.Skills || []).map(s => s.SkillName || s).join(', ');
//       case 'YearsOfExperience': return candidate.YearsOfExperience != null ? String(candidate.YearsOfExperience) : '';
//       case 'CreatedDt': return candidate.CreatedDt || '';
//       default: {
//         const val = candidate[field];
//         return (val !== null && val !== undefined) ? String(val) : '';
//       }
//     }
//   }, []);

//   // ── Check if a candidate matches a single filter row ──
//   const matchesRow = useCallback((candidate, row) => {
//     const rawVal = getFieldValue(candidate, row.field);
//     const target = (row.value || '').trim();

//     if (row.condition === 'is_empty') return !rawVal || String(rawVal).trim() === '';
//     if (row.condition === 'is_not_empty') return rawVal && String(rawVal).trim() !== '';

//     const valStr = String(rawVal || '').trim();
//     const valLower = valStr.toLowerCase();
//     const targetLower = target.toLowerCase();

//     const numVal = parseFloat(valStr);
//     const numTarget = parseFloat(target);
//     const isNumericMatch = !isNaN(numVal) && !isNaN(numTarget) && isFinite(valStr) && isFinite(target);

//     const dateVal = new Date(valStr);
//     const dateTarget = new Date(target);
//     const isDateMatch = !isNaN(dateVal.getTime()) && !isNaN(dateTarget.getTime()) && valStr.includes('-') && target.includes('-');

//     switch (row.condition) {
//       case 'contains': return valLower.includes(targetLower);
//       case 'not_contains': return !valLower.includes(targetLower);
//       case 'equals':
//         if (isNumericMatch) return numVal === numTarget;
//         if (isDateMatch) {
//           const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
//           const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
//           return d1 === d2;
//         }
//         if (row.field === 'Skills') {
//           return valLower.split(',').map(s => s.trim()).includes(targetLower);
//         }
//         return valLower === targetLower;
//       case 'not_equals':
//         if (isNumericMatch) return numVal !== numTarget;
//         if (isDateMatch) {
//           const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
//           const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
//           return d1 !== d2;
//         }
//         if (row.field === 'Skills') {
//           return !valLower.split(',').map(s => s.trim()).includes(targetLower);
//         }
//         return valLower !== targetLower;
//       case 'starts_with': return valLower.startsWith(targetLower);
//       case 'ends_with': return valLower.endsWith(targetLower);
//       case 'greater_than':
//         if (isNumericMatch) return numVal > numTarget;
//         if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) > dateTarget.setHours(0, 0, 0, 0);
//         return valLower > targetLower;
//       case 'less_than':
//         if (isNumericMatch) return numVal < numTarget;
//         if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) < dateTarget.setHours(0, 0, 0, 0);
//         return valLower < targetLower;
//       default: return true;
//     }
//   }, [getFieldValue]);

//   // ── Derived filter options ─────────────────────────────────────────────
//   const availableStatuses = useMemo(() => {
//     return ['Available', 'In Process', 'Not Available', 'Hired'];
//   }, []);

//   const availableWorkTypes = useMemo(() => {
//     return ['Remote', 'OnSite', 'Hybrid'];
//   }, []);

//   const availableLocations = useMemo(() => {
//     const locs = [...new Set(candidates.map(c => {
//       if (c.CurrentLocation) {
//         const parts = c.CurrentLocation.split(',').map(p => p.trim());
//         if (parts.length >= 2) {
//           return parts.slice(-2).join(', ');
//         }
//         return parts[0];
//       }
//       return null;
//     }))].filter(Boolean);
//     return locs.sort();
//   }, [candidates]);

//   const availableSources = useMemo(() => {
//     const sources = [...new Set(candidates.map(c => c.Source))].filter(Boolean);
//     return sources.sort();
//   }, [candidates]);

//   const availableEmploymentTypes = useMemo(() => {
//     const types = [...new Set(candidates.map(c => c.EmploymentType))].filter(Boolean);
//     return types.sort();
//   }, [candidates]);

//   const availableIndustries = useMemo(() => {
//     const inds = [...new Set(candidates.map(c => c.Industry))].filter(Boolean);
//     return inds.sort();
//   }, [candidates]);

//   const availableWorkAuths = useMemo(() => {
//     const auths = [...new Set(candidates.map(c => c.WorkAuthorization))].filter(Boolean);
//     return auths.sort();
//   }, [candidates]);

//   const availableGenders = useMemo(() => {
//     const genders = [...new Set(candidates.map(c => c.Gender))].filter(Boolean);
//     return genders.sort();
//   }, [candidates]);

//   // ── Filter & Sort Logic ────────────────────────────────────────────────
//   const filteredCandidates = useMemo(() => {
//     // 1️⃣ Priority: If AI search was just performed, use those results as our working set
//     let result = aiSearchResults !== null ? [...aiSearchResults] : [...candidates];

//     // 2️⃣ Standard global search filtering - Skip if AI Search is active
//     if (aiSearchResults === null && searchTerm && !useAiSearch) {
//       const term = searchTerm.toLowerCase();
//       result = result.filter(c => {
//         const fullName = formatFullName(c.FirstName, c.MiddleName, c.LastName).toLowerCase();
//         const skillsText = (c.Skills || []).map(s => s.SkillName || s).join(' ').toLowerCase();
//         const exp = (c.YearsOfExperience !== undefined && c.YearsOfExperience !== null) ? c.YearsOfExperience : '';
//         const expText = exp !== '' ? `${exp}y ${exp} yr ${exp} year ${exp} years` : '';

//         const matchesName = fullName.includes(term);
//         const matchesJob = visibleSidebarFilters.includes('JobTitle') && (c.JobTitle || '').toLowerCase().includes(term);
//         const matchesCode = (c.CandidateCode || '').toLowerCase().includes(term);
//         const matchesEmail = visibleSidebarFilters.includes('Email') && (c.Contact?.Email || '').toLowerCase().includes(term);
//         const matchesPhone = visibleSidebarFilters.includes('Phone') && (
//           (c.Contact?.Phone || '').toLowerCase().includes(term) ||
//           (c.Contact?.Mobile || '').toLowerCase().includes(term)
//         );
//         const matchesSkills = visibleSidebarFilters.includes('Skills') && skillsText.includes(term);
//         const matchesExp = expText.toLowerCase().includes(term);

//         return matchesName || matchesJob || matchesCode || matchesEmail || matchesPhone || matchesSkills || matchesExp;
//       });
//     }

//     // 3️⃣ Sidebar-specific search filtering - Skip if AI Search is active
//     if (aiSearchResults === null && sidebarFilters.search) {
//       const term = sidebarFilters.search.toLowerCase();
//       result = result.filter(c => {
//         const fullName = formatFullName(c.FirstName, c.MiddleName, c.LastName).toLowerCase();
//         const skillsText = (c.Skills || []).map(s => s.SkillName || s).join(' ').toLowerCase();
//         const exp = (c.YearsOfExperience !== undefined && c.YearsOfExperience !== null) ? c.YearsOfExperience : '';
//         const expText = exp !== '' ? `${exp}y ${exp} yr ${exp} year ${exp} years` : '';

//         const matchesName = fullName.includes(term);
//         const matchesJob = visibleSidebarFilters.includes('JobTitle') && (c.JobTitle || '').toLowerCase().includes(term);
//         const matchesCode = (c.CandidateCode || '').toLowerCase().includes(term);
//         const matchesEmail = visibleSidebarFilters.includes('Email') && (c.Contact?.Email || '').toLowerCase().includes(term);
//         const matchesPhone = visibleSidebarFilters.includes('Phone') && (
//           (c.Contact?.Phone || '').toLowerCase().includes(term) ||
//           (c.Contact?.Mobile || '').toLowerCase().includes(term)
//         );
//         const matchesSkills = visibleSidebarFilters.includes('Skills') && skillsText.includes(term);
//         const matchesExp = expText.toLowerCase().includes(term);

//         return matchesName || matchesJob || matchesCode || matchesEmail || matchesPhone || matchesSkills || matchesExp;
//       });
//     }

//     // Status filter
//     if (statusFilter !== 'all') {
//       result = result.filter(c => {
//         if (statusFilter === 'On Bench') {
//           return c.IsBench === true || c.CandidateStatus === 'On Bench';
//         }
//         return (c.CandidateStatus || '').toLowerCase() === statusFilter.toLowerCase();
//       });
//     }

//     // Category filter based on 'view' query parameter - Skip strict sourcing/review checks if AI Search is active
//     if (aiSearchResults === null) {
//       if (currentView === 'sourcing') {
//         result = result.filter(c => {
//           const hasEmail = (c.Contact?.Email || '').trim();
//           const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
//           const allowBench = sidebarFilters.isBench === 'bench';
//           return (allowBench || !c.IsBench) && hasEmail && hasPhone;
//         });
//       } else if (currentView === 'bench') {
//         result = result.filter(c => c.IsBench === true);
//       } else if (currentView === 'review') {
//         result = result.filter(c => {
//           const hasEmail = (c.Contact?.Email || '').trim();
//           const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
//           return !hasEmail || !hasPhone;
//         });
//       }
//     }

//     // Sidebar Filters Logic
//     if ((sidebarFilters.status || []).length > 0) {
//       const selected = sidebarFilters.status.map(s => s.toLowerCase());
//       result = result.filter(c => selected.includes((c.CandidateStatus || '').toLowerCase()));
//     }
//     if ((sidebarFilters.workType || []).length > 0) {
//       const selected = sidebarFilters.workType.map(w => w.toLowerCase());
//       result = result.filter(c => selected.includes((c.RemoteStatus || '').toLowerCase()));
//     }

//     // Advanced location filtering with Country/State/City support
//     if (sidebarFilters.country) {
//       const selectedCountryName = sidebarFilters.country;
//       const selectedCountryCode = getCountryCode(selectedCountryName);

//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(selectedCountryName.toLowerCase()) ||
//           locLower.includes(selectedCountryCode.toLowerCase());
//       });
//     }

//     if (sidebarFilters.state) {
//       const selectedStateName = sidebarFilters.state;
//       const countryCode = getCountryCode(sidebarFilters.country);
//       const selectedStateCode = getStateCode(countryCode, selectedStateName);

//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(selectedStateName.toLowerCase()) ||
//           locLower.includes(selectedStateCode.toLowerCase());
//       });
//     }

//     if (sidebarFilters.city) {
//       const cityTerm = sidebarFilters.city.toLowerCase().trim();
//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(cityTerm);
//       });
//     }

//     if ((sidebarFilters.workAuth || []).length > 0) {
//       const selected = sidebarFilters.workAuth.map(a => a.toLowerCase());
//       result = result.filter(c => selected.includes((c.WorkAuthorization || '').toLowerCase()));
//     }

//     if ((sidebarFilters.employmentTypes || []).length > 0) {
//       const selected = sidebarFilters.employmentTypes.map(t => t.toLowerCase());
//       result = result.filter(c => selected.includes((c.EmploymentType || '').toLowerCase()));
//     }

//     if ((sidebarFilters.industries || []).length > 0) {
//       const selected = sidebarFilters.industries.map(i => i.toLowerCase());
//       result = result.filter(c => selected.includes((c.Industry || '').toLowerCase()));
//     }

//     if ((sidebarFilters.sources || []).length > 0) {
//       const selected = sidebarFilters.sources.map(s => s.toLowerCase());
//       result = result.filter(c => selected.includes((c.Source || '').toLowerCase()));
//     }

//     if ((sidebarFilters.gender || []).length > 0) {
//       const selected = sidebarFilters.gender.map(g => g.toLowerCase());
//       result = result.filter(c => selected.includes((c.Gender || '').toLowerCase()));
//     }

//     if (sidebarFilters.isBench && sidebarFilters.isBench !== 'all') {
//       result = result.filter(c => sidebarFilters.isBench === 'bench' ? c.IsBench : !c.IsBench);
//     }

//     if (sidebarFilters.personType && sidebarFilters.personType !== 'all') {
//       result = result.filter(c => sidebarFilters.personType === 'employees' ? c.IsEmployee : !c.IsEmployee);
//     }

//     if (sidebarFilters.relocate && sidebarFilters.relocate !== 'all') {
//       result = result.filter(c => sidebarFilters.relocate === 'yes' ? c.WillingToRelocate : !c.WillingToRelocate);
//     }

//     if (sidebarFilters.experience !== 'all') {
//       switch (sidebarFilters.experience) {
//         case '0-2': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) <= 2); break;
//         case '3-5': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 2 && e <= 5; }); break;
//         case '5-10': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 5 && e <= 10; }); break;
//         case '10+': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) > 10); break;
//         default: break;
//       }
//     }

//     // Advanced filters
//     const validRows = (advancedFilters.rows || []).filter(r => r.field && r.condition);
//     if (validRows.length > 0) {
//       result = result.filter(c => {
//         let isMatch = matchesRow(c, validRows[0]);

//         for (let i = 1; i < validRows.length; i++) {
//           const row = validRows[i];
//           const op = row.operator || 'AND';

//           if (op === 'OR') {
//             isMatch = isMatch || matchesRow(c, row);
//           } else {
//             isMatch = isMatch && matchesRow(c, row);
//           }
//         }
//         return isMatch;
//       });
//     }

//     // Standard sorting
//     result.sort((a, b) => {
//       let av, bv;
//       if (sortConfig.key === 'CreatedDt') {
//         av = new Date(a.CreatedDt || 0); bv = new Date(b.CreatedDt || 0);
//       } else if (sortConfig.key === 'YearsOfExperience') {
//         av = a.YearsOfExperience || 0; bv = b.YearsOfExperience || 0;
//       } else if (sortConfig.key === 'Email') {
//         av = (a.Email || '').toLowerCase();
//         bv = (b.Email || '').toLowerCase();
//       } else if (sortConfig.key === 'FirstName') {
//         av = formatFullName(a.FirstName, a.MiddleName, a.LastName).toLowerCase();
//         bv = formatFullName(b.FirstName, b.MiddleName, b.LastName).toLowerCase();
//       } else {
//         av = String(a[sortConfig.key] || '').toLowerCase();
//         bv = String(b[sortConfig.key] || '').toLowerCase();
//       }
//       if (av < bv) return sortConfig.direction === 'asc' ? -1 : 1;
//       if (av > bv) return sortConfig.direction === 'asc' ? 1 : -1;
//       return 0;
//     });

//     return result;
//   }, [candidates, searchTerm, statusFilter, advancedFilters, sortConfig, aiSearchResults, matchesRow, currentView, sidebarFilters, visibleSidebarFilters, useAiSearch]);

//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);
//   const paginatedCandidates = filteredCandidates.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleResetFilters = () => {
//     setSearchTerm('');
//     setAiSearchResults(null);
//     setAdvancedFilters({ rows: [], logic: 'AND' });
//     setSortConfig({ key: 'CreatedDt', direction: 'desc' });
//     setStatusFilter('all');
//     setSidebarFilters({
//       search: '',
//       status: [],
//       workType: [],
//       experience: 'all',
//       country: '',
//       state: '',
//       city: '',
//       sources: [],
//       employmentTypes: [],
//       industries: [],
//       isBench: 'all',
//       personType: 'all',
//       gender: [],
//       relocate: 'all',
//       workAuth: []
//     });
//   };

//   const handleApplyFilters = (filters) => {
//     setAdvancedFilters(filters);
//     setCurrentPage(1);
//   };

//   const requestSort = (key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//     }));
//     setCurrentPage(1);
//   };

//   const editCandidate = (candidate) => {
//     setEditingCandidate(candidate);
//     setParsedResumeData(null);
//     setShowAddModal(true);
//   };

//   const getFullCandidate = async (id) => {
//     const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
//       headers: getAuthHeaders(),
//     });
//     if (!response.ok) throw new Error('Failed to fetch details');
//     const data = await response.json();
//     return transformCandidate(data);
//   };

//   const deleteCandidate = async (id) => {
//     const candidate = candidates.find(c => c.CandidateId === id);
//     const name = formatFullName(candidate?.FirstName, candidate?.MiddleName, candidate?.LastName);

//     const confirm = await Swal.fire({
//       title: 'Delete Candidate?',
//       text: `This will permanently delete ${name}'s record.`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#ef4444',
//       cancelButtonColor: '#6b7280',
//       confirmButtonText: 'Yes, delete',
//     });

//     if (confirm.isConfirmed) {
//       try {
//         const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
//           method: 'DELETE',
//           headers: getAuthHeaders(),
//         });
//         if (!response.ok) throw new Error('Failed to delete candidate');
//         setCandidates(prev => prev.filter(c => c.CandidateId !== id));
//         Swal.fire({ title: 'Deleted!', text: `${name} has been removed.`, icon: 'success', timer: 1800, showConfirmButton: false });
//       } catch (error) {
//         console.error('Error deleting candidate:', error);
//         Swal.fire({ title: 'Error', text: 'Failed to delete candidate', icon: 'error' });
//       }
//     }
//   };

//   // ── Parse Resume Flow ──────────────────────────────────────────────────
//   const handleParseFileSelect = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     e.target.value = '';
//     setPendingParseFile(file);
//     setShowConfirmParse(true);
//   };

//   const handleConfirmParse = async () => {
//     if (!pendingParseFile) return;
//     setShowConfirmParse(false);
//     setShowParsingLoading(true);
//     setParsingFromToolbar(true);

//     try {
//       const formData = new FormData();
//       formData.append('file1', pendingParseFile);

//       const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formData
//       });
//       if (!response.ok) throw new Error('Failed to parse resume');

//       const data = await response.json();
//       const parsed = {
//         FirstName: formatName(data.firstName || ''),
//         LastName: formatName(data.lastName || ''),
//         MiddleName: formatName(data.middleName || ''),
//         Email: data.email || '',
//         Phone: data.phone || '',
//         Mobile: data.mobile || '',
//         TwitterUrl: data.twitterUrl || '',
//         VideoResumeUrl: data.videoResumeUrl || '',
//         JobTitle: formatJobTitle(data.jobTitle || ''),
//         YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
//         ProfileSummary: data.profileSummary || '',
//         LinkedInUrl: data.linkedInUrl || '',
//         GitHubUrl: data.gitHubUrl || '',
//         Gender: data.gender || '',
//         CurrentLocation: data.currentLocation || '',
//         cityName: data.cityName || '',
//         stateName: data.stateName || '',
//         countryIso2: data.countryIso2 || '',
//         countryName: data.countryName || '',
//         WorkAuthorization: data.workAuthorization || '',
//         EmploymentType: data.employmentType || '',
//         skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
//         workExperience: (data.workExperience || []).map(exp => ({
//           Company: exp.company || '',
//           JobTitle: formatJobTitle(exp.jobTitle || ''),
//           StartDate: exp.startDate || '', EndDate: exp.endDate || '',
//           IsCurrent: exp.isCurrent || false, Description: exp.description || '',
//         })),
//         education: (data.education || []).map(edu => ({
//           Institution: formatName(edu.institution || ''),
//           Degree: formatName(edu.degree || ''),
//           FieldOfStudy: edu.fieldOfStudy || '', StartDate: edu.startDate || '',
//           EndDate: edu.endDate || '', GPA: edu.gpa || '',
//         })),
//         certifications: (data.certifications || []).map(cert => ({
//           CertificationName: formatName(cert.name || ''),
//           IssuingOrganization: cert.issuingOrg || '',
//           IssueDate: cert.issueDate || '', ExpiryDate: cert.expiryDate || '',
//           CredentialId: cert.credentialId || '', CredentialUrl: cert.credentialUrl || '',
//         })),
//         ResumeFile: pendingParseFile,
//         RawPayloadJson: JSON.stringify(data),
//         ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
//         ParsedText: data.parsedText || data.parsed_text || '',
//         ParserVendor: data.vendor || 'llama-3.1-8b-instant',
//         ExtractedEmail: data.email || data.extracted_email || '',
//         ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
//       };

//       const dup = candidates.find(c =>
//         (parsed.Email && c.Contact?.Email?.toLowerCase() === parsed.Email.toLowerCase()) ||
//         (parsed.LinkedInUrl && c.LinkedInUrl?.toLowerCase() === parsed.LinkedInUrl.toLowerCase())
//       );

//       setShowParsingLoading(false);

//       if (dup) {
//         setParsedResumeData(parsed);
//         setDuplicateCandidate(dup);
//         setShowDuplicateModal(true);
//       } else {
//         setParsedResumeData(parsed);
//         setEditingCandidate(null);
//         setShowAddModal(true);
//       }

//     } catch (error) {
//       console.error('Error parsing resume:', error);
//       setShowParsingLoading(false);
//       Swal.fire({ title: 'Error', text: 'Failed to parse resume. Please try again or add candidate manually.', icon: 'error' });
//     } finally {
//       setParsingFromToolbar(false);
//       setPendingParseFile(null);
//     }
//   };

//   const handleDuplicateAction = async (action) => {
//     setShowDuplicateModal(false);

//     if (action === 'cancel') {
//       setParsedResumeData(null);
//       setDuplicateCandidate(null);
//       return;
//     }

//     let fullDuplicateCandidate = duplicateCandidate;
//     try {
//       Swal.fire({ title: 'Loading...', text: 'Fetching candidate details', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//       const response = await fetch(`${BASE_URL}/api/resumes/${duplicateCandidate.CandidateId}`, { headers: getAuthHeaders() });
//       if (response.ok) {
//         const data = await response.json();
//         fullDuplicateCandidate = transformCandidate(data);
//       }
//       Swal.close();
//     } catch (e) {
//       console.error('Error fetching duplicate candidate full details:', e);
//       Swal.close();
//     }

//     if (action === 'add_resume') {
//       setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
//       setEditingCandidate(fullDuplicateCandidate);
//       setShowAddModal(true);
//     }
//     else if (action === 'overwrite') {
//       setEditingCandidate({
//         CandidateId: fullDuplicateCandidate.CandidateId,
//         Document: fullDuplicateCandidate.Document,
//         Contact: { Email: fullDuplicateCandidate.Contact?.Email }
//       });
//       setShowAddModal(true);
//     }
//     else if (action === 'append') {
//       const synthCandidate = { ...fullDuplicateCandidate };

//       for (const [key, value] of Object.entries(parsedResumeData)) {
//         if (typeof value === 'string' && value.trim() !== '') {
//           synthCandidate[key] = value;
//         } else if (typeof value === 'number') {
//           synthCandidate[key] = value;
//         }
//       }

//       const appendedSkills = [...(fullDuplicateCandidate.Skills || [])];
//       (parsedResumeData.skills || []).forEach(s => appendedSkills.push({ ...s }));
//       synthCandidate.Skills = appendedSkills;

//       synthCandidate.WorkExperience = [...(fullDuplicateCandidate.WorkExperience || []), ...(parsedResumeData.workExperience || [])];
//       synthCandidate.Education = [...(fullDuplicateCandidate.Education || []), ...(parsedResumeData.education || [])];
//       synthCandidate.Certifications = [...(fullDuplicateCandidate.Certifications || []), ...(parsedResumeData.certifications || [])];

//       setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
//       setEditingCandidate(synthCandidate);
//       setShowAddModal(true);
//     }
//   };

//   // ── Resume upload / extract ──
//   const handleResumeUpload = async (file) => {
//     try {
//       setUploadingResume(true);
//       const formData = new FormData();
//       formData.append('file1', file);

//       const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formData
//       });
//       if (!response.ok) throw new Error('Failed to parse resume');

//       const data = await response.json();
//       return {
//         FirstName: formatName(data.firstName || ''),
//         LastName: formatName(data.lastName || ''),
//         MiddleName: formatName(data.middleName || ''),
//         Email: data.email || '',
//         Phone: data.phone || '',
//         Mobile: data.mobile || '',
//         TwitterUrl: data.twitterUrl || '',
//         VideoResumeUrl: data.videoResumeUrl || '',
//         JobTitle: formatJobTitle(data.jobTitle || ''),
//         YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
//         ProfileSummary: data.profileSummary || '',
//         LinkedInUrl: data.linkedInUrl || '',
//         GitHubUrl: data.gitHubUrl || '',
//         Gender: data.gender || '',
//         CurrentLocation: data.currentLocation || '',
//         cityName: data.cityName || '',
//         stateName: data.stateName || '',
//         countryIso2: data.countryIso2 || '',
//         countryName: data.countryName || '',
//         WorkAuthorization: data.workAuthorization || '',
//         EmploymentType: data.employmentType || '',
//         Skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
//         WorkExperience: (data.workExperience || []).map(exp => ({
//           Company: exp.company || '',
//           JobTitle: formatJobTitle(exp.jobTitle || ''),
//           StartDate: exp.startDate || '',
//           EndDate: exp.endDate || '',
//           IsCurrent: exp.isCurrent || false,
//           Description: exp.description || '',
//         })),
//         Education: (data.education || []).map(edu => ({
//           Institution: formatName(edu.institution || ''),
//           Degree: formatName(edu.degree || ''),
//           FieldOfStudy: edu.fieldOfStudy || '',
//           StartDate: edu.startDate || '',
//           EndDate: edu.endDate || '',
//           GPA: edu.gpa || '',
//         })),
//         Certifications: (data.certifications || []).map(cert => ({
//           CertificationName: formatName(cert.name || ''),
//           IssuingOrganization: cert.issuingOrg || '',
//           IssueDate: cert.issueDate || '',
//           ExpiryDate: cert.expiryDate || '',
//           CredentialId: cert.credentialId || '',
//           CredentialUrl: cert.credentialUrl || '',
//         })),
//         RawPayloadJson: JSON.stringify(data),
//         ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
//         ParsedText: data.parsedText || data.parsed_text || '',
//         ParserVendor: data.vendor || 'llama-3.1-8b-instant',
//         ExtractedEmail: data.email || data.extracted_email || '',
//         ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
//       };
//     } catch (error) {
//       console.error('Error parsing resume:', error);
//       Swal.fire({ title: 'Error', text: 'Failed to parse resume. Please fill the form manually.', icon: 'error' });
//       return null;
//     } finally {
//       setUploadingResume(false);
//     }
//   };

//   // ── Save candidate ──
//   const handleSaveCandidate = async (data) => {
//     try {
//       setUploadingResume(true);

//       if (data.currentLocation && data.currentLocation.trim()) {
//         const parts = data.currentLocation.split(',').map(s => s.trim()).filter(Boolean);
//         console.log(`📍 Location being saved: "${data.currentLocation}" (${parts.length} parts)`);
//       }

//       const isEditing = !!(editingCandidate?.CandidateId || data.candidateId);
//       const candidateId = editingCandidate?.CandidateId || data.candidateId;

//       const formData = new FormData();

//       const firstName = formatName(data.firstName || data.FirstName || '');
//       const lastName = formatName(data.lastName || data.LastName || '');
//       const middleName = formatName(data.middleName || data.MiddleName || '');
//       const jobTitle = formatJobTitle(data.jobTitle || data.JobTitle || '');

//       formData.append('FirstName', firstName);
//       formData.append('LastName', lastName);
//       formData.append('MiddleName', middleName);
//       formData.append('EmailID', (data.email || data.Email || '').trim());
//       formData.append('Phone', (data.phone || data.Phone || '').trim());
//       formData.append('Mobile', (data.mobile || data.Mobile || '').trim());
//       formData.append('JobTitle', jobTitle);
//       formData.append('YearsOfExperience', data.yearsOfExperience ?? data.YearsOfExperience ?? '');
//       formData.append('Gender', (data.gender || data.Gender || '').trim());
//       formData.append('ProfileSummary', (data.profileSummary || data.ProfileSummary || '').trim());
//       formData.append('LinkedInProfile', (data.linkedInUrl || data.LinkedInUrl || '').trim());
//       formData.append('GitHubUrl', (data.gitHubUrl || data.GitHubUrl || '').trim());
//       formData.append('TwitterUrl', (data.twitterUrl || data.TwitterUrl || '').trim());
//       formData.append('VideoResumeUrl', (data.videoResumeUrl || data.VideoResumeUrl || '').trim());
//       formData.append('CandidateStatus', data.candidateStatus || data.CandidateStatus || 'Available');
//       formData.append('RemoteStatus', data.remoteStatus || data.RemoteStatus || 'OnSite');
//       formData.append('CurrentLocation', (data.currentLocation || data.CurrentLocation || '').trim());

//       formData.append('WorkAuthorization', data.workAuthorization || data.WorkAuthorization || '');
//       formData.append('EmploymentType', data.employmentType || data.EmploymentType || '');
//       formData.append('SecurityClearance', data.securityClearance || data.SecurityClearance || '');
//       formData.append('WillingToRelocate', data.willingToRelocate ? 'true' : 'false');
//       formData.append('IsBench', data.isBench ? 'true' : 'false');
//       formData.append('ExpectedRateFrom', data.expectedRateFrom || data.ExpectedRateFrom || '');
//       formData.append('ExpectedRateTo', data.expectedRateTo || data.ExpectedRateTo || '');
//       formData.append('ExpectedRateType', data.expectedRateType || data.ExpectedRateType || 'Hourly');
//       formData.append('CurrentRate', data.currentRate || data.CurrentRate || '');
//       formData.append('CurrentRateType', data.currentRateType || data.CurrentRateType || 'Hourly');
//       formData.append('MaritalStatus', data.maritalStatus || data.MaritalStatus || '');
//       formData.append('Industry', data.industry || data.Industry || '');

//       const skillsList = (data.skills || data.Skills || []).map(s =>
//         typeof s === 'string' ? s : (s.SkillName || s.skillName || '')
//       ).filter(Boolean);
//       formData.append('Skills', JSON.stringify(skillsList));

//       const workList = (data.workExperience || data.WorkExperience || [])
//         .filter(w => (w.company || w.Company || '').trim() || (w.jobTitle || w.JobTitle || '').trim())
//         .map(exp => ({
//           Company: (exp.company || exp.Company || '').trim(),
//           JobTitle: formatJobTitle(exp.jobTitle || exp.JobTitle || ''),
//           StartDate: exp.startDate || exp.StartDate || '',
//           EndDate: exp.endDate || exp.EndDate || '',
//           IsCurrent: exp.isCurrent ?? exp.IsCurrent ?? false,
//           Description: (exp.description || exp.Description || '').trim(),
//         }));
//       formData.append('WorkExperience', JSON.stringify(workList));

//       const eduList = (data.education || data.Education || [])
//         .filter(e => (e.institution || e.Institution || '').trim() || (e.degree || e.Degree || '').trim())
//         .map(edu => ({
//           Institution: formatName(edu.institution || edu.Institution || ''),
//           Degree: formatName(edu.degree || edu.Degree || ''),
//           FieldOfStudy: (edu.fieldOfStudy || edu.FieldOfStudy || '').trim(),
//           StartDate: edu.startDate || edu.StartDate || '',
//           EndDate: edu.endDate || edu.EndDate || '',
//           GPA: (edu.gpa || edu.GPA || '').trim(),
//         }));
//       formData.append('Education', JSON.stringify(eduList));

//       const certList = (data.certifications || data.Certifications || [])
//         .filter(c => (c.name || c.CertificationName || '').trim())
//         .map(cert => ({
//           CertificationName: formatName(cert.name || cert.CertificationName || ''),
//           IssuingOrganization: (cert.issuingOrg || cert.IssuingOrganization || '').trim(),
//           IssueDate: cert.issueDate || cert.IssueDate || '',
//           ExpiryDate: cert.expiryDate || cert.ExpiryDate || '',
//           CredentialId: (cert.credentialId || cert.CredentialId || '').trim(),
//           CredentialUrl: (cert.credentialUrl || cert.CredentialUrl || '').trim(),
//         }));
//       formData.append('Certifications', JSON.stringify(certList));

//       if (data.ResumeFile) {
//         formData.append('ResumeUpload', data.ResumeFile);
//       }

//       if (data.RawPayloadJson) formData.append('RawPayloadJson', data.RawPayloadJson);
//       if (data.ParseStatus) formData.append('ParseStatus', data.ParseStatus);
//       if (data.ParsedText) formData.append('ParsedText', data.ParsedText);
//       if (data.ParserVendor) formData.append('ParserVendor', data.ParserVendor);
//       if (data.ExtractedEmail) formData.append('ExtractedEmail', data.ExtractedEmail);
//       if (data.ExtractedPhone) formData.append('ExtractedPhone', data.ExtractedPhone);

//       const additionalDocs = (data.documents || []).filter(d => d.file instanceof File);
//       let docIndex = 0;
//       for (const doc of additionalDocs) {
//         formData.append(`AdditionalDoc_${docIndex}`, doc.file);
//         formData.append(`AdditionalDoc_${docIndex}_Name`, doc.documentName || doc.file.name);
//         formData.append(`AdditionalDoc_${docIndex}_Type`, doc.documentType || 'Certificate');
//         docIndex++;
//       }
//       formData.append('AdditionalDocsCount', String(docIndex));

//       const url = isEditing
//         ? `${BASE_URL}/api/resumes/${candidateId}`
//         : `${BASE_URL}/api/resumes`;

//       const response = await fetch(url, {
//         method: isEditing ? 'PUT' : 'POST',
//         headers: getAuthHeaders(),
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.error || errorData.detail || 'Failed to save candidate');
//       }

//       _cachedCandidates = null;
//       await fetchCandidates(true);
//       setShowAddModal(false);
//       setEditingCandidate(null);
//       setParsedResumeData(null);
//       Swal.fire({ title: 'Success!', text: 'Candidate saved successfully.', icon: 'success', timer: 1800, showConfirmButton: false });

//     } catch (error) {
//       console.error('Error saving candidate:', error);
//       Swal.fire({ title: 'Error', text: error.message || 'Failed to save candidate', icon: 'error' });
//     } finally {
//       setUploadingResume(false);
//     }
//   };

//   const exportToExcel = () => {
//     setExporting(true);
//     const data = filteredCandidates.map(c => ({
//       'Candidate Code': c.CandidateCode,
//       'First Name': c.FirstName,
//       'Last Name': c.LastName,
//       'Middle Name': c.MiddleName || '',
//       'Job Title': c.JobTitle,
//       'Email': c.Contact?.Email || '',
//       'Phone': c.Contact?.Phone || '',
//       'Mobile': c.Mobile || '',
//       'Twitter URL': c.TwitterUrl || '',
//       'Video Resume URL': c.VideoResumeUrl || '',
//       'Years of Experience': c.YearsOfExperience,
//       'Gender': c.Gender,
//       'Candidate Status': c.CandidateStatus,
//       'Remote Status': c.RemoteStatus,
//       'Work Authorization': c.WorkAuthorization || '',
//       'Employment Type': c.EmploymentType || '',
//       'Security Clearance': c.SecurityClearance || '',
//       'Willing to Relocate': c.WillingToRelocate ? 'Yes' : 'No',
//       'Expected Rate From': c.ExpectedRateFrom || '',
//       'Expected Rate To': c.ExpectedRateTo || '',
//       'Expected Rate Type': c.ExpectedRateType || '',
//       'Current Rate': c.CurrentRate || '',
//       'Current Rate Type': c.CurrentRateType || '',
//       'Marital Status': c.MaritalStatus || '',
//       'Industry': c.Industry || '',
//       'LinkedIn': c.LinkedInUrl || '',
//       'GitHub': c.GitHubUrl || '',
//       'Location': c.CurrentLocation || '',
//       'Profile Summary': c.ProfileSummary || '',
//       'Skills': (c.Skills || []).map(s => s.SkillName || s).join(', '),
//       'Resume File': c.Document?.FileNameOriginal || '',
//       'Created Date': formatDate(c.CreatedDt),
//     }));
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Candidates');
//     XLSX.writeFile(wb, `candidates_${new Date().toISOString().split('T')[0]}.xlsx`);
//     setExporting(false);
//     Swal.fire({ title: 'Exported!', text: `${data.length} candidates exported.`, icon: 'success', timer: 1800, showConfirmButton: false });
//   };

//   if (loading) {
//     return (
//       <div className="cm-loading-container">
//         <div className="cm-loading-spinner"></div>
//         <p className="cm-loading-text">Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="cm-dashboard" style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: '24px' }}>
//       {/* Header Area */}
//       <div style={{ padding: '16px 32px 12px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px' }}>
//         <div>
//           <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#111827', margin: 0, lineHeight: 1.2 }}>
//             {currentView === 'sourcing' ? 'Sourcing' :
//               currentView === 'bench' ? 'Bench Candidates' :
//                 currentView === 'review' ? 'Need To Review' :
//                   'Candidates'}
//           </h1>
//           <p style={{ color: '#6b7280', fontSize: '14px', margin: '4px 0 0 0' }}>
//             {currentView === 'sourcing' ? 'Explore active sourcing candidates' :
//               currentView === 'bench' ? 'Manage bench candidates' :
//                 currentView === 'review' ? 'Review candidates with missing information' :
//                   'Manage and explore your candidate database'}
//           </p>
//         </div>

//         <div className="cm-toolbar-actions" style={{ flexWrap: 'wrap', borderBottom: 'none' }}>
//           {selectedCandidateIds.length > 0 && (
//             <button
//               className="cm-btn cm-btn-primary"
//               style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd', marginRight: '8px' }}
//               onClick={() => {
//                 const selectedCands = candidates.filter(c => selectedCandidateIds.includes(c.CandidateId));
//                 setShareModalCandidates(selectedCands);
//                 setShowShareModal(true);
//               }}
//             >
//               <Share2 size={16} /> Share Bulk Profile
//             </button>
//           )}

//           <button className="cm-btn cm-btn-primary" style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd' }} onClick={() => { setEditingCandidate(null); setParsedResumeData(null); setShowAddModal(true); }}>
//             <Plus size={16} /> Add Candidate
//           </button>
//           <button
//             className="cm-btn cm-btn-outline"
//             onClick={() => parseFileInputRef.current?.click()}
//             disabled={parsingFromToolbar}
//           >
//             {parsingFromToolbar
//               ? <><Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> Parsing...</>
//               : <><Upload size={16} /> Parse Resume</>}
//           </button>
//           <input
//             ref={parseFileInputRef}
//             type="file"
//             accept=".pdf,.doc,.docx,.txt"
//             style={{ display: 'none' }}
//             onChange={handleParseFileSelect}
//           />
//           <button className="cm-btn cm-btn-outline" onClick={exportToExcel} disabled={exporting}>
//             <Download size={16} /> {exporting ? 'Exporting...' : 'Export'}
//           </button>

//           <button className="cm-btn cm-btn-outline" title="Manage Columns" onClick={() => setShowColumnSidebar(true)} style={{ padding: '0 10px' }}>
//             <SlidersHorizontal size={16} />
//           </button>

//           <button
//             className={`cm-btn cm-btn-outline ${showFilterSidebar ? 'cm-btn-icon--active' : ''}`}
//             title={showFilterSidebar ? "Close Sidebar" : "Open Sidebar"}
//             onClick={() => setShowFilterSidebar(prev => !prev)}
//             style={{ padding: '0 10px' }}
//           >
//             {showFilterSidebar ? <PanelLeftClose size={16} /> : <PanelLeftOpen size={16} />}
//           </button>

//           <button
//             className={`cm-btn cm-btn-outline ${advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? 'cm-btn-icon--active' : ''}`}
//             title="Filters"
//             onClick={() => setShowFilterModal(true)}
//             style={{
//               padding: '0 10px', ...(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? {
//                 background: '#eff6ff', border: '1px solid #60a5fa', color: '#3b5bfd'
//               } : {})
//             }}
//           >
//             <Filter size={16} />
//             {advancedFilters.rows.filter(r => r.field && r.condition).length > 0 && (
//               <span style={{
//                 position: 'absolute', top: -4, right: -4,
//                 width: 16, height: 16, borderRadius: '50%',
//                 background: '#3b5bfd', color: '#fff',
//                 fontSize: 9, fontWeight: 800,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//               }}>
//                 {advancedFilters.rows.filter(r => r.field && r.condition).length}
//               </span>
//             )}
//           </button>

//           <button
//             className={`cm-ask-ai-btn ${showAiSidebar ? 'cm-ask-ai-btn--active' : ''}`}
//             title="Ask AI"
//             onClick={() => setShowAiSidebar(prev => !prev)}
//             style={{ marginLeft: '4px' }}
//           >
//             <Sparkles size={15} />
//             Ask AI
//           </button>
//         </div>
//       </div>

//       {/* Search & Saved Filters Area */}
//       <div style={{ margin: '0 32px 12px 32px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

//         {/* Top Row: Search Input */}
//         <div
//           className="cm-modern-search-bar"
//           style={{
//             display: 'flex', alignItems: 'center',
//             border: '1px solid #e2e8f0', borderRadius: '8px',
//             padding: '4px 8px 4px 16px', height: '40px',
//             transition: 'all 0.2s ease', background: '#fff',
//             boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
//           }}
//           onFocus={(e) => { e.currentTarget.style.borderColor = '#3b5bfd'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 91, 253, 0.15)'; }}
//           onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.02)'; }}
//         >
//           <div style={{ position: 'relative', display: 'flex', alignItems: 'center', marginRight: '10px', flexShrink: 0 }}>
//             <Search
//               size={17}
//               color={useAiSearch ? "#3b5bfd" : "#64748b"}
//               className={isAiSearching ? "cm-pulse" : ""}
//               style={{ cursor: 'pointer' }}
//               onClick={() => {
//                 if (useAiSearch) {
//                   handleAiSearch(searchTerm);
//                 } else {
//                   setAiSearchResults(null);
//                   setCurrentPage(1);
//                 }
//               }}
//               title={useAiSearch ? "Search with AI" : "Search by keyword"}
//             />
//             <Sparkles
//               size={8}
//               color="#3b5bfd"
//               style={{
//                 position: 'absolute', top: -3, right: -4,
//                 animation: 'cm-spin 4s linear infinite',
//                 opacity: 0.8
//               }}
//             />
//           </div>
//           <input
//             className="cm-search-input-modern"
//             placeholder={useAiSearch ? "Ask AI for semantic search..." : "Search by keyword..."}
//             value={searchTerm}
//             onChange={e => {
//               const val = e.target.value;
//               setSearchTerm(val);
//               if (!useAiSearch) {
//                 if (!val) setAiSearchResults(null);
//                 setCurrentPage(1);
//               }
//             }}
//             onKeyDown={e => {
//               if (e.key === 'Enter') {
//                 if (useAiSearch) {
//                   // Manual trigger if user hits enter early
//                   handleAiSearch(searchTerm);
//                 } else {
//                   setAiSearchResults(null);
//                   setCurrentPage(1);
//                 }
//               }
//             }}
//             style={{
//               border: 'none', outline: 'none', background: 'transparent',
//               flex: 1, fontSize: '14px', color: '#0f172a', height: '100%',
//               fontFamily: 'inherit'
//             }}
//           />
//           {isAiSearching && (
//             <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//               <Loader size={14} style={{ animation: 'cm-spin 1s linear infinite', color: '#3b5bfd' }} />
//             </div>
//           )}
//           <div style={{ width: '1px', height: '20px', background: '#e2e8f0', margin: '0 8px' }}></div>
//           <button
//             onClick={() => {
//               const next = !useAiSearch;
//               setUseAiSearch(next);
//               if (!next) setAiSearchResults(null);
//             }}
//             style={{
//               display: 'flex', alignItems: 'center', gap: '6px',
//               padding: '4px 12px', border: useAiSearch ? '1px solid #60a5fa' : '1px solid #e2e8f0',
//               borderRadius: '20px', background: useAiSearch ? '#eff6ff' : '#fff',
//               color: useAiSearch ? '#3b5bfd' : '#64748b', fontSize: '12px',
//               fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease',
//               marginRight: '8px'
//             }}
//           >
//             <Sparkles size={13} color={useAiSearch ? "#60a5fa" : "#94a3b8"} fill={useAiSearch ? "#60a5fa" : "none"} />
//             AI Search: {useAiSearch ? 'ON' : 'OFF'}
//           </button>
//           <button
//             onClick={handleSaveSearch}
//             className="cm-btn"
//             style={{
//               height: '28px', background: '#f8fafc', color: '#475569',
//               border: '1px solid transparent', borderRadius: '6px',
//               padding: '0 12px', fontWeight: 500, display: 'flex',
//               gap: '6px', alignItems: 'center', transition: 'all 0.2s',
//               flexShrink: 0, fontSize: '12.5px'
//             }}
//             onMouseOver={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#0f172a'; }}
//             onMouseOut={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#475569'; }}
//           >
//             <Bookmark size={14} /> Save
//           </button>
//         </div>

//         {/* Bottom Area: Saved Searches */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
//           <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none', flexShrink: 1, paddingBottom: '2px' }}>
//             {savedSearches.map((s) => {
//               const isActive = s.term === searchTerm && s.status === statusFilter;
//               return (
//                 <button
//                   key={s.id}
//                   onClick={() => handleLoadSearch(s)}
//                   style={{
//                     fontSize: '12.5px',
//                     padding: '0 8px 0 10px',
//                     height: '26px',
//                     borderRadius: '6px',
//                     border: '1px solid transparent',
//                     background: isActive ? '#3b5bfd' : '#f1f5f9',
//                     color: isActive ? '#fff' : '#475569',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '6px',
//                     whiteSpace: 'nowrap',
//                     transition: 'all 0.2s ease',
//                     fontWeight: isActive ? 500 : 400,
//                     flexShrink: 0
//                   }}
//                   title={`Load search: ${s.term || 'All'} in ${s.status}`}
//                   onMouseOver={(e) => { if (!isActive) { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; } }}
//                   onMouseOut={(e) => { if (!isActive) { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#475569'; } }}
//                 >
//                   <span>{s.term || 'All'} {s.status !== 'all' ? `(${s.status})` : ''}</span>
//                   <span
//                     onClick={(e) => { e.stopPropagation(); removeSavedSearch(s.id); }}
//                     style={{
//                       display: 'flex', alignItems: 'center', justifyContent: 'center',
//                       width: '18px', height: '18px', borderRadius: '4px', transition: 'all 0.2s',
//                       color: isActive ? '#fff' : '#94a3b8'
//                     }}
//                     onMouseOver={(e) => { e.currentTarget.style.background = isActive ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.05)'; e.currentTarget.style.color = isActive ? '#fff' : '#0f172a'; }}
//                     onMouseOut={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = isActive ? '#fff' : '#94a3b8'; }}
//                   >
//                     <X size={13} />
//                   </span>
//                 </button>
//               );
//             })}
//           </div>

//           {savedSearches.length > 0 && (
//             <button
//               onClick={() => { setSavedSearches([]); localStorage.removeItem('erp_saved_searches'); }}
//               style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '12px', color: '#cbd5e1', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', transition: 'color 0.2s', padding: 0 }}
//               onMouseOver={(e) => e.currentTarget.style.color = '#ef4444'}
//               onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
//             >
//               Clear
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Main Content Layout */}
//       <div style={{ display: 'flex', borderTop: '1px solid #e2e8f0', minHeight: 'calc(100vh - 180px)' }}>
//         {/* Left Sidebar Filter */}
//         {showFilterSidebar ? (
//           <CandidateFilterSidebar
//             totalCount={filteredCandidates.length}
//             overallTotal={candidates.length}
//             filters={sidebarFilters}
//             setFilters={setSidebarFilters}
//             onClearAll={handleResetFilters}
//             availableStatuses={availableStatuses}
//             availableWorkTypes={availableWorkTypes}
//             availableLocations={availableLocations}
//             availableSources={availableSources}
//             availableEmploymentTypes={availableEmploymentTypes}
//             availableIndustries={availableIndustries}
//             availableWorkAuths={availableWorkAuths}
//             availableGenders={availableGenders}
//             onClose={() => setShowFilterSidebar(false)}
//             visibleColumns={visibleSidebarFilters}
//             setVisibleColumns={setVisibleSidebarFilters}
//           />
//         ) : (
//           <div
//             className="cm-sidebar-reopen-strip"
//             onClick={() => setShowFilterSidebar(true)}
//             title="Open Filters"
//             style={{
//               width: '12px',
//               background: '#f1f5f9',
//               borderRight: '1px solid #e2e8f0',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               transition: 'all 0.2s ease',
//               position: 'relative',
//               zIndex: 10
//             }}
//             onMouseOver={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.width = '20px'; }}
//             onMouseOut={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.width = '12px'; }}
//           >
//             <div style={{
//               transform: 'rotate(90deg)',
//               whiteSpace: 'nowrap',
//               fontSize: '10px',
//               fontWeight: 700,
//               color: '#64748b',
//               letterSpacing: '0.1em',
//               textTransform: 'uppercase'
//             }}>
//               Filters
//             </div>
//           </div>
//         )}

//         {/* Right Content Area */}
//         <div style={{ flex: 1, minWidth: 0, padding: '0 0 24px 0' }}>
//           {/* AI Search Active Indicator */}
//           {aiSearchResults && (
//             <div style={{
//               padding: '10px 32px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px',
//               background: '#eff6ff',
//               borderBottom: '1px solid #bfdbfe',
//               animation: 'cm-slide-down 0.3s ease'
//             }}>
//               <Sparkles size={16} color="#3b5bfd" className="cm-pulse" />
//               <span style={{ fontSize: '13px', color: '#3b5bfd', fontWeight: 600 }}>
//                 AI-Powered Search Active
//               </span>
//               <span style={{ fontSize: '12.5px', color: '#475569' }}>
//                 — {aiSearchResults.length} candidates ranked by semantic relevance
//               </span>
//               <button
//                 onClick={() => { setAiSearchResults(null); setSearchTerm(''); }}
//                 style={{
//                   marginLeft: 'auto',
//                   background: '#fff',
//                   border: '1px solid #3b5bfd',
//                   color: '#3b5bfd',
//                   borderRadius: '6px',
//                   padding: '4px 12px',
//                   fontSize: '11.5px',
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                   transition: 'all 0.2s',
//                   boxShadow: '0 1px 2px rgba(59, 91, 253, 0.1)'
//                 }}
//                 onMouseOver={(e) => { e.currentTarget.style.background = '#3b5bfd'; e.currentTarget.style.color = '#fff'; }}
//                 onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#3b5bfd'; }}
//               >
//                 Clear AI Search
//               </button>
//             </div>
//           )}

//           {/* Active Filters Indicator */}
//           {(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ||
//             (sidebarFilters.status || []).length > 0 ||
//             (sidebarFilters.workType || []).length > 0 ||
//             sidebarFilters.country ||
//             sidebarFilters.state ||
//             sidebarFilters.city ||
//             (sidebarFilters.sources || []).length > 0 ||
//             (sidebarFilters.experience && sidebarFilters.experience !== 'all') ||
//             (sidebarFilters.isBench && sidebarFilters.isBench !== 'all') ||
//             (sidebarFilters.gender || []).length > 0 ||
//             (sidebarFilters.workAuth || []).length > 0 ||
//             (sidebarFilters.relocate && sidebarFilters.relocate !== 'all')) && (
//               <div style={{
//                 display: 'flex', alignItems: 'center', gap: 12,
//                 padding: '10px 32px', background: '#f8fafc',
//                 borderBottom: '1px solid #e2e8f0', fontSize: 13,
//                 flexWrap: 'wrap'
//               }}>
//                 <span style={{ fontWeight: 600, color: '#475569', display: 'flex', alignItems: 'center', gap: 4 }}>
//                   <Filter size={14} /> Active Filters:
//                 </span>

//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
//                   {(sidebarFilters.status || []).map(s => (
//                     <span key={s} style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{s}</span>
//                   ))}
//                   {(sidebarFilters.workType || []).map(w => (
//                     <span key={w} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{w}</span>
//                   ))}
//                   {sidebarFilters.country && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Country: {sidebarFilters.country}</span>
//                   )}
//                   {sidebarFilters.state && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>State: {sidebarFilters.state}</span>
//                   )}
//                   {sidebarFilters.city && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>City: {sidebarFilters.city}</span>
//                   )}
//                   {(sidebarFilters.workAuth || []).map(auth => (
//                     <span key={auth} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Auth: {auth}</span>
//                   ))}
//                   {(sidebarFilters.employmentTypes || []).map(type => (
//                     <span key={type} style={{ background: '#ecfdf5', color: '#065f46', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{type}</span>
//                   ))}
//                   {(sidebarFilters.industries || []).map(ind => (
//                     <span key={ind} style={{ background: '#f8fafc', color: '#475569', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{ind}</span>
//                   ))}
//                   {sidebarFilters.experience && sidebarFilters.experience !== 'all' && (
//                     <span style={{ background: '#f3e8ff', color: '#6b21a8', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Exp: {sidebarFilters.experience}</span>
//                   )}
//                   {sidebarFilters.isBench && sidebarFilters.isBench !== 'all' && (
//                     <span style={{ background: '#ffedd5', color: '#9a3412', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{sidebarFilters.isBench === 'bench' ? 'Bench Only' : 'Non-Bench'}</span>
//                   )}
//                 </div>

//                 <button
//                   onClick={handleResetFilters}
//                   style={{
//                     marginLeft: 'auto', background: 'none', border: 'none',
//                     color: '#ef4444', fontSize: 12, fontWeight: 600, cursor: 'pointer',
//                     display: 'flex', alignItems: 'center', gap: 4
//                   }}
//                 >
//                   Clear All
//                 </button>
//               </div>
//             )}

//           {/* Table or AI Loading */}
//           {isAiSearching ? (
//             <div className="cm-ai-search-loading">
//               <div className="cm-ai-search-loading-icon-wrapper">
//                 <Sparkles size={48} color="#3b5bfd" fill="#3b5bfd" className="cm-ai-loading-sparkles" />
//               </div>
//               <h2 className="cm-ai-search-loading-title">AI Is analyzing your database...</h2>
//               <p className="cm-ai-search-loading-subtitle">Finding the best matches based on semantic relevance</p>
//               <div className="cm-ai-search-loading-progress-container">
//                 <div className="cm-ai-search-loading-progress-bar"></div>
//               </div>
//             </div>
//           ) : (
//             <CandidateTable
//               candidates={paginatedCandidates}
//               isAiSearching={isAiSearching}
//               visibleColumns={visibleColumns}
//               sortConfig={sortConfig}
//               onSort={requestSort}
//               onView={viewCandidate}
//               onEdit={editCandidate}
//               onShare={(candidate) => {
//                 setShareModalCandidates([candidate]);
//                 setShowShareModal(true);
//               }}
//               onSchedule={(candidate) => {
//                 setScheduleCandidate(candidate);
//                 setShowJobsModal(true);
//               }}
//               onSubmitProfile={(candidate) => {
//                 setSubmitCandidate(candidate);
//                 setShowSubmitModal(true);
//               }}
//               onDelete={deleteCandidate}
//               currentPage={currentPage}
//               totalPages={totalPages}
//               totalCount={filteredCandidates.length}
//               onPageChange={setCurrentPage}
//               itemsPerPage={itemsPerPage}
//               onItemsPerPageChange={(newVal) => {
//                 setItemsPerPage(newVal);
//                 setCurrentPage(1);
//               }}
//               selectedRows={selectedCandidateIds}
//               onSelectionChange={setSelectedCandidateIds}
//             />
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       <ShareResumeModal
//         isOpen={showShareModal}
//         onClose={() => { setShowShareModal(false); setShareModalCandidates([]); }}
//         candidates={shareModalCandidates}
//       />

//       <CandidateJobsModal
//         isOpen={showJobsModal}
//         onClose={() => { setShowJobsModal(false); setScheduleCandidate(null); }}
//         candidate={scheduleCandidate}
//         onSelectJob={(job) => {
//           setSelectedJobForInterview(job);
//           setShowJobsModal(false);
//           setShowScheduleModal(true);
//         }}
//       />

//       <ScheduleInterviewModal
//         isOpen={showScheduleModal}
//         onClose={() => { setShowScheduleModal(false); setScheduleCandidate(null); setSelectedJobForInterview(null); }}
//         candidate={scheduleCandidate}
//         job={selectedJobForInterview}
//       />

//       <SubmitProfileModal
//         isOpen={showSubmitModal}
//         onClose={() => { setShowSubmitModal(false); setSubmitCandidate(null); }}
//         candidate={submitCandidate}
//       />

//       {showAddModal && (
//         <AddModal
//           candidate={editingCandidate}
//           onClose={() => { setShowAddModal(false); setEditingCandidate(null); setParsedResumeData(null); }}
//           onSave={handleSaveCandidate}
//           onResumeUpload={handleResumeUpload}
//           uploading={uploadingResume}
//           parsedData={parsedResumeData}
//           fetchFullCandidateDetails={getFullCandidate}
//         />
//       )}

//       <FilterModal
//         isOpen={showFilterModal}
//         onClose={() => setShowFilterModal(false)}
//         onApply={handleApplyFilters}
//         initialFilters={advancedFilters}
//       />

//       <ConfirmParseModal
//         isOpen={showConfirmParse}
//         onConfirm={handleConfirmParse}
//         onCancel={() => { setShowConfirmParse(false); setPendingParseFile(null); }}
//       />

//       <ParsingLoadingModal
//         isOpen={showParsingLoading}
//       />

//       <DuplicateResumeModal
//         isOpen={showDuplicateModal}
//         duplicateCandidate={duplicateCandidate}
//         onProceed={handleDuplicateAction}
//         onCancel={() => handleDuplicateAction('cancel')}
//       />

//       <ColumnFilterSidebar
//         availableColumns={availableColumns}
//         selectedColumns={visibleColumns}
//         setSelectedColumns={setVisibleColumns}
//         availableFilters={availableSidebarFilters}
//         selectedFilters={visibleSidebarFilters}
//         setSelectedFilters={setVisibleSidebarFilters}
//         onClose={() => setShowColumnSidebar(false)}
//         isOpen={showColumnSidebar}
//       />

//       {showAiSidebar && (
//         <div className="cm-ai-overlay" onClick={() => setShowAiSidebar(false)} />
//       )}
//       <AskAiSidebar
//         isOpen={showAiSidebar}
//         onClose={() => setShowAiSidebar(false)}
//         candidates={candidates}
//       />
//     </div>
//   );
// };

// export default ResumeDashboard;



import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { Plus, Download, SlidersHorizontal, Filter, Search, Upload, Loader, Share2, Sparkles, Heart, X, Bookmark, Trash2, PanelLeftClose, PanelLeftOpen, Send, Globe, UserCheck, Users, RotateCcw, Briefcase } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CANDIDATE_STATUS_OPTIONS, REMOTE_STATUS_OPTIONS, DATE_OPTIONS, formatDate,
  WORK_AUTHORIZATION_OPTIONS, EMPLOYMENT_TYPE_OPTIONS, SECURITY_CLEARANCE_OPTIONS,
  RATE_TYPE_OPTIONS, MARITAL_STATUS_OPTIONS, INDUSTRY_OPTIONS
} from '../utils/mockData';
import CandidateTable from './CandidateTable';
import AddModal from './AddModal';
import FilterModal from './FilterModal';
import ShareResumeModal from './ShareResumeModal';
import { CandidateJobsModal, ScheduleInterviewModal } from './ScheduleInterviewModals';
import { SubmitProfileModal } from './SubmitProfileModal';
import { ConfirmParseModal, ParsingLoadingModal, DuplicateResumeModal } from './ParseFlowModals';
import ColumnFilterSidebar from './ColumnFilterSidebar';
import CandidateFilterSidebar from './CandidateFilterSidebar';
import AskAiSidebar from './AskAiSidebar';
import '../styles/Dashboard.css';
import '../styles/CandidateTableCustom.css';
import '../styles/AddModalCustom.css';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import BASE_URL, { RESUME_PARSER_URL } from "../../url";
import { formatName, formatJobTitle, formatNameFields, formatFullName } from '../utils/nameFormatter';
import {
  countriesData,
  stateMapping,
  getCountryCode,
  getStateCode
} from '../../erprecruitment/config/locationConfig';
import { parseBooleanQuery, matchCandidateWithBooleanQuery } from '../utils/booleanSearchParser';

// Build a flat map of state name <-> code aliases for smart location search
const buildLocationAliases = (query) => {
  const q = query.toLowerCase().trim();
  const aliases = new Set([q]);
  Object.values(stateMapping).forEach(states => {
    Object.entries(states).forEach(([name, code]) => {
      const nameLower = name.toLowerCase();
      const codeLower = code.toLowerCase();
      if (nameLower === q) aliases.add(codeLower);
      if (codeLower === q) aliases.add(nameLower);
    });
  });
  // Also check country aliases
  countriesData.forEach(c => {
    if (c.name.toLowerCase() === q) aliases.add(c.code.toLowerCase());
    if (c.code.toLowerCase() === q) aliases.add(c.name.toLowerCase());
  });
  return Array.from(aliases);
};

// Match location using word boundaries so "india" does NOT match "indiana"
const locationMatchesQuery = (location, aliases, originalQuery = '') => {
  return aliases.some(alias => {
    // Special collision check: India vs Indiana ("IN")
    // If the matched alias is "in" but the location is in the US (has "us", "usa", "united states")
    // Then "in" means Indiana. If the user originally typed "india", they don't want Indiana.
    if (alias === 'in' && originalQuery === 'india') {
      if (/\b(us|usa|united states)\b/i.test(location)) {
        return false; // Skip this alias match, because "IN" here means Indiana, USA.
      }
    }

    // Use word boundary regex: \b ensures "india" doesn't match inside "indiana"
    try {
      const regex = new RegExp(`\\b${alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
      return regex.test(location);
    } catch {
      return location.includes(alias);
    }
  });
};

// Active Team Pod members only (Onsite & Offshore)
const DEFAULT_POD_MEMBERS = [
  'Abinesh Anbazhagan',
  'Ajay Anandhan',
  'Arun Bansal',
  'Arun S',
  'Ashok Raj',
  'Avneesh Shukla',
  'Devakar Balachandran',
  'Dhivya Thangavel',
  'Hariharan Gowthaman',
  'Hariharan Moorthy',
  'Hariharan Murugesan',
  'Hemalatha Moorthy',
  'Janani Anbu',
  'Jayasakthi Amirthalingam',
  'Jelin K',
  'Kaavya Kalamegam',
  'Kanishkar L',
  'Karunakaran Palani',
  'Lavanya Ganesan',
  'Lavanya S',
  'Monica Baskar',
  'Nandhini Raman',
  'Padmaja Anand',
  'Pragadeeshwaran karthikeyan',
  'Raj Kumar',
  'Rishikumar Nadarajan',
  'Rohinth Chelladurai',
  'Sneha Balaguru',
  'Somanaath Vijay',
  'Srija Sridhar',
  'Suganya Murugesan',
  'Surya Prashanth Sugumar',
  'Vibitha Shanmugavel'
];

// ─── Helper to get auth headers ──────────────────────────────────────────────
const getActiveCompanyId = () => {
  try {
    if (typeof window !== 'undefined' && window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const urlComp = params.get('company') || params.get('tenant');
      if (urlComp) return urlComp.toLowerCase().trim();
    }
    const c1 = localStorage.getItem('company_id');
    if (c1 && c1 !== 'undefined' && c1 !== 'null') return c1.toLowerCase().trim();
    const c2 = localStorage.getItem('saas_company_id');
    if (c2 && c2 !== 'undefined' && c2 !== 'null') return c2.toLowerCase().trim();
    const u = localStorage.getItem('user');
    if (u) {
      const p = JSON.parse(u);
      if (p?.company_id) return p.company_id.toLowerCase().trim();
    }
  } catch (e) {}
  return 'prophecy';
};

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const companyId = getActiveCompanyId();
  return {
    'Authorization': `Bearer ${token}`,
    'x-company-id': companyId,
  };
};

// ─── Module-level cache so multiple mounts don't re-fetch (Tenant Isolated) ────
// Cache version guard: automatically discard stale cache when tenant changes or version bumps
const CACHE_VERSION = 'v7-clean-slate';
if (localStorage.getItem('cm_cache_version') !== CACHE_VERSION || localStorage.getItem('cm_cached_company') !== getActiveCompanyId()) {
  localStorage.removeItem('cm_cached_candidates');
  localStorage.removeItem('cm_cached_bench_candidates');
  localStorage.setItem('cm_cache_version', CACHE_VERSION);
  localStorage.setItem('cm_cached_company', getActiveCompanyId());
}

let _cachedCompanyId = getActiveCompanyId();
let _cachedCandidates = (() => {
  try {
    if (localStorage.getItem('cm_cached_company') !== getActiveCompanyId()) return null;
    const saved = localStorage.getItem('cm_cached_candidates');
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
})();
let _cachedBenchCandidates = (() => {
  try {
    if (localStorage.getItem('cm_cached_company') !== getActiveCompanyId()) return null;
    const saved = localStorage.getItem('cm_cached_bench_candidates');
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
})();
let _cachedSearchTerm = (() => { const v = sessionStorage.getItem('cm_searchTerm'); return v !== null ? v : ''; })();
let _cachedJobTitleSearch = (() => { const v = sessionStorage.getItem('cm_jobTitleSearch'); return v !== null ? v : ''; })();
let _cachedJobTitleTags = (() => { try { const v = sessionStorage.getItem('cm_jobTitleTags'); return v ? JSON.parse(v) : []; } catch { return []; } })();
let _cachedStatusFilter = (() => { const v = sessionStorage.getItem('cm_statusFilter'); return v !== null ? v : 'all'; })();
let _cachedAiSearchResults = null;
let _cachedUseAiSearch = false;
let _cachedItemsPerPage = (() => { const v = sessionStorage.getItem('cm_itemsPerPage'); return v !== null ? Number(v) : 30; })();
let _cachedSidebarFilters = (() => { try { const v = sessionStorage.getItem('cm_sidebarFilters'); return v ? JSON.parse(v) : null; } catch { return null; } })();
let _cachedView = null;
// ──────────────────────────────────────────────────────────────────────────────

const formatToMonth = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return typeof dateStr === 'string' && dateStr.length >= 7 ? dateStr.substring(0, 7) : dateStr;
  return d.toISOString().substring(0, 7);
};

const normalizeWorkAuth = (auth) => {
  if (!auth || !String(auth).trim()) return 'Other';
  const a = String(auth).trim();
  const lower = a.toLowerCase();
  if (lower === 'h1b' || lower === 'h1-b' || lower === 'h1-b visa' || lower === 'h-1b') return 'H1B';
  if (lower === 'gc' || lower === 'green card') return 'Green Card';
  if (lower === 'citizen' || lower === 'us citizen' || lower === 'usc' || lower === 'us citizenship') return 'US Citizen';
  if (lower === 'opt' || lower === 'cpt' || lower === 'opt/cpt' || lower === 'opt-cpt' || lower === 'opt / cpt') return 'OPT/CPT';
  if (lower === 'h4' || lower === 'h4 ead' || lower === 'h4-ead') return 'H4 EAD';
  if (lower === 'l2' || lower === 'l2 ead' || lower === 'l2-ead') return 'L2 EAD';
  if (lower === 'tn' || lower === 'tn visa' || lower === 'tn-1') return 'TN Visa';
  if (lower === 'unknown' || lower === 'n/a' || lower === 'none' || lower === 'null') return 'Other';
  return a;
};

// ── Transform a raw API candidate object into the shape the UI needs ──────────
const transformCandidate = (candidate) => {
  const isEmployee = !!candidate.employee_id;
  const empId = candidate.employee_id || '';

  return {
    CandidateId: candidate.candidate_id,
    CandidateCode: candidate.candidate_code || `CAN-${String(candidate.candidate_id).padStart(6, '0')}`,
    EmployeeCode: empId,
    IsEmployee: isEmployee,
    FirstName: formatName(candidate.first_name || ''),
    LastName: formatName(candidate.last_name || ''),
    MiddleName: formatName(candidate.middle_name || ''),
    JobTitle: formatJobTitle(candidate.job_title || ''),
    YearsOfExperience: candidate.years_exp,
    CandidateStatus: candidate.status || 'Available',
    RemoteStatus: candidate.remote_status || 'OnSite',
    CreatedDt: candidate.created_on,
    ProfileSummary: candidate.profile_summary || '',
    LinkedInUrl: candidate.linkedin_url || '',
    GitHubUrl: candidate.github_url || '',
    TwitterUrl: candidate.twitter_url || '',
    VideoResumeUrl: candidate.video_resume_url || '',
    Gender: candidate.gender || '',
    CurrentLocation: candidate.current_location || '',
    Source: candidate.source || '',
    SourceType: candidate.source_type || candidate.SourceType || 'recruiter',

    // NEW FIELDS from backend
    WorkAuthorization: normalizeWorkAuth(candidate.work_authorization),
    SecurityClearance: candidate.security_clearance || '',
    WillingToRelocate: candidate.willing_to_relocate || false,
    IsBench: candidate.is_bench || false,
    EmploymentType: candidate.employment_type || '',
    ExpectedRateFrom: candidate.expected_rate_from || '',
    ExpectedRateTo: candidate.expected_rate_to || '',
    ExpectedRateType: candidate.expected_rate_type || 'Hourly',
    CurrentRate: candidate.current_rate || '',
    CurrentRateType: candidate.current_rate_type || 'Hourly',
    MaritalStatus: candidate.marital_status || '',
    Industry: candidate.industry || '',
    CurrentEmployer: candidate.current_employer || '',
    CurrentSalary: candidate.current_salary || '',
    ExpectedSalary: candidate.expected_salary || '',
    NoticePeriod: candidate.notice_period || '',
    Mobile: candidate.mobile || '',
    SubmittedByRecruiter: candidate.submitted_by_recruiters || '',

    // Bench Fields
    BenchPriority: candidate.bench_profile?.PriorityCode || candidate.PriorityCode || candidate.BenchPriority || '',
    OutOfJobSince: candidate.bench_profile?.OutOfJobSince || candidate.OutOfJobSince || candidate.BenchOutOfJobSince || '',
    NewJobDeadline: candidate.bench_profile?.NewJobDeadline || candidate.NewJobDeadline || candidate.BenchNewJobDeadline || '',
    WorkAuthPetitioner: candidate.bench_profile?.WorkAuthPetitioner || candidate.WorkAuthPetitioner || candidate.BenchWorkAuthPetitioner || '',
    WorkAuthExpiryDate: candidate.bench_profile?.WorkAuthExpiryDate || candidate.WorkAuthExpiryDate || candidate.BenchWorkAuthExpiryDate || '',
    BenchAssignees: (candidate.bench_assignees && candidate.bench_assignees.length > 0)
      ? candidate.bench_assignees.map(a => typeof a === 'string' ? a : (a.UserName || a.name || ''))
      : (Array.isArray(candidate.BenchAssignees) ? candidate.BenchAssignees : (candidate.BenchAssignee || candidate.PrimaryAssignee ? [candidate.BenchAssignee || candidate.PrimaryAssignee] : [])),
    BenchAssignee: (candidate.bench_assignees && candidate.bench_assignees[0]?.UserName) || candidate.BenchAssignee || candidate.PrimaryAssignee || '',
    DaysOnBench: (() => {
      const outDate = candidate.bench_profile?.OutOfJobSince || candidate.OutOfJobSince || candidate.BenchOutOfJobSince || candidate.created_on;
      if (outDate) {
        const d = new Date(outDate);
        if (!isNaN(d.getTime())) {
          return Math.max(0, Math.floor((new Date() - d) / (1000 * 60 * 60 * 24)));
        }
      }
      return 0;
    })(),

    Contact: {
      Email: candidate.email || '',
      Phone: candidate.phone || '',
      Mobile: candidate.mobile || '',
    },
    Phones: candidate.phones || [],
    Emails: candidate.emails || [],
    Skills: (candidate.skills || []).map(s =>
      typeof s === 'string'
        ? { SkillName: s, SkillType: 'HARD' }
        : { SkillName: s.skill_name || s.SkillName || '', SkillType: s.skill_type || s.SkillType || 'HARD' }
    ),
    Education: (candidate.education || []).map(e => ({
      Institution: formatName(e.Institution || e.institution || ''),
      Degree: formatName(e.Degree || e.degree || ''),
      FieldOfStudy: e.FieldOfStudy || e.fieldOfStudy || '',
      StartDate: formatToMonth(e.StartDate || e.startDate),
      EndDate: formatToMonth(e.EndDate || e.endDate),
      GPA: e.GPA || e.gpa || '',
    })),
    WorkExperience: (candidate.work_experience || []).map(w => ({
      Company: w.Company || w.company || '',
      JobTitle: formatJobTitle(w.JobTitle || w.jobTitle || ''),
      StartDate: formatToMonth(w.StartDate || w.startDate),
      EndDate: formatToMonth(w.EndDate || w.endDate),
      IsCurrent: w.IsCurrent ?? w.isCurrent ?? false,
      Description: w.Description || w.description || '',
    })),
    Certifications: (candidate.certifications || []).map(c => ({
      CertificationName: formatName(c.CertificationName || c.name || ''),
      IssuingOrganization: c.IssuingOrganization || c.issuingOrg || '',
      IssueDate: formatToMonth(c.IssueDate || c.issueDate),
      ExpiryDate: formatToMonth(c.ExpiryDate || c.expiryDate),
      CredentialId: c.CredentialId || c.credentialId || '',
      CredentialUrl: c.CredentialUrl || c.credentialUrl || '',
    })),
    Document: candidate.document ? {
      DocumentId: candidate.document.DocumentId,
      FileNameOriginal: candidate.document.FileNameOriginal,
      FileExtension: candidate.document.FileExtension,
      MimeType: candidate.document.MimeType,
      FileSizeBytes: candidate.document.FileSizeBytes,
      StorageLocator: candidate.document.StorageLocator,
      ParseStatus: candidate.document.ParseStatus,
      DownloadUrl: candidate.document.DownloadUrl,
    } : null,
    Documents: (candidate.documents || []).map(d => ({
      DocumentId: d.DocumentId || d.documentId,
      DocumentType: d.DocumentType || d.documentType || 'Certificate',
      DocumentName: d.FileNameOriginal ? d.FileNameOriginal.replace(/\.[^/.]+$/, "") : (d.DocumentName || ''),
      FileNameOriginal: d.FileNameOriginal || d.fileNameOriginal,
      FileExtension: d.FileExtension || d.fileExtension,
      MimeType: d.MimeType || d.mimeType,
      FileSizeBytes: d.FileSizeBytes || d.fileSizeBytes,
      StorageLocator: d.StorageLocator || d.storageLocator,
      ParseStatus: d.ParseStatus || d.parseStatus,
      DownloadUrl: d.DownloadUrl || d.downloadUrl,
      UploadedOn: d.UploadedOn || d.uploadedOn || d.uploaded_on || d.UploadedDate || d.created_at || d.CreatedAtUtc,
      VersionNo: d.VersionNo || d.versionNo,
      IsPrimary: d.IsPrimary || d.isPrimary,
    })),
  };
};

// ── Transform bench candidate object from /api/bench-manage/candidates ──────────
const transformBenchCandidate = (c) => {
  const daysOnBench = c.DaysOnBench !== undefined ? c.DaysOnBench : (() => {
    const outDate = c.OutOfJobSince || c.CreatedAtUtc;
    if (outDate) {
      const d = new Date(outDate);
      if (!isNaN(d.getTime())) {
        return Math.max(0, Math.floor((new Date() - d) / (1000 * 60 * 60 * 24)));
      }
    }
    return 0;
  })();

  return {
    CandidateId: c.CandidateId || c.candidate_id,
    CandidateCode: c.CandidateCode || c.candidate_code || `CAN-${String(c.CandidateId || c.candidate_id).padStart(6, '0')}`,
    EmployeeCode: c.EmployeeCode || '',
    IsEmployee: false,
    FirstName: formatName(c.FirstName || c.first_name || ''),
    LastName: formatName(c.LastName || c.last_name || ''),
    MiddleName: formatName(c.MiddleName || c.middle_name || ''),
    JobTitle: formatJobTitle(c.JobTitle || c.job_title || ''),
    YearsOfExperience: c.YearsOfExperience || c.years_exp,
    CandidateStatus: c.CandidateStatus || c.status || 'Available',
    RemoteStatus: c.RemoteStatus || c.remote_status || 'OnSite',
    CreatedDt: c.CreatedAtUtc || c.created_on,
    ProfileSummary: c.ProfileSummary || '',
    LinkedInUrl: c.LinkedInUrl || '',
    GitHubUrl: c.GitHubUrl || '',
    TwitterUrl: c.TwitterUrl || '',
    VideoResumeUrl: c.VideoResumeUrl || '',
    Gender: c.Gender || '',
    CurrentLocation: c.CurrentLocation || '',
    Source: c.Source || '',
    SourceType: c.SourceType || c.source_type || 'recruiter',

    WorkAuthorization: normalizeWorkAuth(c.WorkAuthorization || c.work_authorization),
    SecurityClearance: c.SecurityClearance || '',
    WillingToRelocate: c.WillingToRelocate || false,
    IsBench: true,
    EmploymentType: c.EmploymentType || c.employment_type || '',
    ExpectedRateFrom: c.ExpectedRateFrom || '',
    ExpectedRateTo: c.ExpectedRateTo || '',
    ExpectedRateType: c.ExpectedRateType || 'Hourly',
    CurrentRate: c.CurrentRate || '',
    CurrentRateType: c.CurrentRateType || 'Hourly',
    MaritalStatus: c.MaritalStatus || '',
    Industry: c.Industry || '',
    CurrentEmployer: c.CurrentEmployer || '',
    CurrentSalary: c.CurrentSalary || '',
    ExpectedSalary: c.ExpectedSalary || '',
    NoticePeriod: c.NoticePeriod || '',
    Mobile: c.Phone || c.mobile || '',
    SubmittedByRecruiter: c.PrimaryAssignee || c.BenchAssignee || c.SubmittedByRecruiter || '',

    // Bench Fields
    BenchPriority: c.PriorityCode || c.BenchPriority || '',
    OutOfJobSince: c.OutOfJobSince || '',
    NewJobDeadline: c.NewJobDeadline || '',
    WorkAuthPetitioner: c.WorkAuthPetitioner || '',
    WorkAuthExpiryDate: c.WorkAuthExpiryDate || '',
    BenchAssignees: Array.isArray(c.BenchAssignees) && c.BenchAssignees.length > 0
      ? c.BenchAssignees
      : (c.AllAssignees ? c.AllAssignees.split(',').map(s => s.trim()).filter(Boolean) : (c.PrimaryAssignee || c.BenchAssignee ? [c.PrimaryAssignee || c.BenchAssignee] : [])),
    BenchAssignee: c.PrimaryAssignee || c.BenchAssignee || '',
    DaysOnBench: daysOnBench,

    Contact: {
      Email: c.Email || c.email || '',
      Phone: c.Phone || c.phone || '',
      Mobile: c.Mobile || c.mobile || '',
    },
    Phones: c.Phones || (c.Phone ? [{ PhoneNumber: c.Phone }] : []),
    Emails: c.Emails || (c.Email ? [{ EmailAddress: c.Email }] : []),
    Skills: (c.Skills || []).map(s =>
      typeof s === 'string'
        ? { SkillName: s, SkillType: 'HARD' }
        : { SkillName: s.skill_name || s.SkillName || '', SkillType: s.skill_type || s.SkillType || 'HARD' }
    ),
    Education: c.Education || [],
    WorkExperience: c.WorkExperience || [],
    Certifications: c.Certifications || [],
    Document: null,
    Documents: []
  };
};

const getViewSearchState = (view) => {
  try {
    if (typeof window !== 'undefined' && window.location) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlSearch = urlParams.get('search');
      const urlView = urlParams.get('view') || 'all';
      if (urlSearch && urlView === view) {
        return {
          searchTerm: urlSearch,
          jobTitleSearch: '',
          jobTitleTags: []
        };
      }
    }

    const sTerm = sessionStorage.getItem(`cm_searchTerm_${view}`);
    const jtSearch = sessionStorage.getItem(`cm_jobTitleSearch_${view}`);
    let jtTags = sessionStorage.getItem(`cm_jobTitleTags_${view}`);

    // If bench was accidentally populated with sourcing tags from a previous session, clear it
    if (view === 'bench' && jtTags) {
      const sourcingTags = sessionStorage.getItem('cm_jobTitleTags_sourcing');
      if (sourcingTags && jtTags === sourcingTags) {
        sessionStorage.removeItem('cm_jobTitleTags_bench');
        sessionStorage.removeItem('cm_jobTitleSearch_bench');
        jtTags = null;
      }
    }

    // Clean up any legacy un-namespaced keys
    if (sessionStorage.getItem('cm_jobTitleTags')) {
      if (view === 'sourcing' && jtTags === null) {
        const oldTags = sessionStorage.getItem('cm_jobTitleTags') || '[]';
        const oldSearch = sessionStorage.getItem('cm_jobTitleSearch') || '';
        sessionStorage.setItem('cm_jobTitleTags_sourcing', oldTags);
        sessionStorage.setItem('cm_jobTitleSearch_sourcing', oldSearch);
        jtTags = oldTags;
      }
      sessionStorage.removeItem('cm_jobTitleTags');
      sessionStorage.removeItem('cm_jobTitleSearch');
    }

    return {
      searchTerm: sTerm !== null ? sTerm : '',
      jobTitleSearch: jtSearch !== null ? jtSearch : '',
      jobTitleTags: jtTags ? JSON.parse(jtTags) : []
    };
  } catch {
    return { searchTerm: '', jobTitleSearch: '', jobTitleTags: [] };
  }
};

const ResumeDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentView = queryParams.get('view') || 'all';
  const urlSearchParam = queryParams.get('search');

  const activeCompany = getActiveCompanyId();
  if (_cachedCompanyId !== activeCompany) {
    _cachedCandidates = null;
    _cachedBenchCandidates = null;
    _cachedCompanyId = activeCompany;
  }
  const initialCache = currentView === 'bench' ? _cachedBenchCandidates : _cachedCandidates;
  const [candidates, setCandidates] = useState(initialCache || []);
  const [loading, setLoading] = useState(initialCache === null);

  // Dictionary-based per-view search states (strictly isolated)
  const [viewSearches, setViewSearches] = useState(() => ({
    sourcing: getViewSearchState('sourcing'),
    bench: getViewSearchState('bench'),
    review: getViewSearchState('review'),
    all: getViewSearchState('all')
  }));

  const activeViewSearch = viewSearches[currentView] || { searchTerm: '', jobTitleSearch: '', jobTitleTags: [] };
  const searchTerm = activeViewSearch.searchTerm || '';
  const jobTitleSearch = activeViewSearch.jobTitleSearch || '';
  const jobTitleTags = activeViewSearch.jobTitleTags || [];

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [debouncedJobTitleSearch, setDebouncedJobTitleSearch] = useState(jobTitleSearch);
  const [isTypingSearching, setIsTypingSearching] = useState(false);

  const setSearchTerm = useCallback((valOrUpdater) => {
    setViewSearches(prev => {
      const currentVal = prev[currentView]?.searchTerm || '';
      const newVal = typeof valOrUpdater === 'function' ? valOrUpdater(currentVal) : valOrUpdater;
      sessionStorage.setItem(`cm_searchTerm_${currentView}`, newVal);
      return {
        ...prev,
        [currentView]: {
          ...(prev[currentView] || { jobTitleSearch: '', jobTitleTags: [] }),
          searchTerm: newVal
        }
      };
    });
  }, [currentView]);

  const setJobTitleSearch = useCallback((valOrUpdater) => {
    setViewSearches(prev => {
      const currentVal = prev[currentView]?.jobTitleSearch || '';
      const newVal = typeof valOrUpdater === 'function' ? valOrUpdater(currentVal) : valOrUpdater;
      sessionStorage.setItem(`cm_jobTitleSearch_${currentView}`, newVal);
      return {
        ...prev,
        [currentView]: {
          ...(prev[currentView] || { searchTerm: '', jobTitleTags: [] }),
          jobTitleSearch: newVal
        }
      };
    });
  }, [currentView]);

  const setJobTitleTags = useCallback((valOrUpdater) => {
    setViewSearches(prev => {
      const currentVal = prev[currentView]?.jobTitleTags || [];
      const newVal = typeof valOrUpdater === 'function' ? valOrUpdater(currentVal) : valOrUpdater;
      sessionStorage.setItem(`cm_jobTitleTags_${currentView}`, JSON.stringify(newVal));
      return {
        ...prev,
        [currentView]: {
          ...(prev[currentView] || { searchTerm: '', jobTitleSearch: '' }),
          jobTitleTags: newVal
        }
      };
    });
  }, [currentView]);

  const isFetchingRef = useRef(false);

  // Synchronous view change transition guard:
  // When currentView changes, immediately swap to target view's cache or enter loading state
  // before rendering, preventing any flash of stale bench data or 0-count empty state.
  const prevViewRef = useRef(currentView);
  if (prevViewRef.current !== currentView) {
    prevViewRef.current = currentView;
    const targetCache = currentView === 'bench' ? _cachedBenchCandidates : _cachedCandidates;
    if (targetCache && targetCache.length > 0) {
      setCandidates(targetCache);
      setLoading(false);
    } else {
      setCandidates([]);
      setLoading(true);
    }
    const targetSearch = viewSearches[currentView] || { searchTerm: '', jobTitleSearch: '', jobTitleTags: [] };
    const effectiveSearch = urlSearchParam !== null && urlSearchParam !== undefined ? urlSearchParam : (targetSearch.searchTerm || '');
    setDebouncedSearchTerm(effectiveSearch);
    setDebouncedJobTitleSearch(targetSearch.jobTitleSearch || '');
    setIsTypingSearching(false);
  }
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'CreatedOn', direction: 'desc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(_cachedItemsPerPage);
  const [editingCandidate, setEditingCandidate] = useState(null);
  const [showColumnSidebar, setShowColumnSidebar] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState({ rows: [], logic: 'AND' });
  const [showAiSidebar, setShowAiSidebar] = useState(false);
  const [uploadingResume, setUploadingResume] = useState(false);
  const [useAiSearch, setUseAiSearch] = useState(_cachedUseAiSearch);
  const [isAiSearching, setIsAiSearching] = useState(false);
  const [aiSearchResults, setAiSearchResults] = useState(_cachedAiSearchResults);

  // Parse Flow States
  const [parsedResumeData, setParsedResumeData] = useState(null);
  const [parsingFromToolbar, setParsingFromToolbar] = useState(false);
  const [pendingParseFile, setPendingParseFile] = useState(null);
  const [showConfirmParse, setShowConfirmParse] = useState(false);
  const [showParsingLoading, setShowParsingLoading] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateCandidate, setDuplicateCandidate] = useState(null);
  const [statusFilter, setStatusFilter] = useState(_cachedStatusFilter);
  const [showFilterSidebar, setShowFilterSidebar] = useState(true);
  const [candidateSourceTab, setCandidateSourceTab] = useState('all'); // 'all' | 'recruiter' | 'career_portal'
  const [podMemberNames, setPodMemberNames] = useState([]);

  useEffect(() => {
    const fetchPodMembers = async () => {
      try {
        let res = await fetch(`${BASE_URL}/api/teams/pod-members`, {
          headers: getAuthHeaders(),
        });
        if (res.status === 404) {
          res = await fetch(`${BASE_URL}/api/recruitment/teams/pod-members`, {
            headers: getAuthHeaders(),
          });
        }
        if (res.ok) {
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            setPodMemberNames(data);
          }
        }
      } catch (err) {
        console.error('Error fetching pod members:', err);
      }
    };
    fetchPodMembers();
  }, []);

  // Sidebar Filter State
  const [sidebarFilters, setSidebarFilters] = useState(() => {
    const defaults = {
      search: '',
      status: [],
      recruiter: '',
      sourceType: 'all',
      workType: [],
      experience: 'all',
      country: '',
      state: '',
      city: '',
      sources: [],
      employmentTypes: [],
      industries: [],
      isBench: 'all',
      personType: 'all',
      gender: [],
      relocate: 'all',
      workAuth: []
    };
    return _cachedSidebarFilters ? { ...defaults, ..._cachedSidebarFilters } : defaults;
  });

  // Visible Sidebar Filters (Dynamic filter visibility)
  const [visibleSidebarFilters, setVisibleSidebarFilters] = useState([
    'SourceType', 'CandidateStatus', 'SubmittedBy', 'PersonType', 'IsBench', 'RemoteStatus', 'Experience',
    'Gender', 'Relocation', 'WorkAuthorization', 'EmploymentType', 'Industry', 'CurrentLocation',
    'Skills', 'Email', 'Phone', 'JobTitle'
  ]);

  // Sync top search TO sidebar search only once on mount or when searchTerm changes externally
  useEffect(() => {
    setSidebarFilters(prev => ({ ...prev, search: searchTerm }));
  }, [searchTerm]);

  // Sync URL search query param if present
  useEffect(() => {
    if (urlSearchParam !== null && urlSearchParam !== undefined) {
      setSearchTerm(urlSearchParam);
      setDebouncedSearchTerm(urlSearchParam);
      setSidebarFilters(prev => ({ ...prev, search: urlSearchParam }));
    }
  }, [urlSearchParam, setSearchTerm]);

  // Debounce Job Title search input & typing preloader
  useEffect(() => {
    if (jobTitleSearch === debouncedJobTitleSearch) return;
    setIsTypingSearching(true);
    const timer = setTimeout(() => {
      setDebouncedJobTitleSearch(jobTitleSearch);
      setIsTypingSearching(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [jobTitleSearch, debouncedJobTitleSearch]);

  // Debounce Keyword search input & typing preloader
  useEffect(() => {
    if (searchTerm === debouncedSearchTerm) return;
    setIsTypingSearching(true);
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setIsTypingSearching(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, debouncedSearchTerm]);

  useEffect(() => {
    _cachedStatusFilter = statusFilter;
    sessionStorage.setItem('cm_statusFilter', statusFilter);
  }, [statusFilter]);

  useEffect(() => {
    _cachedAiSearchResults = aiSearchResults;
  }, [aiSearchResults]);

  useEffect(() => {
    _cachedUseAiSearch = useAiSearch;
  }, [useAiSearch]);

  useEffect(() => {
    _cachedItemsPerPage = itemsPerPage;
    sessionStorage.setItem('cm_itemsPerPage', itemsPerPage);
  }, [itemsPerPage]);

  useEffect(() => {
    _cachedSidebarFilters = sidebarFilters;
    sessionStorage.setItem('cm_sidebarFilters', JSON.stringify(sidebarFilters));
  }, [sidebarFilters]);

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [sidebarFilters, searchTerm, jobTitleSearch, jobTitleTags, aiSearchResults]);

  // Share Resume State
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareModalCandidates, setShareModalCandidates] = useState([]);
  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

  // Bulk Email Role Selection
  const [isBulkEmailingCandidates, setIsBulkEmailingCandidates] = useState(false);

  // Schedule Interview State
  const [showJobsModal, setShowJobsModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleCandidate, setScheduleCandidate] = useState(null);
  const [selectedJobForInterview, setSelectedJobForInterview] = useState(null);

  // Submit Profile State
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [submitCandidates, setSubmitCandidates] = useState([]);

  const parseFileInputRef = useRef(null);

  // Saved Searches State
  const [savedSearches, setSavedSearches] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem('erp_saved_searches');
    if (saved) {
      try {
        setSavedSearches(JSON.parse(saved));
      } catch (e) { }
    }
  }, []);

  const handleSaveSearch = () => {
    if (!searchTerm && statusFilter === 'all') return;

    const exists = savedSearches.some(s => s.term === searchTerm && s.status === statusFilter);
    if (exists) return;

    const newSaved = [...savedSearches, { term: searchTerm, status: statusFilter, id: Date.now() }];
    setSavedSearches(newSaved);
    localStorage.setItem('erp_saved_searches', JSON.stringify(newSaved));

    Swal.fire({
      title: 'Search Saved!',
      text: 'Your current search and filters have been saved.',
      icon: 'success',
      timer: 1500,
      showConfirmButton: false
    });
  };

  const handleLoadSearch = (search) => {
    setSearchTerm(search.term);
    setStatusFilter(search.status || 'all');
    setCurrentPage(1);

    if (useAiSearch && search.term) {
      handleAiSearch(search.term);
    } else {
      setAiSearchResults(null);
    }
  };

  const removeSavedSearch = (id) => {
    const updated = savedSearches.filter(s => s.id !== id);
    setSavedSearches(updated);
    localStorage.setItem('erp_saved_searches', JSON.stringify(updated));
  };

  // ─── Column Configuration per View ────────────────────────────────────────
  const sourcingAvailableColumns = useMemo(() => [
    { key: 'CandidateCode', label: 'Candidate ID' },
    { key: 'Candidate', label: 'Name' },
    { key: 'EmployeeCode', label: 'Employee ID' },
    { key: 'Email', label: 'Email' },
    { key: 'Phone', label: 'Mobile' },
    { key: 'JobTitle', label: 'Job Title' },
    { key: 'SubmittedBy', label: 'Created By' },
    { key: 'Skills', label: 'Skills' },
    { key: 'CandidateStatus', label: 'Status' },
    { key: 'RemoteStatus', label: 'Work Type' },
    { key: 'WorkAuthorization', label: 'Work Auth' },
    { key: 'EmploymentType', label: 'Emp Type' },
    { key: 'CreatedDate', label: 'Created Date' },
    { key: 'LinkedInUrl', label: 'LinkedIn URL' },
    { key: 'GitHubUrl', label: 'GitHub URL' },
    { key: 'CurrentLocation', label: 'Location' },
    { key: 'Gender', label: 'Gender' },
    { key: 'ProfileSummary', label: 'Profile Summary' },
    { key: 'PersonType', label: 'Type' },
    { key: 'IsBench', label: 'Bench Status' },
    { key: 'Experience', label: 'Experience' },
    { key: 'Relocation', label: 'Relocation' },
    { key: 'Source', label: 'Source' },
    { key: 'Actions', label: 'Actions' },
  ], []);

  const benchAvailableColumns = useMemo(() => [
    { key: 'CandidateCode', label: 'Candidate ID' },
    { key: 'Candidate', label: 'Name' },
    { key: 'EmployeeCode', label: 'Employee ID' },
    { key: 'Email', label: 'Email' },
    { key: 'Phone', label: 'Mobile' },
    { key: 'JobTitle', label: 'Job Title' },
    { key: 'BenchAssignee', label: 'Bench Recruiter' },
    { key: 'BenchPriority', label: 'Bench Priority' },
    { key: 'DaysOnBench', label: 'Days on Bench' },
    { key: 'WorkAuthorization', label: 'Work Auth' },
    { key: 'WorkAuthPetitioner', label: 'Work Auth Petitioner' },
    { key: 'WorkAuthExpiryDate', label: 'Work Auth Expiry Date' },
    { key: 'NewJobDeadline', label: 'Placement Deadline' },
    { key: 'OutOfJobSince', label: 'Out of Job Since' },
    { key: 'EmploymentType', label: 'Emp Type' },
    { key: 'CandidateStatus', label: 'Status' },
    { key: 'RemoteStatus', label: 'Work Type' },
    { key: 'Skills', label: 'Skills' },
    { key: 'SubmittedBy', label: 'Created By' },
    { key: 'CreatedDate', label: 'Created Date' },
    { key: 'LinkedInUrl', label: 'LinkedIn URL' },
    { key: 'GitHubUrl', label: 'GitHub URL' },
    { key: 'CurrentLocation', label: 'Location' },
    { key: 'Gender', label: 'Gender' },
    { key: 'ProfileSummary', label: 'Profile Summary' },
    { key: 'Experience', label: 'Experience' },
    { key: 'Relocation', label: 'Relocation' },
    { key: 'Source', label: 'Source' },
    { key: 'Actions', label: 'Actions' },
  ], []);

  const availableColumns = currentView === 'bench' ? benchAvailableColumns : sourcingAvailableColumns;

  const DEFAULT_SOURCING_VISIBLE_COLUMNS = [
    'CandidateCode', 'Candidate', 'Email', 'Phone', 'JobTitle',
    'Skills', 'CandidateStatus', 'RemoteStatus', 'WorkAuthorization', 'CreatedDate', 'Actions',
  ];

  const DEFAULT_BENCH_VISIBLE_COLUMNS = [
    'CandidateCode', 'Candidate', 'Email', 'Phone', 'JobTitle',
    'BenchAssignee', 'BenchPriority', 'DaysOnBench', 'WorkAuthorization', 'CandidateStatus', 'Actions',
  ];

  const defaultVisibleCols = currentView === 'bench' ? DEFAULT_BENCH_VISIBLE_COLUMNS : DEFAULT_SOURCING_VISIBLE_COLUMNS;

  const [visibleColumns, setVisibleColumns] = useState(defaultVisibleCols);

  useEffect(() => {
    setVisibleColumns(currentView === 'bench' ? DEFAULT_BENCH_VISIBLE_COLUMNS : DEFAULT_SOURCING_VISIBLE_COLUMNS);
  }, [currentView]);

  const availableSidebarFilters = [
    { key: 'SourceType', label: 'Candidate Source' },
    { key: 'CandidateStatus', label: 'Status' },
    { key: 'SubmittedBy', label: 'Created By / Recruiter' },
    { key: 'PersonType', label: 'Type' },
    { key: 'IsBench', label: 'Bench Status' },
    { key: 'RemoteStatus', label: 'Work Type' },
    { key: 'Experience', label: 'Experience' },
    { key: 'WorkAuthorization', label: 'Work Auth' },
    { key: 'EmploymentType', label: 'Emp Type' },
    { key: 'Industry', label: 'Industry' },
    { key: 'Gender', label: 'Gender' },
    { key: 'Relocation', label: 'Relocation' },
    { key: 'CurrentLocation', label: 'Location' },
    { key: 'Skills', label: 'Skills (Search)' },
    { key: 'Email', label: 'Email (Search)' },
    { key: 'Phone', label: 'Mobile (Search)' },
    { key: 'JobTitle', label: 'Job Title (Search)' },
  ];

  // ── Fetch candidate list ──────────────────────────────────────────────────
  const fetchCandidates = useCallback(async (force = false) => {
    const currentCompany = getActiveCompanyId();
    if (_cachedCompanyId !== currentCompany || localStorage.getItem('cm_cached_company') !== currentCompany) {
      _cachedCandidates = null;
      _cachedBenchCandidates = null;
      _cachedCompanyId = currentCompany;
      localStorage.removeItem('cm_cached_candidates');
      localStorage.removeItem('cm_cached_bench_candidates');
      localStorage.setItem('cm_cached_company', currentCompany);
      force = true;
    }
    const currentCache = currentView === 'bench' ? _cachedBenchCandidates : _cachedCandidates;

    // Instant load from cache if available and not forcing
    if (currentCache && !force) {
      setCandidates(currentCache);
      setLoading(false);
      return;
    }

    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    // Stale-While-Revalidate: Show spinner whenever the target view has no cache yet.
    // Do NOT rely on candidates.length because that may still hold data from a different view.
    if (!currentCache) {
      setLoading(true);
    }

    try {
      if (currentView === 'bench') {
        const response = await fetch(`${BASE_URL}/api/bench-manage/candidates?limit=1000`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);
        const raw = await response.json();
        const data = Array.isArray(raw?.data) ? raw.data : (Array.isArray(raw) ? raw : []);
        const transformed = data.map(transformBenchCandidate);
        _cachedBenchCandidates = transformed;
        setCandidates(transformed);
      } else {
        const response = await fetch(`${BASE_URL}/api/resumes`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);

        const raw = await response.json();
        const data = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data) ? raw.data
            : Array.isArray(raw?.candidates) ? raw.candidates
              : [];

        const transformedCandidates = data.map(transformCandidate);

        // De-duplicate by CandidateId
        const uniqueItems = [];
        const seenIds = new Set();
        transformedCandidates.forEach(c => {
          const id = String(c.CandidateId);
          if (!seenIds.has(id)) {
            seenIds.add(id);
            uniqueItems.push(c);
          }
        });

        _cachedCandidates = uniqueItems;
        setCandidates(uniqueItems);
      }
    } catch (error) {
      console.error('[ResumeDashboard] Error fetching candidates:', error);
      // FIX: Only keep stale candidates if they belong to the CURRENT view (from its own cache).
      // If currentCache is null, the candidates in state may be from a different view — clear them
      // to prevent "0 out of 107" showing sourcing filtered over bench data.
      if (currentCache && currentCache.length > 0) {
        setCandidates(currentCache);
      } else if (candidates.length > 0 && currentCache !== null) {
        // Keep existing candidates only if currentCache was set (same view data)
      } else {
        setCandidates([]);  // Clear — stale data from different view must not persist
        Swal.fire({
          title: 'Connection Error',
          html: `<p>Could not load candidates from the server.</p>
                 <small style="color:#888">Make sure the backend server is running and reachable.</small>`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } finally {
      isFetchingRef.current = false;
      setLoading(false);
    }
  }, [currentView, candidates.length]);

  const handleAiSearch = useCallback(async (query) => {
    if (!query || !query.trim()) {
      setAiSearchResults(null);
      return;
    }

    setIsAiSearching(true);
    try {
      const countMatch = query.match(/(\d+)\s*(?:candidates|results|people)/i);
      const requestedLimit = countMatch ? parseInt(countMatch[1]) : 50;

      const response = await fetch(`${BASE_URL}/api/resumes/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          query: query.trim(),
          top_k: requestedLimit,
          limit: requestedLimit,
          size: requestedLimit
        }),
      });

      if (!response.ok) throw new Error('AI Search failed');
      const data = await response.json();

      if (data && data.results) {
        console.log(`🔍 AI Search returned ${data.results.length} results (Requested: ${requestedLimit})`);

        const seenIds = new Set();
        const mappedResults = data.results
          .filter(res => {
            const id = String(res.candidate_id);
            if (seenIds.has(id)) return false;
            seenIds.add(id);
            return true;
          })
          .map(res => {
            const localMatch = candidates.find(c => String(c.CandidateId) === String(res.candidate_id));

            if (localMatch) {
              return {
                ...localMatch,
                aiScore: res.score,
                aiRank: res.rank,
                matchReason: res.match_reason
              };
            }

            return {
              CandidateId: res.candidate_id,
              FirstName: res.name?.split(' ')[0] || 'Unknown',
              LastName: res.name?.split(' ').slice(1).join(' ') || '',
              JobTitle: res.job_title || 'N/A',
              YearsOfExperience: res.years_experience,
              Skills: (res.skills || []).map(s => ({ SkillName: s, SkillType: 'HARD' })),
              CandidateStatus: 'Available',
              RemoteStatus: res.remote_status || 'OnSite',
              Contact: {
                Email: '',
                Phone: '',
                Mobile: ''
              },
              matchReason: res.match_reason,
              aiScore: res.score,
              aiRank: res.rank
            };
          });

        setAiSearchResults(mappedResults);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error('AI Search Error:', error);
      Swal.fire({
        title: 'Search Error',
        text: 'The AI search service is currently unavailable.',
        icon: 'error',
        timer: 2000,
        showConfirmButton: false
      });
    } finally {
      setIsAiSearching(false);
    }
  }, [candidates]);

  // ── Manual AI Search Flow ──────────────────────────────────────────────
  // Clear AI search results when search term is cleared
  useEffect(() => {
    if (!searchTerm || !searchTerm.trim()) {
      setAiSearchResults(null);
      setIsAiSearching(false);
    }
  }, [searchTerm]);

  // Pre-fetch bench candidates silently in the background for 0ms instant tab switching.
  // FIX: Do NOT pre-fetch when on sourcing/review views — competing fetch wastes DB connections
  // and causes the failing bench API (missing CandidateBenchProfile table) to add error overhead.
  useEffect(() => {
    if (currentView === 'sourcing' || currentView === 'review' || currentView === 'all') return;
    if (!_cachedBenchCandidates) {
      fetch(`${BASE_URL}/api/bench-manage/candidates?limit=1000`, { headers: getAuthHeaders() })
        .then(res => res.ok ? res.json() : null)
        .then(raw => {
          if (raw) {
            const data = Array.isArray(raw?.data) ? raw.data : (Array.isArray(raw) ? raw : []);
            _cachedBenchCandidates = data.map(transformBenchCandidate);
            if (currentView === 'bench' && candidates.length === 0) {
              setCandidates(_cachedBenchCandidates);
              setLoading(false);
            }
          }
        })
        .catch(() => { });
    }
  }, [currentView, candidates.length]);

  // Listen for candidate updates across tabs/modals to instantly refresh table without manual reload
  useEffect(() => {
    const handleCandidateUpdate = () => {
      _cachedCandidates = null;
      _cachedBenchCandidates = null;
      fetchCandidates(true);
    };
    window.addEventListener('candidateListUpdated', handleCandidateUpdate);
    return () => {
      window.removeEventListener('candidateListUpdated', handleCandidateUpdate);
    };
  }, [fetchCandidates]);

  // Reset search and filters only when the view actually changes, and refresh on return
  useEffect(() => {
    if (_cachedView !== currentView) {
      const targetCache = currentView === 'bench' ? _cachedBenchCandidates : _cachedCandidates;
      if (targetCache && targetCache.length > 0) {
        setCandidates(targetCache);
        setLoading(false);
      } else {
        setCandidates([]);
        setLoading(true);
      }
      const targetSearch = viewSearches[currentView] || { searchTerm: '', jobTitleSearch: '', jobTitleTags: [] };
      const effectiveSearch = urlSearchParam !== null && urlSearchParam !== undefined ? urlSearchParam : (targetSearch.searchTerm || '');
      setDebouncedSearchTerm(effectiveSearch);
      setDebouncedJobTitleSearch(targetSearch.jobTitleSearch || '');
      setIsTypingSearching(false);
      setAiSearchResults(null);
      setAdvancedFilters({ rows: [], logic: 'AND' });
      setCurrentPage(1);
      _cachedView = currentView;
      fetchCandidates(false);
    } else {
      fetchCandidates(false);
    }
  }, [currentView, fetchCandidates, urlSearchParam]);

  // ── Navigate to full candidate detail page ────────────────────────────
  const viewCandidate = (id) => {
    navigate(`/candidates/${id}`);
  };

  // ── Get field value from candidate ──
  const getFieldValue = useCallback((candidate, field) => {
    switch (field) {
      case 'FirstName':
        return formatFullName(candidate.FirstName, candidate.MiddleName, candidate.LastName);
      case 'Email': return candidate.Contact?.Email || '';
      case 'Phone': return candidate.Contact?.Phone || '';
      case 'Skills':
        return (candidate.Skills || []).map(s => s.SkillName || s).join(', ');
      case 'YearsOfExperience': return candidate.YearsOfExperience != null ? String(candidate.YearsOfExperience) : '';
      case 'CreatedDt': return candidate.CreatedDt || '';
      default: {
        const val = candidate[field];
        return (val !== null && val !== undefined) ? String(val) : '';
      }
    }
  }, []);

  // ── Check if a candidate matches a single filter row ──
  const matchesRow = useCallback((candidate, row) => {
    const rawVal = getFieldValue(candidate, row.field);
    const target = (row.value || '').trim();

    if (row.condition === 'is_empty') return !rawVal || String(rawVal).trim() === '';
    if (row.condition === 'is_not_empty') return rawVal && String(rawVal).trim() !== '';

    const valStr = String(rawVal || '').trim();
    const valLower = valStr.toLowerCase();
    const targetLower = target.toLowerCase();

    const numVal = parseFloat(valStr);
    const numTarget = parseFloat(target);
    const isNumericMatch = !isNaN(numVal) && !isNaN(numTarget) && isFinite(valStr) && isFinite(target);

    const dateVal = new Date(valStr);
    const dateTarget = new Date(target);
    const isDateMatch = !isNaN(dateVal.getTime()) && !isNaN(dateTarget.getTime()) && valStr.includes('-') && target.includes('-');

    switch (row.condition) {
      case 'contains': return valLower.includes(targetLower);
      case 'not_contains': return !valLower.includes(targetLower);
      case 'equals':
        if (isNumericMatch) return numVal === numTarget;
        if (isDateMatch) {
          const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
          const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
          return d1 === d2;
        }
        if (row.field === 'Skills') {
          return valLower.split(',').map(s => s.trim()).includes(targetLower);
        }
        return valLower === targetLower;
      case 'not_equals':
        if (isNumericMatch) return numVal !== numTarget;
        if (isDateMatch) {
          const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
          const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
          return d1 !== d2;
        }
        if (row.field === 'Skills') {
          return !valLower.split(',').map(s => s.trim()).includes(targetLower);
        }
        return valLower !== targetLower;
      case 'starts_with': return valLower.startsWith(targetLower);
      case 'ends_with': return valLower.endsWith(targetLower);
      case 'greater_than':
        if (isNumericMatch) return numVal > numTarget;
        if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) > dateTarget.setHours(0, 0, 0, 0);
        return valLower > targetLower;
      case 'less_than':
        if (isNumericMatch) return numVal < numTarget;
        if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) < dateTarget.setHours(0, 0, 0, 0);
        return valLower < targetLower;
      default: return true;
    }
  }, [getFieldValue]);

  // ── Derived filter options ─────────────────────────────────────────────
  const availableStatuses = useMemo(() => {
    return ['Available', 'In Process', 'Not Available', 'Hired'];
  }, []);

  const availableWorkTypes = useMemo(() => {
    return ['Remote', 'OnSite', 'Hybrid'];
  }, []);

  const availableLocations = useMemo(() => {
    const locs = [...new Set(candidates.map(c => {
      if (c.CurrentLocation) {
        const parts = c.CurrentLocation.split(',').map(p => p.trim());
        if (parts.length >= 2) {
          return parts.slice(-2).join(', ');
        }
        return parts[0];
      }
      return null;
    }))].filter(Boolean);
    return locs.sort();
  }, [candidates]);

  const availableSources = useMemo(() => {
    const sources = [...new Set(candidates.map(c => c.Source))].filter(Boolean);
    return sources.sort();
  }, [candidates]);

  const availableEmploymentTypes = useMemo(() => {
    const types = [...new Set(candidates.map(c => c.EmploymentType))].filter(Boolean);
    return types.sort();
  }, [candidates]);

  const availableIndustries = useMemo(() => {
    const inds = [...new Set(candidates.map(c => c.Industry))].filter(Boolean);
    return inds.sort();
  }, [candidates]);

  const availableWorkAuths = useMemo(() => {
    const auths = [...new Set(candidates.map(c => c.WorkAuthorization))].filter(Boolean);
    return auths.sort();
  }, [candidates]);

  const availableGenders = useMemo(() => {
    const genders = [...new Set(candidates.map(c => c.Gender))].filter(Boolean);
    return genders.sort();
  }, [candidates]);

  const availableRecruiters = useMemo(() => {
    if (podMemberNames && podMemberNames.length > 0) {
      return [...podMemberNames].sort();
    }
    return DEFAULT_POD_MEMBERS;
  }, [podMemberNames]);


  // ── Filter & Sort Logic ────────────────────────────────────────────────
  const filteredCandidates = useMemo(() => {
    // Helper to evaluate a single search term against a candidate record
    const checkCandidateMatch = (candidate, term) => {
      const fullName = formatFullName(candidate.FirstName, candidate.MiddleName, candidate.LastName).toLowerCase().replace(/\s+/g, ' ');
      const skillsText = (candidate.Skills || []).map(s => s.SkillName || s).join(' ').toLowerCase().replace(/\s+/g, ' ');
      const exp = (candidate.YearsOfExperience !== undefined && candidate.YearsOfExperience !== null) ? candidate.YearsOfExperience : '';
      const expText = exp !== '' ? `${exp}y ${exp} yr ${exp} year ${exp} years` : '';
      const location = (candidate.CurrentLocation || '').toLowerCase();
      const recruiterText = (candidate.SubmittedByRecruiter || '').toLowerCase();

      // Setup smart location matching
      const locationAliases = buildLocationAliases(term);
      const locationMatch = locationMatchesQuery(location, locationAliases, term);

      return (
        fullName.includes(term) ||
        (candidate.JobTitle || '').toLowerCase().includes(term) ||
        (candidate.CandidateCode || '').toLowerCase().includes(term) ||
        (candidate.Contact?.Email || '').toLowerCase().includes(term) ||
        (candidate.Contact?.Phone || '').toLowerCase().includes(term) ||
        (candidate.Contact?.Mobile || '').toLowerCase().includes(term) ||
        recruiterText.includes(term) ||
        skillsText.includes(term) ||
        expText.toLowerCase().includes(term) ||
        locationMatch
      );
    };

    // 1️⃣ Priority: If AI search was just performed, use those results as our working set
    let result = aiSearchResults !== null ? [...aiSearchResults] : [...candidates];

    // 2️⃣ Standard global search filtering - Skip if AI Search is active
    if (aiSearchResults === null && debouncedSearchTerm && !useAiSearch) {
      const parsedQuery = parseBooleanQuery(debouncedSearchTerm);
      result = result.filter(c => matchCandidateWithBooleanQuery(c, parsedQuery, checkCandidateMatch));
    }

    // 2️⃣.1 Dedicated Job Title search filtering (Tags + debounced typed input with OR logic)
    const allTitleTerms = [
      ...jobTitleTags,
      ...(debouncedJobTitleSearch && debouncedJobTitleSearch.trim() ? [debouncedJobTitleSearch.trim()] : [])
    ];
    if (allTitleTerms.length > 0) {
      result = result.filter(c => {
        const candTitle = (c.JobTitle || '').toLowerCase();
        return allTitleTerms.some(term => candTitle.includes(term.toLowerCase()));
      });
    }

    // 3️⃣ Sidebar-specific search filtering - Skip if AI Search is active
    if (aiSearchResults === null && sidebarFilters.search && !useAiSearch) {
      const parsedQuery = parseBooleanQuery(sidebarFilters.search);
      result = result.filter(c => matchCandidateWithBooleanQuery(c, parsedQuery, checkCandidateMatch));
    }

    // Status filter
    if (statusFilter !== 'all') {
      result = result.filter(c => {
        if (statusFilter === 'On Bench') {
          return c.IsBench === true || c.CandidateStatus === 'On Bench';
        }
        return (c.CandidateStatus || '').toLowerCase() === statusFilter.toLowerCase();
      });
    }

    // Recruiter filter
    if (sidebarFilters.recruiter && sidebarFilters.recruiter !== 'all') {
      const target = sidebarFilters.recruiter.toLowerCase().trim();
      result = result.filter(c => (c.SubmittedByRecruiter || '').toLowerCase().includes(target));
    }

    // Category filter based on 'view' query parameter - Skip strict sourcing/review checks if AI Search is active
    if (aiSearchResults === null) {
      if (currentView === 'sourcing') {
        result = result.filter(c => {
          const hasEmail = (c.Contact?.Email || '').trim();
          const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
          const benchMatch = sidebarFilters.isBench === 'bench' ? c.IsBench : !c.IsBench;
          return benchMatch && (hasEmail || hasPhone);
        });
      } else if (currentView === 'bench') {
        result = result.filter(c => c.IsBench === true);
      } else if (currentView === 'review') {
        result = result.filter(c => {
          const hasEmail = (c.Contact?.Email || '').trim();
          const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
          return !hasEmail && !hasPhone;
        });
      }
    }

    // Source Type filter: 'by recruiter' vs 'by career portal' (ATS)
    const activeSourceType = (sidebarFilters.sourceType && sidebarFilters.sourceType !== 'all')
      ? sidebarFilters.sourceType
      : candidateSourceTab;

    if (activeSourceType !== 'all') {
      result = result.filter(c => {
        const type = (c.SourceType || 'recruiter').toLowerCase();
        const src = (c.Source || '').toLowerCase();
        const isPortal = type === 'career_portal' || src.includes('career') || src.includes('ats') || src.includes('portal');
        if (activeSourceType === 'career_portal') return isPortal;
        if (activeSourceType === 'recruiter') return !isPortal;
        return true;
      });
    }

    // Sidebar Filters Logic

    // Live search (as you type) — filters instantly without pressing Enter
    if ((sidebarFilters.search || '').trim()) {
      const parsedQuery = parseBooleanQuery(sidebarFilters.search);
      result = result.filter(c => matchCandidateWithBooleanQuery(c, parsedQuery, checkCandidateMatch));
    }

    if ((sidebarFilters.status || []).length > 0) {
      const selected = sidebarFilters.status.map(s => s.toLowerCase());
      result = result.filter(c => selected.includes((c.CandidateStatus || '').toLowerCase()));
    }
    if ((sidebarFilters.workType || []).length > 0) {
      const selected = sidebarFilters.workType.map(w => w.toLowerCase());
      result = result.filter(c => selected.includes((c.RemoteStatus || '').toLowerCase()));
    }

    // Advanced location filtering with Country/State/City support
    if (sidebarFilters.country) {
      const selectedCountryName = sidebarFilters.country;
      const selectedCountryCode = getCountryCode(selectedCountryName);

      result = result.filter(c => {
        if (!c.CurrentLocation) return false;
        const locLower = c.CurrentLocation.toLowerCase();

        // Special case: India ("IN") vs Indiana ("IN") collision
        if (selectedCountryCode === 'IN') {
          // If the location has US country indicators, the "IN" is likely Indiana.
          // Only keep it if it explicitly contains the word "india".
          if (/\b(us|usa|united states)\b/.test(locLower)) {
            return /\bindia\b/.test(locLower);
          }
        }

        // Use word boundaries for exact matching
        const aliases = [selectedCountryName.toLowerCase()];
        if (selectedCountryCode) aliases.push(selectedCountryCode.toLowerCase());

        return locationMatchesQuery(locLower, aliases, selectedCountryName.toLowerCase());
      });
    }

    if ((sidebarFilters.states || []).length > 0) {
      const countryCode = getCountryCode(sidebarFilters.country);
      result = result.filter(c => {
        if (!c.CurrentLocation) return false;
        const locLower = c.CurrentLocation.toLowerCase();

        return sidebarFilters.states.some(selectedStateName => {
          const selectedStateCode = getStateCode(countryCode, selectedStateName);
          const aliases = [selectedStateName.toLowerCase()];
          if (selectedStateCode) aliases.push(selectedStateCode.toLowerCase());

          return locationMatchesQuery(locLower, aliases);
        });
      });
    }

    if ((sidebarFilters.cities || []).length > 0) {
      result = result.filter(c => {
        if (!c.CurrentLocation) return false;
        const locLower = c.CurrentLocation.toLowerCase();

        return sidebarFilters.cities.some(cityTerm => {
          return locationMatchesQuery(locLower, [cityTerm.toLowerCase().trim()]);
        });
      });
    }

    if ((sidebarFilters.workAuth || []).length > 0) {
      const selected = sidebarFilters.workAuth.map(a => a.toLowerCase());
      result = result.filter(c => selected.includes((c.WorkAuthorization || '').toLowerCase()));
    }

    if ((sidebarFilters.employmentTypes || []).length > 0) {
      const selected = sidebarFilters.employmentTypes.map(t => t.toLowerCase());
      result = result.filter(c => selected.includes((c.EmploymentType || '').toLowerCase()));
    }

    if ((sidebarFilters.industries || []).length > 0) {
      const selected = sidebarFilters.industries.map(i => i.toLowerCase());
      result = result.filter(c => selected.includes((c.Industry || '').toLowerCase()));
    }

    if ((sidebarFilters.sources || []).length > 0) {
      const selected = sidebarFilters.sources.map(s => s.toLowerCase());
      result = result.filter(c => selected.includes((c.Source || '').toLowerCase()));
    }

    if ((sidebarFilters.gender || []).length > 0) {
      const selected = sidebarFilters.gender.map(g => g.toLowerCase());
      result = result.filter(c => selected.includes((c.Gender || '').toLowerCase()));
    }

    if (sidebarFilters.isBench && sidebarFilters.isBench !== 'all') {
      result = result.filter(c => sidebarFilters.isBench === 'bench' ? c.IsBench : !c.IsBench);
    }

    if (sidebarFilters.personType && sidebarFilters.personType !== 'all') {
      result = result.filter(c => sidebarFilters.personType === 'employees' ? c.IsEmployee : !c.IsEmployee);
    }

    if (sidebarFilters.relocate && sidebarFilters.relocate !== 'all') {
      result = result.filter(c => sidebarFilters.relocate === 'yes' ? c.WillingToRelocate : !c.WillingToRelocate);
    }

    if (sidebarFilters.experience !== 'all') {
      switch (sidebarFilters.experience) {
        case '0-2': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) <= 2); break;
        case '3-5': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 2 && e <= 5; }); break;
        case '5-10': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 5 && e <= 10; }); break;
        case '10+': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) > 10); break;
        default: break;
      }
    }

    if ((sidebarFilters.skills || []).length > 0) {
      result = result.filter(c => {
        return sidebarFilters.skills.every(tag => {
          const parsedQuery = parseBooleanQuery(tag);
          return matchCandidateWithBooleanQuery(c, parsedQuery, checkCandidateMatch);
        });
      });
    }

    // Advanced filters
    const validRows = (advancedFilters.rows || []).filter(r => r.field && r.condition);
    if (validRows.length > 0) {
      result = result.filter(c => {
        let isMatch = matchesRow(c, validRows[0]);

        for (let i = 1; i < validRows.length; i++) {
          const row = validRows[i];
          const op = row.operator || 'AND';

          if (op === 'OR') {
            isMatch = isMatch || matchesRow(c, row);
          } else {
            isMatch = isMatch && matchesRow(c, row);
          }
        }
        return isMatch;
      });
    }

    // Standard sorting
    result.sort((a, b) => {
      let av, bv;
      if (sortConfig.key === 'CreatedDt') {
        av = new Date(a.CreatedDt || 0); bv = new Date(b.CreatedDt || 0);
      } else if (sortConfig.key === 'YearsOfExperience') {
        av = a.YearsOfExperience || 0; bv = b.YearsOfExperience || 0;
      } else if (sortConfig.key === 'Email') {
        av = (a.Email || '').toLowerCase();
        bv = (b.Email || '').toLowerCase();
      } else if (sortConfig.key === 'FirstName') {
        av = formatFullName(a.FirstName, a.MiddleName, a.LastName).toLowerCase();
        bv = formatFullName(b.FirstName, b.MiddleName, b.LastName).toLowerCase();
      } else {
        av = String(a[sortConfig.key] || '').toLowerCase();
        bv = String(b[sortConfig.key] || '').toLowerCase();
      }
      if (av < bv) return sortConfig.direction === 'asc' ? -1 : 1;
      if (av > bv) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });

    return result;
  }, [candidates, debouncedSearchTerm, debouncedJobTitleSearch, jobTitleTags, statusFilter, advancedFilters, sortConfig, aiSearchResults, matchesRow, currentView, sidebarFilters, visibleSidebarFilters, useAiSearch, candidateSourceTab]);

  const sourceStats = useMemo(() => {
    let baseList = candidates;
    if (aiSearchResults === null) {
      if (currentView === 'sourcing') {
        baseList = baseList.filter(c => {
          const hasEmail = (c.Contact?.Email || '').trim();
          const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
          const benchMatch = sidebarFilters.isBench === 'bench' ? c.IsBench : !c.IsBench;
          return benchMatch && (hasEmail || hasPhone);
        });
      } else if (currentView === 'bench') {
        baseList = baseList.filter(c => c.IsBench === true);
      } else if (currentView === 'review') {
        baseList = baseList.filter(c => {
          const hasEmail = (c.Contact?.Email || '').trim();
          const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
          return !hasEmail && !hasPhone;
        });
      }
    }

    let recruiterCount = 0;
    let careerPortalCount = 0;

    for (const c of baseList) {
      const type = (c.SourceType || 'recruiter').toLowerCase();
      const src = (c.Source || '').toLowerCase();
      if (type === 'career_portal' || src.includes('career') || src.includes('ats') || src.includes('portal')) {
        careerPortalCount++;
      } else {
        recruiterCount++;
      }
    }

    return {
      all: baseList.length,
      recruiter: recruiterCount,
      careerPortal: careerPortalCount
    };
  }, [candidates, currentView, aiSearchResults, sidebarFilters.isBench]);

  const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);
  const paginatedCandidates = filteredCandidates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleResetFilters = () => {
    setViewSearches(prev => ({
      ...prev,
      [currentView]: { searchTerm: '', jobTitleSearch: '', jobTitleTags: [] }
    }));
    setDebouncedSearchTerm('');
    setDebouncedJobTitleSearch('');
    setIsTypingSearching(false);
    setAiSearchResults(null);
    setCandidateSourceTab('all');
    setAdvancedFilters({ rows: [], logic: 'AND' });
    setSortConfig({ key: 'CreatedDt', direction: 'desc' });
    setStatusFilter('all');
    setSidebarFilters({
      search: '',
      status: [],
      recruiter: '',
      sourceType: 'all',
      workType: [],
      experience: 'all',
      country: '',
      state: '',
      city: '',
      sources: [],
      employmentTypes: [],
      industries: [],
      isBench: 'all',
      personType: 'all',
      gender: [],
      relocate: 'all',
      workAuth: []
    });
    // Clear view-specific and legacy sessionStorage values
    sessionStorage.removeItem(`cm_searchTerm_${currentView}`);
    sessionStorage.removeItem(`cm_jobTitleSearch_${currentView}`);
    sessionStorage.removeItem(`cm_jobTitleTags_${currentView}`);
    sessionStorage.removeItem('cm_searchTerm');
    sessionStorage.removeItem('cm_jobTitleSearch');
    sessionStorage.removeItem('cm_jobTitleTags');
    sessionStorage.removeItem('cm_statusFilter');
    sessionStorage.removeItem('cm_sidebarFilters');
  };

  const handleApplyFilters = (filters) => {
    setAdvancedFilters(filters);
    setCurrentPage(1);
  };

  const requestSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
    setCurrentPage(1);
  };

  const editCandidate = (candidate) => {
    setEditingCandidate(candidate);
    setParsedResumeData(null);
    setShowAddModal(true);
  };

  const getFullCandidate = async (id) => {
    const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch details');
    const data = await response.json();
    return transformCandidate(data);
  };

  const deleteCandidate = async (id) => {
    const candidate = candidates.find(c => c.CandidateId === id);
    const name = formatFullName(candidate?.FirstName, candidate?.MiddleName, candidate?.LastName);

    const confirm = await Swal.fire({
      title: 'Delete Candidate?',
      text: `This will permanently delete ${name}'s record.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete',
    });

    if (confirm.isConfirmed) {
      try {
        const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
          method: 'DELETE',
          headers: getAuthHeaders(),
        });
        if (!response.ok) throw new Error('Failed to delete candidate');
        _cachedCandidates = null;
        _cachedBenchCandidates = null;
        try {
          localStorage.removeItem('cm_cached_candidates');
          localStorage.removeItem('cm_cached_bench_candidates');
        } catch (e) { }
        setCandidates(prev => prev.filter(c => c.CandidateId !== id));
        Swal.fire({ title: 'Deleted!', text: `${name} has been removed.`, icon: 'success', timer: 1800, showConfirmButton: false });
      } catch (error) {
        console.error('Error deleting candidate:', error);
        Swal.fire({ title: 'Error', text: 'Failed to delete candidate', icon: 'error' });
      }
    }
  };

  // ── Parse Resume Flow ──────────────────────────────────────────────────
  const handleParseFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';
    setPendingParseFile(file);
    setShowConfirmParse(true);
  };

  const handleConfirmParse = async () => {
    if (!pendingParseFile) return;
    setShowConfirmParse(false);
    setShowParsingLoading(true);
    setParsingFromToolbar(true);

    try {
      const formData = new FormData();
      formData.append('file1', pendingParseFile);

      const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: formData
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || errData.error || 'Failed to parse resume');
      }

      const data = await response.json();
      const parsed = {
        FirstName: formatName(data.firstName || ''),
        LastName: formatName(data.lastName || ''),
        MiddleName: formatName(data.middleName || ''),
        Email: data.email || '',
        Phone: data.phone || '',
        Mobile: data.mobile || '',
        TwitterUrl: data.twitterUrl || '',
        VideoResumeUrl: data.videoResumeUrl || '',
        JobTitle: formatJobTitle(data.jobTitle || ''),
        YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
        ProfileSummary: data.profileSummary || '',
        LinkedInUrl: data.linkedInUrl || '',
        GitHubUrl: data.gitHubUrl || '',
        Gender: data.gender || '',
        CurrentLocation: data.currentLocation || '',
        cityName: data.cityName || '',
        stateName: data.stateName || '',
        countryIso2: data.countryIso2 || '',
        countryName: data.countryName || '',
        WorkAuthorization: data.workAuthorization || '',
        EmploymentType: data.employmentType || '',
        skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
        workExperience: (data.workExperience || []).map(exp => ({
          Company: exp.company || '',
          JobTitle: formatJobTitle(exp.jobTitle || ''),
          StartDate: exp.startDate || '', EndDate: exp.endDate || '',
          IsCurrent: exp.isCurrent || false, Description: exp.description || '',
        })),
        education: (data.education || []).map(edu => ({
          Institution: formatName(edu.institution || ''),
          Degree: formatName(edu.degree || ''),
          FieldOfStudy: edu.fieldOfStudy || '', StartDate: edu.startDate || '',
          EndDate: edu.endDate || '', GPA: edu.gpa || '',
        })),
        certifications: (data.certifications || []).map(cert => ({
          CertificationName: formatName(cert.name || ''),
          IssuingOrganization: cert.issuingOrg || '',
          IssueDate: cert.issueDate || '', ExpiryDate: cert.expiryDate || '',
          CredentialId: cert.credentialId || '', CredentialUrl: cert.credentialUrl || '',
        })),
        ResumeFile: pendingParseFile,
        RawPayloadJson: JSON.stringify(data),
        ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
        ParsedText: data.parsedText || data.parsed_text || '',
        ParserVendor: data.vendor || 'llama-3.1-8b-instant',
        ExtractedEmail: data.email || data.extracted_email || '',
        ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
      };

      // Check duplicate candidate globally against the entire DB
      let dup = null;
      try {
        const checkRes = await fetch(`${BASE_URL}/api/resumes/check-duplicate`, {
          method: 'POST',
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: parsed.Email || parsed.ExtractedEmail,
            linkedInUrl: parsed.LinkedInUrl,
            phone: parsed.Phone || parsed.Mobile || parsed.ExtractedPhone
          })
        });
        if (checkRes.ok) {
          const checkData = await checkRes.json();
          if (checkData.exists && checkData.candidate) {
            dup = checkData.candidate;
          }
        }
      } catch (checkErr) {
        console.warn('Backend duplicate check failed, checking in-memory list:', checkErr);
      }

      // Fallback: check in-memory candidates array (both current candidates + cached sourcing pool)
      if (!dup) {
        const allCandidatesPool = [
          ...(Array.isArray(candidates) ? candidates : []),
          ...(Array.isArray(_cachedCandidates) ? _cachedCandidates : []),
          ...(Array.isArray(_cachedBenchCandidates) ? _cachedBenchCandidates : [])
        ];
        dup = allCandidatesPool.find(c => {
          const cEmail = (c.Contact?.Email || c.email || '').toLowerCase().trim();
          const pEmail = (parsed.Email || parsed.ExtractedEmail || '').toLowerCase().trim();
          if (pEmail && cEmail && cEmail === pEmail) return true;

          const cLinkedIn = (c.LinkedInUrl || c.linkedin_url || '').toLowerCase().trim();
          const pLinkedIn = (parsed.LinkedInUrl || '').toLowerCase().trim();
          if (pLinkedIn && cLinkedIn && (cLinkedIn === pLinkedIn || cLinkedIn.includes(pLinkedIn) || pLinkedIn.includes(cLinkedIn))) return true;

          const cPhone = (c.Contact?.Phone || c.phone || c.Mobile || c.mobile || '').replace(/\D/g, '').slice(-10);
          const pPhone = (parsed.Phone || parsed.Mobile || parsed.ExtractedPhone || '').replace(/\D/g, '').slice(-10);
          if (pPhone && cPhone && pPhone.length >= 7 && cPhone === pPhone) return true;

          return false;
        });
      }

      setShowParsingLoading(false);

      if (dup) {
        setParsedResumeData(parsed);
        setDuplicateCandidate(dup);
        setShowDuplicateModal(true);
      } else {
        setParsedResumeData(parsed);
        setEditingCandidate(null);
        setShowAddModal(true);
      }

    } catch (error) {
      console.error('Error parsing resume:', error);
      setShowParsingLoading(false);
      Swal.fire({ title: 'Error', text: error.message || 'Failed to parse resume. Please try again or add candidate manually.', icon: 'error' });
    } finally {
      setParsingFromToolbar(false);
      setPendingParseFile(null);
    }
  };

  const handleDuplicateAction = async (action) => {
    setShowDuplicateModal(false);

    if (action === 'cancel') {
      setParsedResumeData(null);
      setDuplicateCandidate(null);
      return;
    }

    // Direct 1-click execution for "Add resume and don't update candidate"
    if (action === 'add_resume') {
      const candidateId = duplicateCandidate.CandidateId || duplicateCandidate.candidate_id;
      try {
        Swal.fire({
          title: 'Adding Resume...',
          text: 'Attaching new resume to candidate profile',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        const formData = new FormData();
        if (parsedResumeData?.ResumeFile) {
          formData.append('ResumeUpload', parsedResumeData.ResumeFile);
        }
        if (currentView === 'bench') {
          formData.append('IsBench', 'true');
        }

        const response = await fetch(`${BASE_URL}/api/resumes/${candidateId}`, {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
          body: formData,
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error || 'Failed to add resume');
        }

        _cachedCandidates = null;
        _cachedBenchCandidates = null;
        try {
          localStorage.removeItem('cm_cached_candidates');
        } catch (_) { }
        await fetchCandidates(true);

        Swal.fire({
          title: 'Success!',
          text: 'New resume added to candidate successfully.',
          icon: 'success',
          timer: 1800,
          showConfirmButton: false
        });
      } catch (err) {
        console.error('Error adding resume directly:', err);
        Swal.fire('Error', err.message || 'Failed to add resume.', 'error');
      } finally {
        setParsedResumeData(null);
        setDuplicateCandidate(null);
      }
      return;
    }

    let fullDuplicateCandidate = duplicateCandidate;
    try {
      Swal.fire({ title: 'Loading...', text: 'Fetching candidate details', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const response = await fetch(`${BASE_URL}/api/resumes/${duplicateCandidate.CandidateId || duplicateCandidate.candidate_id}`, { headers: getAuthHeaders() });
      if (response.ok) {
        const data = await response.json();
        fullDuplicateCandidate = transformCandidate(data);
      }
      Swal.close();
    } catch (e) {
      console.error('Error fetching duplicate candidate full details:', e);
      Swal.close();
    }

    if (action === 'overwrite') {
      const synthCandidate = {
        ...fullDuplicateCandidate,
        _skipFetch: true,
        _overwriteResume: true,
        ...(currentView === 'bench' ? { IsBench: true, is_bench: true } : {})
      };

      // Overwrite primitive fields from parsedResumeData
      for (const [key, value] of Object.entries(parsedResumeData)) {
        if ((typeof value === 'string' && value.trim() !== '') || typeof value === 'number') {
          const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
          synthCandidate[pascalKey] = value;
          synthCandidate[key] = value;
        }
      }

      // Overwrite arrays entirely
      if (parsedResumeData.skills?.length) {
        synthCandidate.Skills = parsedResumeData.skills.map(s => ({ ...s }));
      }
      if (parsedResumeData.workExperience?.length) {
        synthCandidate.WorkExperience = parsedResumeData.workExperience.map(w => ({ ...w }));
      }
      if (parsedResumeData.education?.length) {
        synthCandidate.Education = parsedResumeData.education.map(e => ({ ...e }));
      }
      if (parsedResumeData.certifications?.length) {
        synthCandidate.Certifications = parsedResumeData.certifications.map(c => ({ ...c }));
      }

      setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
      setEditingCandidate(synthCandidate);
      setShowAddModal(true);
    }
    else if (action === 'append') {
      const synthCandidate = {
        ...fullDuplicateCandidate,
        _skipFetch: true,
        ...(currentView === 'bench' ? { IsBench: true, is_bench: true } : {})
      };

      for (const [key, value] of Object.entries(parsedResumeData)) {
        if ((typeof value === 'string' && value.trim() !== '') || typeof value === 'number') {
          const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
          synthCandidate[pascalKey] = value;
          synthCandidate[key] = value;
        }
      }

      // De-duplicate skills by SkillName
      const existingSkillNames = new Set(
        (fullDuplicateCandidate.Skills || []).map(s => (s.SkillName || s.skillName || '').toLowerCase().trim()).filter(Boolean)
      );
      const newUniqueSkills = (parsedResumeData.skills || []).filter(
        s => !existingSkillNames.has((s.SkillName || s.skillName || '').toLowerCase().trim())
      );
      synthCandidate.Skills = [...(fullDuplicateCandidate.Skills || []), ...newUniqueSkills];

      synthCandidate.WorkExperience = [...(fullDuplicateCandidate.WorkExperience || []), ...(parsedResumeData.workExperience || [])];
      synthCandidate.Education = [...(fullDuplicateCandidate.Education || []), ...(parsedResumeData.education || [])];
      synthCandidate.Certifications = [...(fullDuplicateCandidate.Certifications || []), ...(parsedResumeData.certifications || [])];

      setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
      setEditingCandidate(synthCandidate);
      setShowAddModal(true);
    }
  };

  const handleCheckInCandidate = useCallback((cand) => {
    setShowDuplicateModal(false);
    setPendingParseFile(null);
    setParsedResumeData(null);
    setDuplicateCandidate(null);

    const isBench = Boolean(
      cand?.IsBench === true ||
      cand?.is_bench === true ||
      cand?.IsBench === 1 ||
      cand?.is_bench === 1 ||
      cand?.IsBench === 'true' ||
      cand?.is_bench === 'true'
    );
    const targetView = isBench ? 'bench' : 'sourcing';
    const candName = `${cand?.FirstName || cand?.first_name || ''} ${cand?.LastName || cand?.last_name || ''}`.trim();
    const candCode = cand?.CandidateCode || cand?.candidate_code || '';
    const searchTarget = candName || candCode;

    // Set search term for target view in session storage
    sessionStorage.setItem(`cm_searchTerm_${targetView}`, searchTarget);
    sessionStorage.setItem(`cm_jobTitleSearch_${targetView}`, '');
    sessionStorage.setItem(`cm_jobTitleTags_${targetView}`, '[]');

    // Update viewSearches state
    setViewSearches(prev => ({
      ...prev,
      [targetView]: {
        searchTerm: searchTarget,
        jobTitleSearch: '',
        jobTitleTags: []
      }
    }));

    // Update active search inputs and filters
    setSearchTerm(searchTarget);
    setDebouncedSearchTerm(searchTarget);
    setDebouncedJobTitleSearch('');
    setJobTitleTags([]);
    setIsTypingSearching(false);
    setAiSearchResults(null);
    setAdvancedFilters({ rows: [], logic: 'AND' });
    setCurrentPage(1);

    setSidebarFilters(prev => ({
      ...prev,
      search: searchTarget,
      status: [],
      recruiter: '',
      sourceType: 'all',
      workType: [],
      experience: 'all',
      country: '',
      state: '',
      city: '',
      sources: [],
      employmentTypes: [],
      industries: [],
      isBench: 'all',
      personType: 'all',
      gender: [],
      relocate: 'all',
      workAuth: []
    }));

    if (currentView === targetView) {
      fetchCandidates(false);
    } else {
      navigate(`/resume-dashboard?view=${targetView}&search=${encodeURIComponent(searchTarget)}`);
    }
  }, [currentView, fetchCandidates, navigate, setSearchTerm, setJobTitleTags]);

  // ── Resume upload / extract ──
  const handleResumeUpload = async (file) => {
    try {
      setUploadingResume(true);
      const formData = new FormData();
      formData.append('file1', file);

      const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: formData
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || errData.error || 'Failed to parse resume');
      }

      const data = await response.json();
      return {
        FirstName: formatName(data.firstName || ''),
        LastName: formatName(data.lastName || ''),
        MiddleName: formatName(data.middleName || ''),
        Email: data.email || '',
        Phone: data.phone || '',
        Mobile: data.mobile || '',
        TwitterUrl: data.twitterUrl || '',
        VideoResumeUrl: data.videoResumeUrl || '',
        JobTitle: formatJobTitle(data.jobTitle || ''),
        YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
        ProfileSummary: data.profileSummary || '',
        LinkedInUrl: data.linkedInUrl || '',
        GitHubUrl: data.gitHubUrl || '',
        Gender: data.gender || '',
        CurrentLocation: data.currentLocation || '',
        cityName: data.cityName || '',
        stateName: data.stateName || '',
        countryIso2: data.countryIso2 || '',
        countryName: data.countryName || '',
        WorkAuthorization: data.workAuthorization || '',
        EmploymentType: data.employmentType || '',
        Skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
        WorkExperience: (data.workExperience || []).map(exp => ({
          Company: exp.company || '',
          JobTitle: formatJobTitle(exp.jobTitle || ''),
          StartDate: exp.startDate || '',
          EndDate: exp.endDate || '',
          IsCurrent: exp.isCurrent || false,
          Description: exp.description || '',
        })),
        Education: (data.education || []).map(edu => ({
          Institution: formatName(edu.institution || ''),
          Degree: formatName(edu.degree || ''),
          FieldOfStudy: edu.fieldOfStudy || '',
          StartDate: edu.startDate || '',
          EndDate: edu.endDate || '',
          GPA: edu.gpa || '',
        })),
        Certifications: (data.certifications || []).map(cert => ({
          CertificationName: formatName(cert.name || ''),
          IssuingOrganization: cert.issuingOrg || '',
          IssueDate: cert.issueDate || '',
          ExpiryDate: cert.expiryDate || '',
          CredentialId: cert.credentialId || '',
          CredentialUrl: cert.credentialUrl || '',
        })),
        RawPayloadJson: JSON.stringify(data),
        ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
        ParsedText: data.parsedText || data.parsed_text || '',
        ParserVendor: data.vendor || 'llama-3.1-8b-instant',
        ExtractedEmail: data.email || data.extracted_email || '',
        ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
      };
    } catch (error) {
      console.error('Error parsing resume:', error);
      Swal.fire({ title: 'Error', text: error.message || 'Failed to parse resume. Please fill the form manually.', icon: 'error' });
      return null;
    } finally {
      setUploadingResume(false);
    }
  };

  // ── Save candidate ──
  const handleSaveCandidate = async (data) => {
    try {
      setUploadingResume(true);

      if (data.currentLocation && data.currentLocation.trim()) {
        const parts = data.currentLocation.split(',').map(s => s.trim()).filter(Boolean);
        console.log(`📍 Location being saved: "${data.currentLocation}" (${parts.length} parts)`);
      }

      const isEditing = !!(editingCandidate?.CandidateId || data.candidateId);
      const candidateId = editingCandidate?.CandidateId || data.candidateId;

      const formData = new FormData();

      const firstName = formatName(data.firstName || data.FirstName || '');
      const lastName = formatName(data.lastName || data.LastName || '');
      const middleName = formatName(data.middleName || data.MiddleName || '');
      const jobTitle = formatJobTitle(data.jobTitle || data.JobTitle || '');

      formData.append('FirstName', firstName);
      formData.append('LastName', lastName);
      formData.append('MiddleName', middleName);
      formData.append('EmailID', (data.email || data.Email || '').trim());
      formData.append('Phone', (data.phone || data.Phone || '').trim());
      formData.append('Mobile', (data.mobile || data.Mobile || '').trim());
      formData.append('JobTitle', jobTitle);
      formData.append('YearsOfExperience', data.yearsOfExperience ?? data.YearsOfExperience ?? '');
      formData.append('Gender', (data.gender || data.Gender || '').trim());
      formData.append('ProfileSummary', (data.profileSummary || data.ProfileSummary || '').trim());
      formData.append('LinkedInProfile', (data.linkedInUrl || data.LinkedInUrl || '').trim());
      formData.append('GitHubUrl', (data.gitHubUrl || data.GitHubUrl || '').trim());
      formData.append('TwitterUrl', (data.twitterUrl || data.TwitterUrl || '').trim());
      formData.append('VideoResumeUrl', (data.videoResumeUrl || data.VideoResumeUrl || '').trim());
      formData.append('CandidateStatus', data.candidateStatus || data.CandidateStatus || 'Available');
      formData.append('RemoteStatus', data.remoteStatus || data.RemoteStatus || 'OnSite');
      formData.append('CurrentLocation', (data.currentLocation || data.CurrentLocation || '').trim());

      formData.append('WorkAuthorization', data.workAuthorization || data.WorkAuthorization || '');
      formData.append('EmploymentType', data.employmentType || data.EmploymentType || '');
      formData.append('SecurityClearance', data.securityClearance || data.SecurityClearance || '');
      formData.append('WillingToRelocate', data.willingToRelocate ? 'true' : 'false');
      formData.append('IsBench', data.isBench ? 'true' : 'false');
      formData.append('ExpectedRateFrom', data.expectedRateFrom || data.ExpectedRateFrom || '');
      formData.append('ExpectedRateTo', data.expectedRateTo || data.ExpectedRateTo || '');
      formData.append('ExpectedRateType', data.expectedRateType || data.ExpectedRateType || 'Hourly');
      formData.append('CurrentRate', data.currentRate || data.CurrentRate || '');
      formData.append('CurrentRateType', data.currentRateType || data.CurrentRateType || 'Hourly');
      formData.append('MaritalStatus', data.maritalStatus || data.MaritalStatus || '');
      formData.append('Industry', data.industry || data.Industry || '');
      formData.append('CurrentEmployer', data.currentEmployer || data.CurrentEmployer || '');
      formData.append('CurrentSalary', data.currentSalary || data.CurrentSalary || '');
      formData.append('ExpectedSalary', data.expectedSalary || data.ExpectedSalary || '');
      formData.append('NoticePeriod', data.noticePeriod || data.NoticePeriod || '');

      // Bench Details
      formData.append('BenchPriority', data.benchPriority || data.BenchPriority || data.PriorityCode || '');
      formData.append('OutOfJobSince', data.outOfJobSince || data.OutOfJobSince || '');
      formData.append('NewJobDeadline', data.newJobDeadline || data.NewJobDeadline || '');
      formData.append('RecentPlacementDate', data.recentPlacementDate || data.RecentPlacementDate || '');
      formData.append('WorkAuthPetitioner', data.workAuthPetitioner || data.WorkAuthPetitioner || '');
      formData.append('WorkAuthExpiryDate', data.workAuthExpiryDate || data.WorkAuthExpiryDate || '');
      formData.append('BenchAssignee', data.benchAssignee || data.BenchAssignee || '');
      formData.append('BenchAssigneeUserId', data.benchAssigneeUserId || data.BenchAssigneeUserId || '');
      if (Array.isArray(data.benchAssignees || data.BenchAssignees)) {
        formData.append('BenchAssignees', JSON.stringify(data.benchAssignees || data.BenchAssignees));
      }
      formData.append('CurrentClientName', data.currentClientName || data.CurrentClientName || '');
      formData.append('ReasonForLeaving', data.reasonForLeaving || data.ReasonForLeaving || '');
      formData.append('ReferenceText', data.referenceText || data.ReferenceText || '');
      formData.append('Remarks', data.remarks || data.Remarks || '');
      if (data.h1bTransferWilling !== undefined || data.H1BTransferWilling !== undefined) {
        formData.append('H1BTransferWilling', (data.h1bTransferWilling || data.H1BTransferWilling) ? 'true' : 'false');
      }
      formData.append('I140Status', data.i140Status || data.I140Status || '');
      formData.append('I140PriorityDate', data.i140PriorityDate || data.I140PriorityDate || '');
      formData.append('C2CCorpName', data.c2cCorpName || data.C2CCorpName || '');
      formData.append('C2CFEIN', data.c2cFEIN || data.C2CFEIN || '');
      formData.append('C2CStructure', data.c2cStructure || data.C2CStructure || '');

      const skillsList = (data.skills || data.Skills || []).map(s => {
        if (typeof s === 'string') return { SkillName: s.trim(), SkillType: 'Intermediate' };
        return {
          SkillName: (s.SkillName || s.skillName || '').trim(),
          SkillType: s.SkillType || s.skillType || 'Intermediate'
        };
      }).filter(s => s.SkillName);
      formData.append('Skills', JSON.stringify(skillsList));

      const workList = (data.workExperience || data.WorkExperience || [])
        .filter(w => (w.company || w.Company || '').trim() || (w.jobTitle || w.JobTitle || '').trim())
        .map(exp => ({
          Company: (exp.company || exp.Company || '').trim(),
          JobTitle: formatJobTitle(exp.jobTitle || exp.JobTitle || ''),
          StartDate: exp.startDate || exp.StartDate || '',
          EndDate: exp.endDate || exp.EndDate || '',
          IsCurrent: exp.isCurrent ?? exp.IsCurrent ?? false,
          Description: (exp.description || exp.Description || '').trim(),
        }));
      formData.append('WorkExperience', JSON.stringify(workList));

      const eduList = (data.education || data.Education || [])
        .filter(e => (e.institution || e.Institution || '').trim() || (e.degree || e.Degree || '').trim())
        .map(edu => ({
          Institution: formatName(edu.institution || edu.Institution || ''),
          Degree: formatName(edu.degree || edu.Degree || ''),
          FieldOfStudy: (edu.fieldOfStudy || edu.FieldOfStudy || '').trim(),
          StartDate: edu.startDate || edu.StartDate || '',
          EndDate: edu.endDate || edu.EndDate || '',
          GPA: (edu.gpa || edu.GPA || '').trim(),
        }));
      formData.append('Education', JSON.stringify(eduList));

      const certList = (data.certifications || data.Certifications || [])
        .filter(c => (c.name || c.CertificationName || '').trim())
        .map(cert => ({
          CertificationName: formatName(cert.name || cert.CertificationName || ''),
          IssuingOrganization: (cert.issuingOrg || cert.IssuingOrganization || '').trim(),
          IssueDate: cert.issueDate || cert.IssueDate || '',
          ExpiryDate: cert.expiryDate || cert.ExpiryDate || '',
          CredentialId: (cert.credentialId || cert.CredentialId || '').trim(),
          CredentialUrl: (cert.credentialUrl || cert.CredentialUrl || '').trim(),
        }));
      formData.append('Certifications', JSON.stringify(certList));

      if (data.ResumeFile) {
        formData.append('ResumeUpload', data.ResumeFile);
      }

      if (editingCandidate?._overwriteResume) {
        formData.append('OverwriteResume', 'true');
      }

      if (data.RawPayloadJson) formData.append('RawPayloadJson', data.RawPayloadJson);
      if (data.ParseStatus) formData.append('ParseStatus', data.ParseStatus);
      if (data.ParsedText) formData.append('ParsedText', data.ParsedText);
      if (data.ParserVendor) formData.append('ParserVendor', data.ParserVendor);
      if (data.ExtractedEmail) formData.append('ExtractedEmail', data.ExtractedEmail);
      if (data.ExtractedPhone) formData.append('ExtractedPhone', data.ExtractedPhone);

      const additionalDocs = (data.documents || []).filter(d => d.file instanceof File);
      let docIndex = 0;
      for (const doc of additionalDocs) {
        formData.append(`AdditionalDoc_${docIndex}`, doc.file);
        formData.append(`AdditionalDoc_${docIndex}_Name`, doc.documentName || doc.file.name);
        formData.append(`AdditionalDoc_${docIndex}_Type`, doc.documentType || 'Certificate');
        docIndex++;
      }
      formData.append('AdditionalDocsCount', String(docIndex));

      const url = isEditing
        ? `${BASE_URL}/api/resumes/${candidateId}`
        : `${BASE_URL}/api/resumes`;

      const response = await fetch(url, {
        method: isEditing ? 'PUT' : 'POST',
        headers: getAuthHeaders(),
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || errorData.detail || 'Failed to save candidate');
      }

      _cachedCandidates = null;
      try {
        localStorage.removeItem('cm_cached_candidates');
      } catch (e) { }
      await fetchCandidates(true);
      setShowAddModal(false);
      setEditingCandidate(null);
      setParsedResumeData(null);
      Swal.fire({ title: 'Success!', text: 'Candidate saved successfully.', icon: 'success', timer: 1800, showConfirmButton: false });

    } catch (error) {
      console.error('Error saving candidate:', error);
      Swal.fire({ title: 'Error', text: error.message || 'Failed to save candidate', icon: 'error' });
    } finally {
      setUploadingResume(false);
    }
  };

  const exportToExcel = () => {
    setExporting(true);
    const data = filteredCandidates.map(c => ({
      'Candidate Code': c.CandidateCode,
      'First Name': c.FirstName,
      'Last Name': c.LastName,
      'Middle Name': c.MiddleName || '',
      'Job Title': c.JobTitle,
      'Email': c.Contact?.Email || '',
      'Phone': c.Contact?.Phone || '',
      'Mobile': c.Mobile || '',
      'Twitter URL': c.TwitterUrl || '',
      'Video Resume URL': c.VideoResumeUrl || '',
      'Years of Experience': c.YearsOfExperience,
      'Gender': c.Gender,
      'Candidate Status': c.CandidateStatus,
      'Remote Status': c.RemoteStatus,
      'Work Authorization': c.WorkAuthorization || '',
      'Employment Type': c.EmploymentType || '',
      'Security Clearance': c.SecurityClearance || '',
      'Willing to Relocate': c.WillingToRelocate ? 'Yes' : 'No',
      'Expected Rate From': c.ExpectedRateFrom || '',
      'Expected Rate To': c.ExpectedRateTo || '',
      'Expected Rate Type': c.ExpectedRateType || '',
      'Current Rate': c.CurrentRate || '',
      'Current Rate Type': c.CurrentRateType || '',
      'Marital Status': c.MaritalStatus || '',
      'Industry': c.Industry || '',
      'Current Employer': c.CurrentEmployer || '',
      'Current Salary': c.CurrentSalary || '',
      'Expected Salary': c.ExpectedSalary || '',
      'Notice Period': c.NoticePeriod || '',
      'LinkedIn': c.LinkedInUrl || '',
      'GitHub': c.GitHubUrl || '',
      'Location': c.CurrentLocation || '',
      'Profile Summary': c.ProfileSummary || '',
      'Skills': (c.Skills || []).map(s => s.SkillName || s).join(', '),
      'Resume File': c.Document?.FileNameOriginal || '',
      'Created Date': formatDate(c.CreatedDt),
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Candidates');
    XLSX.writeFile(wb, `candidates_${new Date().toISOString().split('T')[0]}.xlsx`);
    setExporting(false);
    Swal.fire({ title: 'Exported!', text: `${data.length} candidates exported.`, icon: 'success', timer: 1800, showConfirmButton: false });
  };

  return (
    <div className="cm-dashboard" style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: '24px' }}>
      {/* Header Area */}
      <div style={{ padding: '16px 32px 12px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#111827', margin: 0, lineHeight: 1.2 }}>
            {currentView === 'sourcing' ? 'Sourcing' :
              currentView === 'bench' ? 'Bench Candidates' :
                currentView === 'review' ? 'Need To Review' :
                  'Candidates'}
          </h1>
          <p style={{ color: '#6b7280', fontSize: '14px', margin: '4px 0 0 0' }}>
            {currentView === 'sourcing' ? 'Explore active sourcing candidates' :
              currentView === 'bench' ? 'Manage bench candidates' :
                currentView === 'review' ? 'Review candidates with missing information' :
                  'Manage and explore your candidate database'}
          </p>
        </div>

        <div className="cm-toolbar-actions" style={{ flexWrap: 'wrap', borderBottom: 'none' }}>
          {selectedCandidateIds.length > 0 && (
            <button
              className="cm-btn cm-btn-primary"
              style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd', marginRight: '8px' }}
              onClick={() => {
                const selectedCands = candidates.filter(c => selectedCandidateIds.includes(c.CandidateId));
                setShareModalCandidates(selectedCands);
                setShowShareModal(true);
              }}
            >
              <Share2 size={16} /> {selectedCandidateIds.length > 1 ? 'Share Bulk Profile' : 'Share Profile'}
            </button>
          )}

          {selectedCandidateIds.length > 0 && (
            <button
              className="cm-btn cm-btn-primary"
              style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', marginRight: '8px' }}
              onClick={() => {
                const selectedCands = candidates.filter(c => selectedCandidateIds.includes(c.CandidateId));
                setSubmitCandidates(selectedCands);
                setShowSubmitModal(true);
              }}
            >
              <Send size={16} /> {selectedCandidateIds.length > 1 ? 'Submit Bulk Resume' : 'Submit Profile'}
            </button>
          )}

          {selectedCandidateIds.length > 0 && (
            <button
              className="cm-btn cm-btn-primary"
              style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd', marginRight: '8px' }}
              onClick={() => {
                setIsBulkEmailingCandidates(true);
                const selectedCands = candidates.filter(c => selectedCandidateIds.includes(c.CandidateId));
                setShareModalCandidates(selectedCands);
                setShowShareModal(true);
              }}
            >
              <Share2 size={16} /> {selectedCandidateIds.length > 1 ? 'Send Bulk Email' : 'Send Email'}
            </button>
          )}

          <button className="cm-btn cm-btn-primary" style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd' }} onClick={() => { setEditingCandidate(null); setParsedResumeData(null); setShowAddModal(true); }}>
            <Plus size={16} /> Add Candidate
          </button>
          <button
            className="cm-btn cm-btn-outline"
            onClick={() => parseFileInputRef.current?.click()}
            disabled={parsingFromToolbar}
          >
            {parsingFromToolbar
              ? <><Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> Parsing...</>
              : <><Upload size={16} /> Parse Resume</>}
          </button>
          <input
            ref={parseFileInputRef}
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            style={{ display: 'none' }}
            onChange={handleParseFileSelect}
          />
          <button className="cm-btn cm-btn-outline" onClick={exportToExcel} disabled={exporting}>
            <Download size={16} /> {exporting ? 'Exporting...' : 'Export'}
          </button>

          <button
            className="cm-btn cm-btn-outline"
            title="Refresh Candidate List"
            onClick={() => fetchCandidates(true)}
            style={{ padding: '0 10px' }}
          >
            <RotateCcw size={16} />
          </button>

          <button className="cm-btn cm-btn-outline" title="Manage Columns" onClick={() => setShowColumnSidebar(true)} style={{ padding: '0 10px' }}>
            <SlidersHorizontal size={16} />
          </button>

          <button
            className={`cm-btn cm-btn-outline ${showFilterSidebar ? 'cm-btn-icon--active' : ''}`}
            title={showFilterSidebar ? "Close Sidebar" : "Open Sidebar"}
            onClick={() => setShowFilterSidebar(prev => !prev)}
            style={{ padding: '0 10px' }}
          >
            {showFilterSidebar ? <Filter size={16} /> : <Filter size={16} />}
          </button>

          {/* <button
            className={`cm-btn cm-btn-outline ${advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? 'cm-btn-icon--active' : ''}`}
            title="Filters"
            onClick={() => setShowFilterModal(true)}
            style={{
              padding: '0 10px', ...(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? {
                background: '#eff6ff', border: '1px solid #60a5fa', color: '#3b5bfd'
              } : {})
            }}
          >
            <Filter size={16} />
            {advancedFilters.rows.filter(r => r.field && r.condition).length > 0 && (
              <span style={{
                position: 'absolute', top: -4, right: -4,
                width: 16, height: 16, borderRadius: '50%',
                background: '#3b5bfd', color: '#fff',
                fontSize: 9, fontWeight: 800,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {advancedFilters.rows.filter(r => r.field && r.condition).length}
              </span>
            )}
          </button> */}

          <button
            className={`cm-ask-ai-btn ${showAiSidebar ? 'cm-ask-ai-btn--active' : ''}`}
            title="Ask AI"
            onClick={() => setShowAiSidebar(prev => !prev)}
            style={{ marginLeft: '4px' }}
          >
            <Sparkles size={15} />
            Ask AI
          </button>
        </div>
      </div>

      {/* Source Type Tabs: By Recruiter / By Career Portal (Commented out as requested)
      <div style={{
        margin: '0 32px 14px 32px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        borderBottom: '1px solid #e2e8f0',
        paddingBottom: '10px'
      }}>
        <button
          type="button"
          onClick={() => { setCandidateSourceTab('all'); setCurrentPage(1); }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '7px 16px',
            borderRadius: '6px',
            border: candidateSourceTab === 'all' ? '1px solid #3b5bfd' : '1px solid #e2e8f0',
            background: candidateSourceTab === 'all' ? '#f0fdf9' : '#fff',
            color: candidateSourceTab === 'all' ? '#2563eb' : '#64748b',
            fontWeight: candidateSourceTab === 'all' ? 600 : 500,
            fontSize: '13px',
            cursor: 'pointer',
            transition: 'all 0.15s ease'
          }}
        >
          <Users size={15} />
          All Candidates
          <span style={{
            background: candidateSourceTab === 'all' ? '#3b5bfd' : '#f1f5f9',
            color: candidateSourceTab === 'all' ? '#fff' : '#475569',
            padding: '1px 7px',
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: 700
          }}>
            {sourceStats.all}
          </span>
        </button>

        <button
          type="button"
          onClick={() => { setCandidateSourceTab('recruiter'); setCurrentPage(1); }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '7px 16px',
            borderRadius: '6px',
            border: candidateSourceTab === 'recruiter' ? '1px solid #3b5bfd' : '1px solid #e2e8f0',
            background: candidateSourceTab === 'recruiter' ? '#f0fdf9' : '#fff',
            color: candidateSourceTab === 'recruiter' ? '#2563eb' : '#64748b',
            fontWeight: candidateSourceTab === 'recruiter' ? 600 : 500,
            fontSize: '13px',
            cursor: 'pointer',
            transition: 'all 0.15s ease'
          }}
        >
          <UserCheck size={15} />
          By Recruiter
          <span style={{
            background: candidateSourceTab === 'recruiter' ? '#3b5bfd' : '#f1f5f9',
            color: candidateSourceTab === 'recruiter' ? '#fff' : '#475569',
            padding: '1px 7px',
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: 700
          }}>
            {sourceStats.recruiter}
          </span>
        </button>

        <button
          type="button"
          onClick={() => { setCandidateSourceTab('career_portal'); setCurrentPage(1); }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '7px 16px',
            borderRadius: '6px',
            border: candidateSourceTab === 'career_portal' ? '1px solid #3b5bfd' : '1px solid #e2e8f0',
            background: candidateSourceTab === 'career_portal' ? '#f0fdf9' : '#fff',
            color: candidateSourceTab === 'career_portal' ? '#2563eb' : '#64748b',
            fontWeight: candidateSourceTab === 'career_portal' ? 600 : 500,
            fontSize: '13px',
            cursor: 'pointer',
            transition: 'all 0.15s ease'
          }}
        >
          <Globe size={15} />
          By Career Portal
          <span style={{
            background: candidateSourceTab === 'career_portal' ? '#3b5bfd' : '#f1f5f9',
            color: candidateSourceTab === 'career_portal' ? '#fff' : '#475569',
            padding: '1px 7px',
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: 700
          }}>
            {sourceStats.careerPortal}
          </span>
        </button>
      </div>
      */}

      {/* Search & Saved Filters Area */}
      <div style={{ margin: '0 32px 12px 32px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* Top Row: Dual Search Inputs (Keyword Search + Job Title Search) */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch', flexWrap: 'wrap' }}>

          {/* Search Bar 1: Keyword / Skill Search */}
          <div
            className="cm-modern-search-bar"
            style={{
              flex: '1.2 1 480px',
              display: 'flex', alignItems: 'center',
              border: '1px solid #e2e8f0', borderRadius: '8px',
              padding: '4px 8px 4px 16px', height: 'auto',
              minHeight: '40px', flexWrap: 'wrap', gap: '6px',
              transition: 'all 0.2s ease', background: '#fff',
              boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
            }}
            onFocus={(e) => { e.currentTarget.style.borderColor = '#3b5bfd'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 91, 253, 0.15)'; }}
            onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.02)'; }}
          >
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', marginRight: '10px', flexShrink: 0 }}>
              <Search
                size={17}
                color={useAiSearch ? "#3b5bfd" : "#64748b"}
                className={isAiSearching ? "cm-pulse" : ""}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (useAiSearch) {
                    handleAiSearch(searchTerm);
                  } else {
                    if (searchTerm.trim()) {
                      const tag = searchTerm.trim();
                      const current = sidebarFilters.skills || [];
                      if (!current.includes(tag)) {
                        setSidebarFilters(prev => ({ ...prev, skills: [...current, tag] }));
                      }
                      setSearchTerm('');
                    }
                    setAiSearchResults(null);
                    setCurrentPage(1);
                  }
                }}
                title={useAiSearch ? "Search with AI" : "Search by keyword"}
              />
              <Sparkles
                size={8}
                color="#3b5bfd"
                style={{
                  position: 'absolute', top: -3, right: -4,
                  animation: 'cm-spin 4s linear infinite',
                  opacity: 0.8
                }}
              />
            </div>

            {/* Active search tag badges rendered inside the input bar */}
            {(sidebarFilters.skills || []).map(tag => (
              <span
                key={tag}
                className="filter-tag"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  background: '#eff6ff',
                  color: '#2563eb',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: 500,
                  border: '1px solid #dbeafe',
                  flexShrink: 0,
                  cursor: 'pointer'
                }}
                onClick={() => {
                  const updated = (sidebarFilters.skills || []).filter(item => item !== tag);
                  setSidebarFilters(prev => ({ ...prev, skills: updated }));
                  setSearchTerm(tag);
                }}
              >
                {tag}
                <X
                  size={12}
                  className="filter-tag-close"
                  style={{ cursor: 'pointer', color: '#94a3b8' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const updated = (sidebarFilters.skills || []).filter(item => item !== tag);
                    setSidebarFilters(prev => ({ ...prev, skills: updated }));
                  }}
                />
              </span>
            ))}

            <input
              className="cm-search-input-modern"
              placeholder={useAiSearch ? "Ask AI for semantic search..." : "Search by keyword..."}
              value={searchTerm}
              onChange={e => {
                const val = e.target.value;
                setSearchTerm(val);
                if (!useAiSearch) {
                  if (!val) setAiSearchResults(null);
                  setCurrentPage(1);
                }
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  if (useAiSearch) {
                    handleAiSearch(searchTerm);
                  } else {
                    if (searchTerm.trim()) {
                      const tag = searchTerm.trim();
                      const current = sidebarFilters.skills || [];
                      if (!current.includes(tag)) {
                        setSidebarFilters(prev => ({ ...prev, skills: [...current, tag] }));
                      }
                      setSearchTerm('');
                      setDebouncedSearchTerm('');
                      setIsTypingSearching(false);
                    }
                    setAiSearchResults(null);
                    setCurrentPage(1);
                  }
                }
              }}
              style={{
                border: 'none', outline: 'none', background: 'transparent',
                flex: 1, fontSize: '14px', color: '#0f172a', height: '100%',
                minWidth: '120px', fontFamily: 'inherit'
              }}
            />
            {(isTypingSearching && searchTerm !== debouncedSearchTerm) && (
              <div style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
                <Loader size={14} style={{ animation: 'cm-spin 1s linear infinite', color: '#3b5bfd' }} />
              </div>
            )}
            {isAiSearching && (
              <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                <Loader size={14} style={{ animation: 'cm-spin 1s linear infinite', color: '#3b5bfd' }} />
              </div>
            )}
            {/* Commented out AI Search button
            <div style={{ width: '1px', height: '20px', background: '#e2e8f0', margin: '0 8px' }}></div>
            <button
              onClick={() => {
                const next = !useAiSearch;
                setUseAiSearch(next);
                if (!next) setAiSearchResults(null);
              }}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                padding: '4px 12px', border: useAiSearch ? '1px solid #60a5fa' : '1px solid #e2e8f0',
                borderRadius: '20px', background: useAiSearch ? '#eff6ff' : '#fff',
                color: useAiSearch ? '#3b5bfd' : '#64748b', fontSize: '12px',
                fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease',
                marginRight: '8px'
              }}
            >
              <Sparkles size={13} color={useAiSearch ? "#60a5fa" : "#94a3b8"} fill={useAiSearch ? "#60a5fa" : "none"} />
              AI Search: {useAiSearch ? 'ON' : 'OFF'}
            </button>
            */}

            {(searchTerm || jobTitleSearch || jobTitleTags.length > 0 || statusFilter !== 'all' ||
              sidebarFilters.status.length > 0 ||
              sidebarFilters.workType.length > 0 ||
              sidebarFilters.experience !== 'all' ||
              sidebarFilters.country ||
              sidebarFilters.state ||
              sidebarFilters.city ||
              sidebarFilters.sources.length > 0 ||
              sidebarFilters.employmentTypes.length > 0 ||
              sidebarFilters.industries.length > 0 ||
              sidebarFilters.isBench !== 'all' ||
              sidebarFilters.personType !== 'all' ||
              sidebarFilters.gender.length > 0 ||
              sidebarFilters.relocate !== 'all' ||
              sidebarFilters.workAuth.length > 0
            ) && (
                <button
                  onClick={handleResetFilters}
                  style={{
                    height: '28px',
                    borderRadius: '6px',
                    border: '1px solid #e74c3c',
                    background: '#fff5f5',
                    color: '#e74c3c',
                    fontSize: '12.5px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '0 10px',
                    flexShrink: 0
                  }}
                >
                  ✕ Clear All Filters
                </button>
              )}
          </div>

          {/* Search Bar 2: Dedicated Job Title Search */}
          <div
            className="cm-modern-search-bar"
            style={{
              flex: '1 1 320px',
              display: 'flex', alignItems: 'center',
              border: '1px solid #e2e8f0', borderRadius: '8px',
              padding: '4px 12px 4px 14px', height: 'auto',
              minHeight: '40px', gap: '8px',
              transition: 'all 0.2s ease', background: '#fff',
              boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
              flexWrap: 'wrap'
            }}
            onFocus={(e) => { e.currentTarget.style.borderColor = '#3b5bfd'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 91, 253, 0.15)'; }}
            onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.02)'; }}
          >
            <Briefcase size={16} color="#3b5bfd" style={{ flexShrink: 0 }} />

            {/* Active job title tag badges rendered inside the input bar */}
            {(jobTitleTags || []).map(tag => (
              <span
                key={tag}
                className="filter-tag"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  background: '#eff6ff',
                  color: '#2563eb',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: 500,
                  border: '1px solid #dbeafe',
                  flexShrink: 0,
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setJobTitleTags(prev => prev.filter(item => item !== tag));
                  setJobTitleSearch(tag);
                }}
              >
                {tag}
                <X
                  size={12}
                  className="filter-tag-close"
                  style={{ cursor: 'pointer', color: '#94a3b8' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setJobTitleTags(prev => prev.filter(item => item !== tag));
                  }}
                />
              </span>
            ))}

            <input
              className="cm-search-input-modern"
              placeholder={jobTitleTags.length > 0 ? "Add another title..." : "Search by job title..."}
              value={jobTitleSearch}
              onChange={e => {
                setJobTitleSearch(e.target.value);
                setCurrentPage(1);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  if (jobTitleSearch.trim()) {
                    const tag = jobTitleSearch.trim();
                    if (!jobTitleTags.some(t => t.toLowerCase() === tag.toLowerCase())) {
                      setJobTitleTags(prev => [...prev, tag]);
                    }
                    setJobTitleSearch('');
                    setDebouncedJobTitleSearch('');
                    setIsTypingSearching(false);
                    setCurrentPage(1);
                  }
                } else if (e.key === 'Backspace' && !jobTitleSearch && jobTitleTags.length > 0) {
                  setJobTitleTags(prev => prev.slice(0, -1));
                }
              }}
              style={{
                border: 'none', outline: 'none', background: 'transparent',
                flex: 1, fontSize: '14px', color: '#0f172a', height: '100%',
                minWidth: '110px', fontFamily: 'inherit'
              }}
            />
            {(isTypingSearching && jobTitleSearch !== debouncedJobTitleSearch) && (
              <div style={{ marginRight: '6px', display: 'flex', alignItems: 'center' }}>
                <Loader size={14} style={{ animation: 'cm-spin 1s linear infinite', color: '#3b5bfd' }} />
              </div>
            )}
            {(jobTitleSearch || jobTitleTags.length > 0) && (
              <button
                onClick={() => {
                  setJobTitleSearch('');
                  setDebouncedJobTitleSearch('');
                  setJobTitleTags([]);
                  setIsTypingSearching(false);
                  sessionStorage.removeItem(`cm_jobTitleSearch_${currentView}`);
                  sessionStorage.removeItem(`cm_jobTitleTags_${currentView}`);
                  setCurrentPage(1);
                }}
                style={{
                  background: 'none', border: 'none', color: '#94a3b8',
                  cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center',
                  borderRadius: '50%'
                }}
                onMouseOver={(e) => { e.currentTarget.style.color = '#ef4444'; }}
                onMouseOut={(e) => { e.currentTarget.style.color = '#94a3b8'; }}
                title="Clear job title"
              >
                <X size={14} />
              </button>
            )}
          </div>

        </div>

        {/* Bottom Area: Saved Searches */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none', flexShrink: 1, paddingBottom: '2px' }}>
            {savedSearches.map((s) => {
              const isActive = s.term === searchTerm && s.status === statusFilter;
              return (
                <button
                  key={s.id}
                  onClick={() => handleLoadSearch(s)}
                  style={{
                    fontSize: '12.5px',
                    padding: '0 8px 0 10px',
                    height: '26px',
                    borderRadius: '6px',
                    border: '1px solid transparent',
                    background: isActive ? '#3b5bfd' : '#f1f5f9',
                    color: isActive ? '#fff' : '#475569',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s ease',
                    fontWeight: isActive ? 500 : 400,
                    flexShrink: 0
                  }}
                  title={`Load search: ${s.term || 'All'} in ${s.status}`}
                  onMouseOver={(e) => { if (!isActive) { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; } }}
                  onMouseOut={(e) => { if (!isActive) { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#475569'; } }}
                >
                  <span>{s.term || 'All'} {s.status !== 'all' ? `(${s.status})` : ''}</span>
                  <span
                    onClick={(e) => { e.stopPropagation(); removeSavedSearch(s.id); }}
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      width: '18px', height: '18px', borderRadius: '4px', transition: 'all 0.2s',
                      color: isActive ? '#fff' : '#94a3b8'
                    }}
                    onMouseOver={(e) => { e.currentTarget.style.background = isActive ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.05)'; e.currentTarget.style.color = isActive ? '#fff' : '#0f172a'; }}
                    onMouseOut={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = isActive ? '#fff' : '#94a3b8'; }}
                  >
                    <X size={13} />
                  </span>
                </button>
              );
            })}
          </div>

          {savedSearches.length > 0 && (
            <button
              onClick={() => { setSavedSearches([]); localStorage.removeItem('erp_saved_searches'); }}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '12px', color: '#cbd5e1', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', transition: 'color 0.2s', padding: 0 }}
              onMouseOver={(e) => e.currentTarget.style.color = '#ef4444'}
              onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Main Content Layout */}
      <div style={{ display: 'flex', borderTop: '1px solid #e2e8f0', minHeight: 'calc(100vh - 180px)' }}>
        {/* Left Sidebar Filter */}
        {showFilterSidebar ? (
          <CandidateFilterSidebar
            loading={loading || isTypingSearching}
            totalCount={filteredCandidates.length}
            overallTotal={candidates.length}
            filters={sidebarFilters}
            setFilters={setSidebarFilters}
            onClearAll={handleResetFilters}
            availableStatuses={availableStatuses}
            availableRecruiters={availableRecruiters}
            availableWorkTypes={availableWorkTypes}
            availableLocations={availableLocations}
            availableSources={availableSources}
            availableEmploymentTypes={availableEmploymentTypes}
            availableIndustries={availableIndustries}
            availableWorkAuths={availableWorkAuths}
            availableGenders={availableGenders}
            onClose={() => setShowFilterSidebar(false)}
            visibleColumns={visibleSidebarFilters}
            setVisibleColumns={setVisibleSidebarFilters}
            currentView={currentView}
            sourceStats={sourceStats}
          />
        ) : (
          <div
            className="cm-sidebar-reopen-strip"
            onClick={() => setShowFilterSidebar(true)}
            title="Open Filters"
            style={{
              width: '12px',
              background: '#f1f5f9',
              borderRight: '1px solid #e2e8f0',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              position: 'relative',
              zIndex: 10
            }}
            onMouseOver={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.width = '20px'; }}
            onMouseOut={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.width = '12px'; }}
          >
            <div style={{
              transform: 'rotate(90deg)',
              whiteSpace: 'nowrap',
              fontSize: '10px',
              fontWeight: 700,
              color: '#64748b',
              letterSpacing: '0.1em',
              textTransform: 'uppercase'
            }}>
              Filters
            </div>
          </div>
        )}

        {/* Right Content Area */}
        <div style={{ flex: 1, minWidth: 0, padding: '0 0 24px 0' }}>
          {/* AI Search Active Indicator */}
          {aiSearchResults && (
            <div style={{
              padding: '10px 32px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: '#eff6ff',
              borderBottom: '1px solid #bfdbfe',
              animation: 'cm-slide-down 0.3s ease'
            }}>
              <Sparkles size={16} color="#3b5bfd" className="cm-pulse" />
              <span style={{ fontSize: '13px', color: '#3b5bfd', fontWeight: 600 }}>
                AI-Powered Search Active
              </span>
              <span style={{ fontSize: '12.5px', color: '#475569' }}>
                — {aiSearchResults.length} candidates ranked by semantic relevance
              </span>
              <button
                onClick={() => { setAiSearchResults(null); setSearchTerm(''); }}
                style={{
                  marginLeft: 'auto',
                  background: '#fff',
                  border: '1px solid #3b5bfd',
                  color: '#3b5bfd',
                  borderRadius: '6px',
                  padding: '4px 12px',
                  fontSize: '11.5px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: '0 1px 2px rgba(59, 91, 253, 0.1)'
                }}
                onMouseOver={(e) => { e.currentTarget.style.background = '#3b5bfd'; e.currentTarget.style.color = '#fff'; }}
                onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#3b5bfd'; }}
              >
                Clear AI Search
              </button>
            </div>
          )}

          {/* Active Filters Indicator */}
          {(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ||
            (sidebarFilters.status || []).length > 0 ||
            (sidebarFilters.workType || []).length > 0 ||
            sidebarFilters.country ||
            sidebarFilters.state ||
            sidebarFilters.city ||
            (sidebarFilters.sources || []).length > 0 ||
            (sidebarFilters.experience && sidebarFilters.experience !== 'all') ||
            (currentView !== 'bench' && sidebarFilters.isBench && sidebarFilters.isBench !== 'all') ||
            (sidebarFilters.gender || []).length > 0 ||
            (sidebarFilters.workAuth || []).length > 0 ||
            (sidebarFilters.relocate && sidebarFilters.relocate !== 'all')) && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 32px', background: '#f8fafc',
                borderBottom: '1px solid #e2e8f0', fontSize: 13,
                flexWrap: 'wrap'
              }}>
                <span style={{ fontWeight: 600, color: '#475569', display: 'flex', alignItems: 'center', gap: 4 }}>
                  <Filter size={14} /> Active Filters:
                </span>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {(sidebarFilters.status || []).map(s => (
                    <span key={s} style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{s}</span>
                  ))}
                  {(sidebarFilters.workType || []).map(w => (
                    <span key={w} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{w}</span>
                  ))}
                  {sidebarFilters.country && (
                    <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Country: {sidebarFilters.country}</span>
                  )}
                  {sidebarFilters.state && (
                    <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>State: {sidebarFilters.state}</span>
                  )}
                  {sidebarFilters.city && (
                    <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>City: {sidebarFilters.city}</span>
                  )}
                  {(sidebarFilters.workAuth || []).map(auth => (
                    <span key={auth} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Auth: {auth}</span>
                  ))}
                  {(sidebarFilters.employmentTypes || []).map(type => (
                    <span key={type} style={{ background: '#ecfdf5', color: '#065f46', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{type}</span>
                  ))}
                  {(sidebarFilters.industries || []).map(ind => (
                    <span key={ind} style={{ background: '#f8fafc', color: '#475569', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{ind}</span>
                  ))}
                  {sidebarFilters.experience && sidebarFilters.experience !== 'all' && (
                    <span style={{ background: '#f3e8ff', color: '#6b21a8', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Exp: {sidebarFilters.experience}</span>
                  )}
                  {sidebarFilters.isBench && sidebarFilters.isBench !== 'all' && (
                    <span style={{ background: '#ffedd5', color: '#9a3412', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{sidebarFilters.isBench === 'bench' ? 'Bench Only' : 'Non-Bench'}</span>
                  )}
                </div>

                <button
                  onClick={handleResetFilters}
                  style={{
                    marginLeft: 'auto', background: 'none', border: 'none',
                    color: '#ef4444', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: 4
                  }}
                >
                  Clear All
                </button>
              </div>
            )}

          {/* Table or AI Loading */}
          {isAiSearching ? (
            <div className="cm-ai-search-loading">
              <div className="cm-ai-search-loading-icon-wrapper">
                <Sparkles size={48} color="#3b5bfd" fill="#3b5bfd" className="cm-ai-loading-sparkles" />
              </div>
              <h2 className="cm-ai-search-loading-title">AI Is analyzing your database...</h2>
              <p className="cm-ai-search-loading-subtitle">Finding the best matches based on semantic relevance</p>
              <div className="cm-ai-search-loading-progress-container">
                <div className="cm-ai-search-loading-progress-bar"></div>
              </div>
            </div>
          ) : (
            <CandidateTable
              loading={loading || isTypingSearching}
              candidates={paginatedCandidates}
              isAiSearching={isAiSearching}
              visibleColumns={visibleColumns}
              sortConfig={sortConfig}
              onSort={requestSort}
              onView={viewCandidate}
              onEdit={editCandidate}
              onShare={(candidate) => {
                setShareModalCandidates([candidate]);
                setShowShareModal(true);
              }}
              onSchedule={(candidate) => {
                setScheduleCandidate(candidate);
                setShowJobsModal(true);
              }}
              onSubmitProfile={(candidate) => {
                setSubmitCandidates([candidate]);
                setShowSubmitModal(true);
              }}
              onDelete={deleteCandidate}
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={filteredCandidates.length}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={(newVal) => {
                setItemsPerPage(newVal);
                setCurrentPage(1);
              }}
              selectedRows={selectedCandidateIds}
              onSelectionChange={setSelectedCandidateIds}
            />
          )}
        </div>
      </div>

      {/* Modals */}
      <ShareResumeModal
        isOpen={showShareModal}
        onClose={() => {
          setShowShareModal(false);
          setShareModalCandidates([]);
          setIsBulkEmailingCandidates(false);
        }}
        candidates={shareModalCandidates}
        isBulkEmailMode={isBulkEmailingCandidates}
        onSuccess={() => {
          setSelectedCandidateIds([]);
        }}
      />

      <CandidateJobsModal
        isOpen={showJobsModal}
        onClose={() => { setShowJobsModal(false); setScheduleCandidate(null); }}
        candidate={scheduleCandidate}
        onSelectJob={(job) => {
          setSelectedJobForInterview(job);
          setShowJobsModal(false);
          setShowScheduleModal(true);
        }}
      />

      <ScheduleInterviewModal
        isOpen={showScheduleModal}
        onClose={() => { setShowScheduleModal(false); setScheduleCandidate(null); setSelectedJobForInterview(null); }}
        candidate={scheduleCandidate}
        job={selectedJobForInterview}
      />

      <SubmitProfileModal
        isOpen={showSubmitModal}
        onClose={() => { setShowSubmitModal(false); setSubmitCandidates([]); }}
        candidates={submitCandidates}
        onBulkSuccess={(cands) => {
          setShareModalCandidates(cands);
          setShowShareModal(true);
        }}
      />

      {showAddModal && (
        <AddModal
          candidate={editingCandidate}
          isBenchPage={currentView === 'bench'}
          onClose={() => { setShowAddModal(false); setEditingCandidate(null); setParsedResumeData(null); }}
          onSave={handleSaveCandidate}
          onResumeUpload={handleResumeUpload}
          uploading={uploadingResume}
          parsedData={parsedResumeData}
          fetchFullCandidateDetails={getFullCandidate}
        />
      )}

      <FilterModal
        isOpen={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        onApply={handleApplyFilters}
        initialFilters={advancedFilters}
      />

      <ConfirmParseModal
        isOpen={showConfirmParse}
        onConfirm={handleConfirmParse}
        onCancel={() => { setShowConfirmParse(false); setPendingParseFile(null); }}
      />

      <ParsingLoadingModal
        isOpen={showParsingLoading}
      />

      <DuplicateResumeModal
        isOpen={showDuplicateModal}
        duplicateCandidate={duplicateCandidate}
        currentView={currentView}
        onProceed={handleDuplicateAction}
        onCancel={() => handleDuplicateAction('cancel')}
        onCheckInCandidate={handleCheckInCandidate}
      />

      <ColumnFilterSidebar
        availableColumns={availableColumns}
        selectedColumns={visibleColumns}
        setSelectedColumns={setVisibleColumns}
        availableFilters={availableSidebarFilters}
        selectedFilters={visibleSidebarFilters}
        setSelectedFilters={setVisibleSidebarFilters}
        defaultColumns={defaultVisibleCols}
        defaultFilters={availableSidebarFilters.map(f => f.key)}
        onClose={() => setShowColumnSidebar(false)}
        isOpen={showColumnSidebar}
      />

      {showAiSidebar && (
        <div className="cm-ai-overlay" onClick={() => setShowAiSidebar(false)} />
      )}
      <AskAiSidebar
        isOpen={showAiSidebar}
        onClose={() => setShowAiSidebar(false)}
        candidates={candidates}
      />
    </div>
  );
};

export default ResumeDashboard;




// import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
// import { Plus, Download, SlidersHorizontal, Filter, Search, Upload, Loader, Share2, Sparkles, Heart, X, Bookmark, Trash2, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   CANDIDATE_STATUS_OPTIONS, REMOTE_STATUS_OPTIONS, DATE_OPTIONS, formatDate,
//   WORK_AUTHORIZATION_OPTIONS, EMPLOYMENT_TYPE_OPTIONS, SECURITY_CLEARANCE_OPTIONS,
//   RATE_TYPE_OPTIONS, MARITAL_STATUS_OPTIONS, INDUSTRY_OPTIONS
// } from '../utils/mockData';
// import CandidateTable from './CandidateTable';
// import AddModal from './AddModal';
// import FilterModal from './FilterModal';
// import ShareResumeModal from './ShareResumeModal';
// import { CandidateJobsModal, ScheduleInterviewModal } from './ScheduleInterviewModals';
// import { SubmitProfileModal } from './SubmitProfileModal';
// import { ConfirmParseModal, ParsingLoadingModal, DuplicateResumeModal } from './ParseFlowModals';
// import ColumnFilterSidebar from './ColumnFilterSidebar';
// import CandidateFilterSidebar from './CandidateFilterSidebar';
// import AskAiSidebar from './AskAiSidebar';
// import '../styles/Dashboard.css';
// import '../styles/CandidateTableCustom.css';
// import '../styles/AddModalCustom.css';
// import Swal from 'sweetalert2';
// import * as XLSX from 'xlsx';
// import BASE_URL, { RESUME_PARSER_URL } from "../../url";
// import { formatName, formatJobTitle, formatNameFields, formatFullName } from '../utils/nameFormatter';
// import {
//   countriesData,
//   getCountryCode,
//   getStateCode
// } from '../../erprecruitment/config/locationConfig';

// // ─── Helper to get auth headers ──────────────────────────────────────────────
// const getAuthHeaders = () => {
//   const token = localStorage.getItem('token');
//   return {
//     'Authorization': `Bearer ${token}`,
//   };
// };

// // ─── Module-level cache so multiple mounts don't re-fetch ─────────────────────
// let _cachedCandidates = null;
// let _cachedSearchTerm = '';
// let _cachedStatusFilter = 'all';
// let _cachedAiSearchResults = null;
// let _cachedUseAiSearch = true;
// let _cachedItemsPerPage = 30;
// // ──────────────────────────────────────────────────────────────────────────────

// const formatToMonth = (dateStr) => {
//   if (!dateStr) return '';
//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return typeof dateStr === 'string' && dateStr.length >= 7 ? dateStr.substring(0, 7) : dateStr;
//   return d.toISOString().substring(0, 7);
// };

// // ── Transform a raw API candidate object into the shape the UI needs ──────────
// const transformCandidate = (candidate) => {
//   const isEmployee = !!candidate.employee_id;
//   const empId = candidate.employee_id || '';

//   return {
//     CandidateId: candidate.candidate_id,
//     CandidateCode: candidate.candidate_code || `CAN-${String(candidate.candidate_id).padStart(6, '0')}`,
//     EmployeeCode: empId,
//     IsEmployee: isEmployee,
//     FirstName: formatName(candidate.first_name || ''),
//     LastName: formatName(candidate.last_name || ''),
//     MiddleName: formatName(candidate.middle_name || ''),
//     JobTitle: formatJobTitle(candidate.job_title || ''),
//     YearsOfExperience: candidate.years_exp,
//     CandidateStatus: candidate.status || 'Available',
//     RemoteStatus: candidate.remote_status || 'OnSite',
//     CreatedDt: candidate.created_on,
//     ProfileSummary: candidate.profile_summary || '',
//     LinkedInUrl: candidate.linkedin_url || '',
//     GitHubUrl: candidate.github_url || '',
//     TwitterUrl: candidate.twitter_url || '',
//     VideoResumeUrl: candidate.video_resume_url || '',
//     Gender: candidate.gender || '',
//     CurrentLocation: candidate.current_location || '',
//     Source: candidate.source || '',

//     // NEW FIELDS from backend
//     WorkAuthorization: candidate.work_authorization || '',
//     SecurityClearance: candidate.security_clearance || '',
//     WillingToRelocate: candidate.willing_to_relocate || false,
//     IsBench: candidate.is_bench || false,
//     EmploymentType: candidate.employment_type || '',
//     ExpectedRateFrom: candidate.expected_rate_from || '',
//     ExpectedRateTo: candidate.expected_rate_to || '',
//     ExpectedRateType: candidate.expected_rate_type || 'Hourly',
//     CurrentRate: candidate.current_rate || '',
//     CurrentRateType: candidate.current_rate_type || 'Hourly',
//     MaritalStatus: candidate.marital_status || '',
//     Industry: candidate.industry || '',
//     Mobile: candidate.mobile || '',

//     Contact: {
//       Email: candidate.email || '',
//       Phone: candidate.phone || '',
//       Mobile: candidate.mobile || '',
//     },
//     Phones: candidate.phones || [],
//     Emails: candidate.emails || [],
//     Skills: (candidate.skills || []).map(s =>
//       typeof s === 'string'
//         ? { SkillName: s, SkillType: 'HARD' }
//         : { SkillName: s.skill_name || s.SkillName || '', SkillType: s.skill_type || s.SkillType || 'HARD' }
//     ),
//     Education: (candidate.education || []).map(e => ({
//       Institution: formatName(e.Institution || e.institution || ''),
//       Degree: formatName(e.Degree || e.degree || ''),
//       FieldOfStudy: e.FieldOfStudy || e.fieldOfStudy || '',
//       StartDate: formatToMonth(e.StartDate || e.startDate),
//       EndDate: formatToMonth(e.EndDate || e.endDate),
//       GPA: e.GPA || e.gpa || '',
//     })),
//     WorkExperience: (candidate.work_experience || []).map(w => ({
//       Company: w.Company || w.company || '',
//       JobTitle: formatJobTitle(w.JobTitle || w.jobTitle || ''),
//       StartDate: formatToMonth(w.StartDate || w.startDate),
//       EndDate: formatToMonth(w.EndDate || w.endDate),
//       IsCurrent: w.IsCurrent ?? w.isCurrent ?? false,
//       Description: w.Description || w.description || '',
//     })),
//     Certifications: (candidate.certifications || []).map(c => ({
//       CertificationName: formatName(c.CertificationName || c.name || ''),
//       IssuingOrganization: c.IssuingOrganization || c.issuingOrg || '',
//       IssueDate: formatToMonth(c.IssueDate || c.issueDate),
//       ExpiryDate: formatToMonth(c.ExpiryDate || c.expiryDate),
//       CredentialId: c.CredentialId || c.credentialId || '',
//       CredentialUrl: c.CredentialUrl || c.credentialUrl || '',
//     })),
//     Document: candidate.document ? {
//       DocumentId: candidate.document.DocumentId,
//       FileNameOriginal: candidate.document.FileNameOriginal,
//       FileExtension: candidate.document.FileExtension,
//       MimeType: candidate.document.MimeType,
//       FileSizeBytes: candidate.document.FileSizeBytes,
//       StorageLocator: candidate.document.StorageLocator,
//       ParseStatus: candidate.document.ParseStatus,
//       DownloadUrl: candidate.document.DownloadUrl,
//     } : null,
//     Documents: (candidate.documents || []).map(d => ({
//       DocumentId: d.DocumentId || d.documentId,
//       DocumentType: d.DocumentType || d.documentType || 'Certificate',
//       DocumentName: d.FileNameOriginal ? d.FileNameOriginal.replace(/\.[^/.]+$/, "") : (d.DocumentName || ''),
//       FileNameOriginal: d.FileNameOriginal || d.fileNameOriginal,
//       FileExtension: d.FileExtension || d.fileExtension,
//       MimeType: d.MimeType || d.mimeType,
//       FileSizeBytes: d.FileSizeBytes || d.fileSizeBytes,
//       UploadedOn: d.UploadedOn || d.uploadedOn,
//       VersionNo: d.VersionNo || d.versionNo,
//       IsPrimary: d.IsPrimary || d.isPrimary,
//     })),
//   };
// };

// const ResumeDashboard = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const currentView = queryParams.get('view') || 'all';
//   const [candidates, setCandidates] = useState(_cachedCandidates || []);
//   const [loading, setLoading] = useState(_cachedCandidates === null);
//   const isFetchingRef = useRef(false);
//   const [searchTerm, setSearchTerm] = useState(_cachedSearchTerm);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [sortConfig, setSortConfig] = useState({ key: 'CreatedOn', direction: 'desc' });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(_cachedItemsPerPage);
//   const [editingCandidate, setEditingCandidate] = useState(null);
//   const [showColumnSidebar, setShowColumnSidebar] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [showFilterModal, setShowFilterModal] = useState(false);
//   const [advancedFilters, setAdvancedFilters] = useState({ rows: [], logic: 'AND' });
//   const [showAiSidebar, setShowAiSidebar] = useState(false);
//   const [uploadingResume, setUploadingResume] = useState(false);
//   const [useAiSearch, setUseAiSearch] = useState(_cachedUseAiSearch);
//   const [isAiSearching, setIsAiSearching] = useState(false);
//   const [aiSearchResults, setAiSearchResults] = useState(_cachedAiSearchResults);

//   // Parse Flow States
//   const [parsedResumeData, setParsedResumeData] = useState(null);
//   const [parsingFromToolbar, setParsingFromToolbar] = useState(false);
//   const [pendingParseFile, setPendingParseFile] = useState(null);
//   const [showConfirmParse, setShowConfirmParse] = useState(false);
//   const [showParsingLoading, setShowParsingLoading] = useState(false);
//   const [showDuplicateModal, setShowDuplicateModal] = useState(false);
//   const [duplicateCandidate, setDuplicateCandidate] = useState(null);
//   const [statusFilter, setStatusFilter] = useState(_cachedStatusFilter);
//   const [showFilterSidebar, setShowFilterSidebar] = useState(true);

//   // Sidebar Filter State
//   const [sidebarFilters, setSidebarFilters] = useState({
//     search: '',
//     status: [],
//     workType: [],
//     experience: 'all',
//     country: '',
//     state: '',
//     city: '',
//     sources: [],
//     employmentTypes: [],
//     industries: [],
//     isBench: 'all',
//     personType: 'all',
//     gender: [],
//     relocate: 'all',
//     workAuth: []
//   });

//   // Visible Sidebar Filters (Dynamic filter visibility)
//   const [visibleSidebarFilters, setVisibleSidebarFilters] = useState([
//     'CandidateStatus', 'PersonType', 'IsBench', 'RemoteStatus', 'Experience',
//     'Gender', 'Relocation', 'WorkAuthorization', 'EmploymentType', 'Industry', 'CurrentLocation'
//   ]);

//   // Sync top search TO sidebar search only once on mount or when searchTerm changes externally
//   useEffect(() => {
//     setSidebarFilters(prev => ({ ...prev, search: searchTerm }));
//   }, [searchTerm]);

//   // Auto-save active search filters
//   useEffect(() => {
//     _cachedSearchTerm = searchTerm;
//   }, [searchTerm]);

//   useEffect(() => {
//     _cachedStatusFilter = statusFilter;
//   }, [statusFilter]);

//   useEffect(() => {
//     _cachedAiSearchResults = aiSearchResults;
//   }, [aiSearchResults]);

//   useEffect(() => {
//     _cachedUseAiSearch = useAiSearch;
//   }, [useAiSearch]);

//   useEffect(() => {
//     _cachedItemsPerPage = itemsPerPage;
//   }, [itemsPerPage]);

//   // Reset page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [sidebarFilters, searchTerm, aiSearchResults]);

//   // Share Resume State
//   const [showShareModal, setShowShareModal] = useState(false);
//   const [shareModalCandidates, setShareModalCandidates] = useState([]);
//   const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

//   // Schedule Interview State
//   const [showJobsModal, setShowJobsModal] = useState(false);
//   const [showScheduleModal, setShowScheduleModal] = useState(false);
//   const [scheduleCandidate, setScheduleCandidate] = useState(null);
//   const [selectedJobForInterview, setSelectedJobForInterview] = useState(null);

//   // Submit Profile State
//   const [showSubmitModal, setShowSubmitModal] = useState(false);
//   const [submitCandidate, setSubmitCandidate] = useState(null);

//   const parseFileInputRef = useRef(null);

//   // Saved Searches State
//   const [savedSearches, setSavedSearches] = useState([]);

//   useEffect(() => {
//     const saved = localStorage.getItem('erp_saved_searches');
//     if (saved) {
//       try {
//         setSavedSearches(JSON.parse(saved));
//       } catch (e) { }
//     }
//   }, []);

//   const handleSaveSearch = () => {
//     if (!searchTerm && statusFilter === 'all') return;

//     const exists = savedSearches.some(s => s.term === searchTerm && s.status === statusFilter);
//     if (exists) return;

//     const newSaved = [...savedSearches, { term: searchTerm, status: statusFilter, id: Date.now() }];
//     setSavedSearches(newSaved);
//     localStorage.setItem('erp_saved_searches', JSON.stringify(newSaved));

//     Swal.fire({
//       title: 'Search Saved!',
//       text: 'Your current search and filters have been saved.',
//       icon: 'success',
//       timer: 1500,
//       showConfirmButton: false
//     });
//   };

//   const handleLoadSearch = (search) => {
//     setSearchTerm(search.term);
//     setStatusFilter(search.status || 'all');
//     setCurrentPage(1);

//     if (useAiSearch && search.term) {
//       handleAiSearch(search.term);
//     } else {
//       setAiSearchResults(null);
//     }
//   };

//   const removeSavedSearch = (id) => {
//     const updated = savedSearches.filter(s => s.id !== id);
//     setSavedSearches(updated);
//     localStorage.setItem('erp_saved_searches', JSON.stringify(updated));
//   };

//   // ─── Column Configuration ────────────────────────────────────────────────
//   const availableColumns = [
//     { key: 'CandidateCode', label: 'Candidate ID' },
//     { key: 'EmployeeCode', label: 'Employee ID' },
//     { key: 'Candidate', label: 'Name' },
//     { key: 'Email', label: 'Email' },
//     { key: 'Phone', label: 'Phone' },
//     { key: 'Mobile', label: 'Mobile' },
//     { key: 'JobTitle', label: 'Job Title' },
//     { key: 'YearsOfExperience', label: 'Years of Exp.' },
//     { key: 'Skills', label: 'Skills' },
//     { key: 'CandidateStatus', label: 'Status' },
//     { key: 'RemoteStatus', label: 'Work Type' },
//     { key: 'CreatedDate', label: 'Created Date' },
//     { key: 'LinkedInUrl', label: 'LinkedIn URL' },
//     { key: 'GitHubUrl', label: 'GitHub URL' },
//     { key: 'CurrentLocation', label: 'Location' },
//     { key: 'Gender', label: 'Gender' },
//     { key: 'ProfileSummary', label: 'Profile Summary' },
//     { key: 'PersonType', label: 'Type' },
//     { key: 'IsBench', label: 'Bench Status' },
//     { key: 'Experience', label: 'Experience' },
//     { key: 'Relocation', label: 'Relocation' },
//     { key: 'Source', label: 'Source' },
//     { key: 'Actions', label: 'Actions' },
//   ];

//   const availableSidebarFilters = [
//     { key: 'CandidateStatus', label: 'Status' },
//     { key: 'PersonType', label: 'Type' },
//     { key: 'IsBench', label: 'Bench Status' },
//     { key: 'RemoteStatus', label: 'Work Type' },
//     { key: 'Experience', label: 'Experience' },
//     { key: 'Gender', label: 'Gender' },
//     { key: 'Relocation', label: 'Relocation' },
//     { key: 'CurrentLocation', label: 'Location' },
//     { key: 'Skills', label: 'Skills (Search)' },
//     { key: 'Email', label: 'Email (Search)' },
//     { key: 'Phone', label: 'Phone (Search)' },
//     { key: 'JobTitle', label: 'Job Title (Search)' },
//   ];

//   const [visibleColumns, setVisibleColumns] = useState([
//     'CandidateCode', 'EmployeeCode', 'Candidate', 'Email', 'Phone', 'JobTitle',
//     'YearsOfExperience', 'Skills', 'CandidateStatus', 'RemoteStatus', 'CreatedDate', 'Actions',
//   ]);

//   // ── Fetch candidate list ──────────────────────────────────────────────────
//   const fetchCandidates = useCallback(async (force = false) => {
//     if (_cachedCandidates && !force) {
//       setCandidates(_cachedCandidates);
//       setLoading(false);
//       return;
//     }
//     if (isFetchingRef.current) return;
//     isFetchingRef.current = true;
//     setLoading(true);

//     try {
//       const response = await fetch(`${BASE_URL}/api/resumes`, {
//         headers: getAuthHeaders(),
//       });
//       if (!response.ok) throw new Error(`Server error: ${response.status} ${response.statusText}`);

//       const raw = await response.json();
//       const data = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.data) ? raw.data
//           : Array.isArray(raw?.candidates) ? raw.candidates
//             : [];

//       const transformedCandidates = data.map(transformCandidate);

//       // De-duplicate by CandidateId
//       const uniqueItems = [];
//       const seenIds = new Set();
//       transformedCandidates.forEach(c => {
//         const id = String(c.CandidateId);
//         if (!seenIds.has(id)) {
//           seenIds.add(id);
//           uniqueItems.push(c);
//         }
//       });

//       _cachedCandidates = uniqueItems;
//       setCandidates(uniqueItems);

//     } catch (error) {
//       console.error('[ResumeDashboard] Error fetching candidates:', error);
//       Swal.fire({
//         title: 'Connection Error',
//         html: `<p>Could not load candidates from the server.</p>
//                <small style="color:#888">Make sure the backend server is running and reachable.</small>`,
//         icon: 'error',
//         confirmButtonText: 'OK',
//       });
//       setCandidates([]);
//     } finally {
//       isFetchingRef.current = false;
//       setLoading(false);
//     }
//   }, []);

//   const handleAiSearch = useCallback(async (query) => {
//     if (!query || !query.trim()) {
//       setAiSearchResults(null);
//       return;
//     }

//     setIsAiSearching(true);
//     try {
//       const countMatch = query.match(/(\d+)\s*(?:candidates|results|people)/i);
//       const requestedLimit = countMatch ? parseInt(countMatch[1]) : 50;

//       const response = await fetch(`${BASE_URL}/api/resumes/search`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           ...getAuthHeaders()
//         },
//         body: JSON.stringify({
//           query: query.trim(),
//           top_k: requestedLimit,
//           limit: requestedLimit,
//           size: requestedLimit
//         }),
//       });

//       if (!response.ok) throw new Error('AI Search failed');
//       const data = await response.json();

//       if (data && data.results) {
//         console.log(`🔍 AI Search returned ${data.results.length} results (Requested: ${requestedLimit})`);

//         const seenIds = new Set();
//         const mappedResults = data.results
//           .filter(res => {
//             const id = String(res.candidate_id);
//             if (seenIds.has(id)) return false;
//             seenIds.add(id);
//             return true;
//           })
//           .map(res => {
//             const localMatch = candidates.find(c => String(c.CandidateId) === String(res.candidate_id));

//             if (localMatch) {
//               return {
//                 ...localMatch,
//                 aiScore: res.score,
//                 aiRank: res.rank,
//                 matchReason: res.match_reason
//               };
//             }

//             return {
//               CandidateId: res.candidate_id,
//               FirstName: res.name?.split(' ')[0] || 'Unknown',
//               LastName: res.name?.split(' ').slice(1).join(' ') || '',
//               JobTitle: res.job_title || 'N/A',
//               YearsOfExperience: res.years_experience,
//               Skills: (res.skills || []).map(s => ({ SkillName: s, SkillType: 'HARD' })),
//               CandidateStatus: 'Available',
//               RemoteStatus: res.remote_status || 'OnSite',
//               Contact: {
//                 Email: '',
//                 Phone: '',
//                 Mobile: ''
//               },
//               matchReason: res.match_reason,
//               aiScore: res.score,
//               aiRank: res.rank
//             };
//           });

//         setAiSearchResults(mappedResults);
//         setCurrentPage(1);
//       }
//     } catch (error) {
//       console.error('AI Search Error:', error);
//       Swal.fire({
//         title: 'Search Error',
//         text: 'The AI search service is currently unavailable.',
//         icon: 'error',
//         timer: 2000,
//         showConfirmButton: false
//       });
//     } finally {
//       setIsAiSearching(false);
//     }
//   }, [candidates]);

//   // ── Debounced AI Search Flow ─────────────────────────────────────────────
//   useEffect(() => {
//     if (!useAiSearch || !searchTerm || !searchTerm.trim()) {
//       if (!searchTerm) {
//         setAiSearchResults(null);
//       }
//       // If we cleared the search, we stop searching
//       if (!searchTerm) setIsAiSearching(false);
//       return;
//     }

//     // Immediately indicate searching state to trigger animation
//     setIsAiSearching(true);

//     const timer = setTimeout(() => {
//       handleAiSearch(searchTerm);
//     }, 1200); // Slightly longer debounce for semantic analysis

//     return () => clearTimeout(timer);
//   }, [searchTerm, useAiSearch, handleAiSearch]);

//   // Reset search and filters when view changes
//   useEffect(() => {
//     setSearchTerm('');
//     setAiSearchResults(null);
//     setAdvancedFilters({ rows: [], logic: 'AND' });
//     setCurrentPage(1);
//     fetchCandidates(true);
//   }, [currentView, fetchCandidates]);

//   // ── Navigate to full candidate detail page ────────────────────────────
//   const viewCandidate = (id) => {
//     navigate(`/candidates/${id}`);
//   };

//   // ── Get field value from candidate ──
//   const getFieldValue = useCallback((candidate, field) => {
//     switch (field) {
//       case 'FirstName':
//         return formatFullName(candidate.FirstName, candidate.MiddleName, candidate.LastName);
//       case 'Email': return candidate.Contact?.Email || '';
//       case 'Phone': return candidate.Contact?.Phone || '';
//       case 'Skills':
//         return (candidate.Skills || []).map(s => s.SkillName || s).join(', ');
//       case 'YearsOfExperience': return candidate.YearsOfExperience != null ? String(candidate.YearsOfExperience) : '';
//       case 'CreatedDt': return candidate.CreatedDt || '';
//       default: {
//         const val = candidate[field];
//         return (val !== null && val !== undefined) ? String(val) : '';
//       }
//     }
//   }, []);

//   // ── Check if a candidate matches a single filter row ──
//   const matchesRow = useCallback((candidate, row) => {
//     const rawVal = getFieldValue(candidate, row.field);
//     const target = (row.value || '').trim();

//     if (row.condition === 'is_empty') return !rawVal || String(rawVal).trim() === '';
//     if (row.condition === 'is_not_empty') return rawVal && String(rawVal).trim() !== '';

//     const valStr = String(rawVal || '').trim();
//     const valLower = valStr.toLowerCase();
//     const targetLower = target.toLowerCase();

//     const numVal = parseFloat(valStr);
//     const numTarget = parseFloat(target);
//     const isNumericMatch = !isNaN(numVal) && !isNaN(numTarget) && isFinite(valStr) && isFinite(target);

//     const dateVal = new Date(valStr);
//     const dateTarget = new Date(target);
//     const isDateMatch = !isNaN(dateVal.getTime()) && !isNaN(dateTarget.getTime()) && valStr.includes('-') && target.includes('-');

//     switch (row.condition) {
//       case 'contains': return valLower.includes(targetLower);
//       case 'not_contains': return !valLower.includes(targetLower);
//       case 'equals':
//         if (isNumericMatch) return numVal === numTarget;
//         if (isDateMatch) {
//           const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
//           const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
//           return d1 === d2;
//         }
//         if (row.field === 'Skills') {
//           return valLower.split(',').map(s => s.trim()).includes(targetLower);
//         }
//         return valLower === targetLower;
//       case 'not_equals':
//         if (isNumericMatch) return numVal !== numTarget;
//         if (isDateMatch) {
//           const d1 = new Date(dateVal).setHours(0, 0, 0, 0);
//           const d2 = new Date(dateTarget).setHours(0, 0, 0, 0);
//           return d1 !== d2;
//         }
//         if (row.field === 'Skills') {
//           return !valLower.split(',').map(s => s.trim()).includes(targetLower);
//         }
//         return valLower !== targetLower;
//       case 'starts_with': return valLower.startsWith(targetLower);
//       case 'ends_with': return valLower.endsWith(targetLower);
//       case 'greater_than':
//         if (isNumericMatch) return numVal > numTarget;
//         if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) > dateTarget.setHours(0, 0, 0, 0);
//         return valLower > targetLower;
//       case 'less_than':
//         if (isNumericMatch) return numVal < numTarget;
//         if (isDateMatch) return dateVal.setHours(0, 0, 0, 0) < dateTarget.setHours(0, 0, 0, 0);
//         return valLower < targetLower;
//       default: return true;
//     }
//   }, [getFieldValue]);

//   // ── Derived filter options ─────────────────────────────────────────────
//   const availableStatuses = useMemo(() => {
//     return ['Available', 'In Process', 'Not Available', 'Hired'];
//   }, []);

//   const availableWorkTypes = useMemo(() => {
//     return ['Remote', 'OnSite', 'Hybrid'];
//   }, []);

//   const availableLocations = useMemo(() => {
//     const locs = [...new Set(candidates.map(c => {
//       if (c.CurrentLocation) {
//         const parts = c.CurrentLocation.split(',').map(p => p.trim());
//         if (parts.length >= 2) {
//           return parts.slice(-2).join(', ');
//         }
//         return parts[0];
//       }
//       return null;
//     }))].filter(Boolean);
//     return locs.sort();
//   }, [candidates]);

//   const availableSources = useMemo(() => {
//     const sources = [...new Set(candidates.map(c => c.Source))].filter(Boolean);
//     return sources.sort();
//   }, [candidates]);

//   const availableEmploymentTypes = useMemo(() => {
//     const types = [...new Set(candidates.map(c => c.EmploymentType))].filter(Boolean);
//     return types.sort();
//   }, [candidates]);

//   const availableIndustries = useMemo(() => {
//     const inds = [...new Set(candidates.map(c => c.Industry))].filter(Boolean);
//     return inds.sort();
//   }, [candidates]);

//   const availableWorkAuths = useMemo(() => {
//     const auths = [...new Set(candidates.map(c => c.WorkAuthorization))].filter(Boolean);
//     return auths.sort();
//   }, [candidates]);

//   const availableGenders = useMemo(() => {
//     const genders = [...new Set(candidates.map(c => c.Gender))].filter(Boolean);
//     return genders.sort();
//   }, [candidates]);


//   // ── Filter & Sort Logic ────────────────────────────────────────────────
//   const filteredCandidates = useMemo(() => {
//     // 1️⃣ Priority: If AI search was just performed, use those results as our working set
//     let result = aiSearchResults !== null ? [...aiSearchResults] : [...candidates];

//     // 2️⃣ Standard global search filtering - Skip if AI Search is active
//     if (aiSearchResults === null && searchTerm && !useAiSearch) {
//       const term = searchTerm.toLowerCase();
//       result = result.filter(c => {
//         const fullName = formatFullName(c.FirstName, c.MiddleName, c.LastName).toLowerCase();
//         const skillsText = (c.Skills || []).map(s => s.SkillName || s).join(' ').toLowerCase();
//         const exp = (c.YearsOfExperience !== undefined && c.YearsOfExperience !== null) ? c.YearsOfExperience : '';
//         const expText = exp !== '' ? `${exp}y ${exp} yr ${exp} year ${exp} years` : '';

//         const matchesName = fullName.includes(term);
//         const matchesJob = visibleSidebarFilters.includes('JobTitle') && (c.JobTitle || '').toLowerCase().includes(term);
//         const matchesCode = (c.CandidateCode || '').toLowerCase().includes(term);
//         const matchesEmail = visibleSidebarFilters.includes('Email') && (c.Contact?.Email || '').toLowerCase().includes(term);
//         const matchesPhone = visibleSidebarFilters.includes('Phone') && (
//           (c.Contact?.Phone || '').toLowerCase().includes(term) ||
//           (c.Contact?.Mobile || '').toLowerCase().includes(term)
//         );
//         const matchesSkills = visibleSidebarFilters.includes('Skills') && skillsText.includes(term);
//         const matchesExp = expText.toLowerCase().includes(term);

//         return matchesName || matchesJob || matchesCode || matchesEmail || matchesPhone || matchesSkills || matchesExp;
//       });
//     }

//     // 3️⃣ Sidebar-specific search filtering - Skip if AI Search is active
//     if (aiSearchResults === null && sidebarFilters.search) {
//       const term = sidebarFilters.search.toLowerCase();
//       result = result.filter(c => {
//         const fullName = formatFullName(c.FirstName, c.MiddleName, c.LastName).toLowerCase();
//         const skillsText = (c.Skills || []).map(s => s.SkillName || s).join(' ').toLowerCase();
//         const exp = (c.YearsOfExperience !== undefined && c.YearsOfExperience !== null) ? c.YearsOfExperience : '';
//         const expText = exp !== '' ? `${exp}y ${exp} yr ${exp} year ${exp} years` : '';

//         const matchesName = fullName.includes(term);
//         const matchesJob = visibleSidebarFilters.includes('JobTitle') && (c.JobTitle || '').toLowerCase().includes(term);
//         const matchesCode = (c.CandidateCode || '').toLowerCase().includes(term);
//         const matchesEmail = visibleSidebarFilters.includes('Email') && (c.Contact?.Email || '').toLowerCase().includes(term);
//         const matchesPhone = visibleSidebarFilters.includes('Phone') && (
//           (c.Contact?.Phone || '').toLowerCase().includes(term) ||
//           (c.Contact?.Mobile || '').toLowerCase().includes(term)
//         );
//         const matchesSkills = visibleSidebarFilters.includes('Skills') && skillsText.includes(term);
//         const matchesExp = expText.toLowerCase().includes(term);

//         return matchesName || matchesJob || matchesCode || matchesEmail || matchesPhone || matchesSkills || matchesExp;
//       });
//     }

//     // Status filter
//     if (statusFilter !== 'all') {
//       result = result.filter(c => {
//         if (statusFilter === 'On Bench') {
//           return c.IsBench === true || c.CandidateStatus === 'On Bench';
//         }
//         return (c.CandidateStatus || '').toLowerCase() === statusFilter.toLowerCase();
//       });
//     }

//     // Category filter based on 'view' query parameter - Skip strict sourcing/review checks if AI Search is active
//     if (aiSearchResults === null) {
//       if (currentView === 'sourcing') {
//         result = result.filter(c => {
//           const hasEmail = (c.Contact?.Email || '').trim();
//           const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
//           const allowBench = sidebarFilters.isBench === 'bench';
//           return (allowBench || !c.IsBench) && hasEmail && hasPhone;
//         });
//       } else if (currentView === 'bench') {
//         result = result.filter(c => c.IsBench === true);
//       } else if (currentView === 'review') {
//         result = result.filter(c => {
//           const hasEmail = (c.Contact?.Email || '').trim();
//           const hasPhone = (c.Contact?.Phone || '').trim() || (c.Contact?.Mobile || '').trim() || (c.Mobile || '').trim();
//           return !hasEmail || !hasPhone;
//         });
//       }
//     }

//     // Sidebar Filters Logic
//     if ((sidebarFilters.status || []).length > 0) {
//       const selected = sidebarFilters.status.map(s => s.toLowerCase());
//       result = result.filter(c => selected.includes((c.CandidateStatus || '').toLowerCase()));
//     }
//     if ((sidebarFilters.workType || []).length > 0) {
//       const selected = sidebarFilters.workType.map(w => w.toLowerCase());
//       result = result.filter(c => selected.includes((c.RemoteStatus || '').toLowerCase()));
//     }

//     // Advanced location filtering with Country/State/City support
//     if (sidebarFilters.country) {
//       const selectedCountryName = sidebarFilters.country;
//       const selectedCountryCode = getCountryCode(selectedCountryName);

//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(selectedCountryName.toLowerCase()) ||
//           locLower.includes(selectedCountryCode.toLowerCase());
//       });
//     }

//     if (sidebarFilters.state) {
//       const selectedStateName = sidebarFilters.state;
//       const countryCode = getCountryCode(sidebarFilters.country);
//       const selectedStateCode = getStateCode(countryCode, selectedStateName);

//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(selectedStateName.toLowerCase()) ||
//           locLower.includes(selectedStateCode.toLowerCase());
//       });
//     }

//     if (sidebarFilters.city) {
//       const cityTerm = sidebarFilters.city.toLowerCase().trim();
//       result = result.filter(c => {
//         if (!c.CurrentLocation) return false;
//         const locLower = c.CurrentLocation.toLowerCase();
//         return locLower.includes(cityTerm);
//       });
//     }

//     if ((sidebarFilters.workAuth || []).length > 0) {
//       const selected = sidebarFilters.workAuth.map(a => a.toLowerCase());
//       result = result.filter(c => selected.includes((c.WorkAuthorization || '').toLowerCase()));
//     }

//     if ((sidebarFilters.employmentTypes || []).length > 0) {
//       const selected = sidebarFilters.employmentTypes.map(t => t.toLowerCase());
//       result = result.filter(c => selected.includes((c.EmploymentType || '').toLowerCase()));
//     }

//     if ((sidebarFilters.industries || []).length > 0) {
//       const selected = sidebarFilters.industries.map(i => i.toLowerCase());
//       result = result.filter(c => selected.includes((c.Industry || '').toLowerCase()));
//     }

//     if ((sidebarFilters.sources || []).length > 0) {
//       const selected = sidebarFilters.sources.map(s => s.toLowerCase());
//       result = result.filter(c => selected.includes((c.Source || '').toLowerCase()));
//     }

//     if ((sidebarFilters.gender || []).length > 0) {
//       const selected = sidebarFilters.gender.map(g => g.toLowerCase());
//       result = result.filter(c => selected.includes((c.Gender || '').toLowerCase()));
//     }

//     if (sidebarFilters.isBench && sidebarFilters.isBench !== 'all') {
//       result = result.filter(c => sidebarFilters.isBench === 'bench' ? c.IsBench : !c.IsBench);
//     }

//     if (sidebarFilters.personType && sidebarFilters.personType !== 'all') {
//       result = result.filter(c => sidebarFilters.personType === 'employees' ? c.IsEmployee : !c.IsEmployee);
//     }

//     if (sidebarFilters.relocate && sidebarFilters.relocate !== 'all') {
//       result = result.filter(c => sidebarFilters.relocate === 'yes' ? c.WillingToRelocate : !c.WillingToRelocate);
//     }

//     if (sidebarFilters.experience !== 'all') {
//       switch (sidebarFilters.experience) {
//         case '0-2': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) <= 2); break;
//         case '3-5': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 2 && e <= 5; }); break;
//         case '5-10': result = result.filter(c => { const e = parseFloat(c.YearsOfExperience) || 0; return e > 5 && e <= 10; }); break;
//         case '10+': result = result.filter(c => (parseFloat(c.YearsOfExperience) || 0) > 10); break;
//         default: break;
//       }
//     }

//     // Advanced filters
//     const validRows = (advancedFilters.rows || []).filter(r => r.field && r.condition);
//     if (validRows.length > 0) {
//       result = result.filter(c => {
//         let isMatch = matchesRow(c, validRows[0]);

//         for (let i = 1; i < validRows.length; i++) {
//           const row = validRows[i];
//           const op = row.operator || 'AND';

//           if (op === 'OR') {
//             isMatch = isMatch || matchesRow(c, row);
//           } else {
//             isMatch = isMatch && matchesRow(c, row);
//           }
//         }
//         return isMatch;
//       });
//     }

//     // Standard sorting
//     result.sort((a, b) => {
//       let av, bv;
//       if (sortConfig.key === 'CreatedDt') {
//         av = new Date(a.CreatedDt || 0); bv = new Date(b.CreatedDt || 0);
//       } else if (sortConfig.key === 'YearsOfExperience') {
//         av = a.YearsOfExperience || 0; bv = b.YearsOfExperience || 0;
//       } else if (sortConfig.key === 'Email') {
//         av = (a.Email || '').toLowerCase();
//         bv = (b.Email || '').toLowerCase();
//       } else if (sortConfig.key === 'FirstName') {
//         av = formatFullName(a.FirstName, a.MiddleName, a.LastName).toLowerCase();
//         bv = formatFullName(b.FirstName, b.MiddleName, b.LastName).toLowerCase();
//       } else {
//         av = String(a[sortConfig.key] || '').toLowerCase();
//         bv = String(b[sortConfig.key] || '').toLowerCase();
//       }
//       if (av < bv) return sortConfig.direction === 'asc' ? -1 : 1;
//       if (av > bv) return sortConfig.direction === 'asc' ? 1 : -1;
//       return 0;
//     });

//     return result;
//   }, [candidates, searchTerm, statusFilter, advancedFilters, sortConfig, aiSearchResults, matchesRow, currentView, sidebarFilters, visibleSidebarFilters, useAiSearch]);

//   const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);
//   const paginatedCandidates = filteredCandidates.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleResetFilters = () => {
//     setSearchTerm('');
//     setAiSearchResults(null);
//     setAdvancedFilters({ rows: [], logic: 'AND' });
//     setSortConfig({ key: 'CreatedDt', direction: 'desc' });
//     setStatusFilter('all');
//     setSidebarFilters({
//       search: '',
//       status: [],
//       workType: [],
//       experience: 'all',
//       country: '',
//       state: '',
//       city: '',
//       sources: [],
//       employmentTypes: [],
//       industries: [],
//       isBench: 'all',
//       personType: 'all',
//       gender: [],
//       relocate: 'all',
//       workAuth: []
//     });
//   };

//   const handleApplyFilters = (filters) => {
//     setAdvancedFilters(filters);
//     setCurrentPage(1);
//   };

//   const requestSort = (key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
//     }));
//     setCurrentPage(1);
//   };

//   const editCandidate = (candidate) => {
//     setEditingCandidate(candidate);
//     setParsedResumeData(null);
//     setShowAddModal(true);
//   };

//   const getFullCandidate = async (id) => {
//     const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
//       headers: getAuthHeaders(),
//     });
//     if (!response.ok) throw new Error('Failed to fetch details');
//     const data = await response.json();
//     return transformCandidate(data);
//   };

//   const deleteCandidate = async (id) => {
//     const candidate = candidates.find(c => c.CandidateId === id);
//     const name = formatFullName(candidate?.FirstName, candidate?.MiddleName, candidate?.LastName);

//     const confirm = await Swal.fire({
//       title: 'Delete Candidate?',
//       text: `This will permanently delete ${name}'s record.`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#ef4444',
//       cancelButtonColor: '#6b7280',
//       confirmButtonText: 'Yes, delete',
//     });

//     if (confirm.isConfirmed) {
//       try {
//         const response = await fetch(`${BASE_URL}/api/resumes/${id}`, {
//           method: 'DELETE',
//           headers: getAuthHeaders(),
//         });
//         if (!response.ok) throw new Error('Failed to delete candidate');
//         setCandidates(prev => prev.filter(c => c.CandidateId !== id));
//         Swal.fire({ title: 'Deleted!', text: `${name} has been removed.`, icon: 'success', timer: 1800, showConfirmButton: false });
//       } catch (error) {
//         console.error('Error deleting candidate:', error);
//         Swal.fire({ title: 'Error', text: 'Failed to delete candidate', icon: 'error' });
//       }
//     }
//   };

//   // ── Parse Resume Flow ──────────────────────────────────────────────────
//   const handleParseFileSelect = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     e.target.value = '';
//     setPendingParseFile(file);
//     setShowConfirmParse(true);
//   };

//   const handleConfirmParse = async () => {
//     if (!pendingParseFile) return;
//     setShowConfirmParse(false);
//     setShowParsingLoading(true);
//     setParsingFromToolbar(true);

//     try {
//       const formData = new FormData();
//       formData.append('file1', pendingParseFile);

//       const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formData
//       });
//       if (!response.ok) throw new Error('Failed to parse resume');

//       const data = await response.json();
//       const parsed = {
//         FirstName: formatName(data.firstName || ''),
//         LastName: formatName(data.lastName || ''),
//         MiddleName: formatName(data.middleName || ''),
//         Email: data.email || '',
//         Phone: data.phone || '',
//         Mobile: data.mobile || '',
//         TwitterUrl: data.twitterUrl || '',
//         VideoResumeUrl: data.videoResumeUrl || '',
//         JobTitle: formatJobTitle(data.jobTitle || ''),
//         YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
//         ProfileSummary: data.profileSummary || '',
//         LinkedInUrl: data.linkedInUrl || '',
//         GitHubUrl: data.gitHubUrl || '',
//         Gender: data.gender || '',
//         CurrentLocation: data.currentLocation || '',
//         cityName: data.cityName || '',
//         stateName: data.stateName || '',
//         countryIso2: data.countryIso2 || '',
//         countryName: data.countryName || '',
//         WorkAuthorization: data.workAuthorization || '',
//         EmploymentType: data.employmentType || '',
//         skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
//         workExperience: (data.workExperience || []).map(exp => ({
//           Company: exp.company || '',
//           JobTitle: formatJobTitle(exp.jobTitle || ''),
//           StartDate: exp.startDate || '', EndDate: exp.endDate || '',
//           IsCurrent: exp.isCurrent || false, Description: exp.description || '',
//         })),
//         education: (data.education || []).map(edu => ({
//           Institution: formatName(edu.institution || ''),
//           Degree: formatName(edu.degree || ''),
//           FieldOfStudy: edu.fieldOfStudy || '', StartDate: edu.startDate || '',
//           EndDate: edu.endDate || '', GPA: edu.gpa || '',
//         })),
//         certifications: (data.certifications || []).map(cert => ({
//           CertificationName: formatName(cert.name || ''),
//           IssuingOrganization: cert.issuingOrg || '',
//           IssueDate: cert.issueDate || '', ExpiryDate: cert.expiryDate || '',
//           CredentialId: cert.credentialId || '', CredentialUrl: cert.credentialUrl || '',
//         })),
//         ResumeFile: pendingParseFile,
//         RawPayloadJson: JSON.stringify(data),
//         ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
//         ParsedText: data.parsedText || data.parsed_text || '',
//         ParserVendor: data.vendor || 'llama-3.1-8b-instant',
//         ExtractedEmail: data.email || data.extracted_email || '',
//         ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
//       };

//       const dup = candidates.find(c =>
//         (parsed.Email && c.Contact?.Email?.toLowerCase() === parsed.Email.toLowerCase()) ||
//         (parsed.LinkedInUrl && c.LinkedInUrl?.toLowerCase() === parsed.LinkedInUrl.toLowerCase())
//       );

//       setShowParsingLoading(false);

//       if (dup) {
//         setParsedResumeData(parsed);
//         setDuplicateCandidate(dup);
//         setShowDuplicateModal(true);
//       } else {
//         setParsedResumeData(parsed);
//         setEditingCandidate(null);
//         setShowAddModal(true);
//       }

//     } catch (error) {
//       console.error('Error parsing resume:', error);
//       setShowParsingLoading(false);
//       Swal.fire({ title: 'Error', text: 'Failed to parse resume. Please try again or add candidate manually.', icon: 'error' });
//     } finally {
//       setParsingFromToolbar(false);
//       setPendingParseFile(null);
//     }
//   };

//   const handleDuplicateAction = async (action) => {
//     setShowDuplicateModal(false);

//     if (action === 'cancel') {
//       setParsedResumeData(null);
//       setDuplicateCandidate(null);
//       return;
//     }

//     let fullDuplicateCandidate = duplicateCandidate;
//     try {
//       Swal.fire({ title: 'Loading...', text: 'Fetching candidate details', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//       const response = await fetch(`${BASE_URL}/api/resumes/${duplicateCandidate.CandidateId}`, { headers: getAuthHeaders() });
//       if (response.ok) {
//         const data = await response.json();
//         fullDuplicateCandidate = transformCandidate(data);
//       }
//       Swal.close();
//     } catch (e) {
//       console.error('Error fetching duplicate candidate full details:', e);
//       Swal.close();
//     }

//     if (action === 'add_resume') {
//       setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
//       setEditingCandidate(fullDuplicateCandidate);
//       setShowAddModal(true);
//     }
//     else if (action === 'overwrite') {
//       setEditingCandidate({
//         CandidateId: fullDuplicateCandidate.CandidateId,
//         Document: fullDuplicateCandidate.Document,
//         Contact: { Email: fullDuplicateCandidate.Contact?.Email }
//       });
//       setShowAddModal(true);
//     }
//     else if (action === 'append') {
//       const synthCandidate = { ...fullDuplicateCandidate };

//       for (const [key, value] of Object.entries(parsedResumeData)) {
//         if (typeof value === 'string' && value.trim() !== '') {
//           synthCandidate[key] = value;
//         } else if (typeof value === 'number') {
//           synthCandidate[key] = value;
//         }
//       }

//       const appendedSkills = [...(fullDuplicateCandidate.Skills || [])];
//       (parsedResumeData.skills || []).forEach(s => appendedSkills.push({ ...s }));
//       synthCandidate.Skills = appendedSkills;

//       synthCandidate.WorkExperience = [...(fullDuplicateCandidate.WorkExperience || []), ...(parsedResumeData.workExperience || [])];
//       synthCandidate.Education = [...(fullDuplicateCandidate.Education || []), ...(parsedResumeData.education || [])];
//       synthCandidate.Certifications = [...(fullDuplicateCandidate.Certifications || []), ...(parsedResumeData.certifications || [])];

//       setParsedResumeData({ ResumeFile: parsedResumeData.ResumeFile });
//       setEditingCandidate(synthCandidate);
//       setShowAddModal(true);
//     }
//   };

//   // ── Resume upload / extract ──
//   const handleResumeUpload = async (file) => {
//     try {
//       setUploadingResume(true);
//       const formData = new FormData();
//       formData.append('file1', file);

//       const response = await fetch(`${BASE_URL}/api/resumes/parse`, {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formData
//       });
//       if (!response.ok) throw new Error('Failed to parse resume');

//       const data = await response.json();
//       return {
//         FirstName: formatName(data.firstName || ''),
//         LastName: formatName(data.lastName || ''),
//         MiddleName: formatName(data.middleName || ''),
//         Email: data.email || '',
//         Phone: data.phone || '',
//         Mobile: data.mobile || '',
//         TwitterUrl: data.twitterUrl || '',
//         VideoResumeUrl: data.videoResumeUrl || '',
//         JobTitle: formatJobTitle(data.jobTitle || ''),
//         YearsOfExperience: data.yearsOfExperience ? parseFloat(data.yearsOfExperience) : '',
//         ProfileSummary: data.profileSummary || '',
//         LinkedInUrl: data.linkedInUrl || '',
//         GitHubUrl: data.gitHubUrl || '',
//         Gender: data.gender || '',
//         CurrentLocation: data.currentLocation || '',
//         cityName: data.cityName || '',
//         stateName: data.stateName || '',
//         countryIso2: data.countryIso2 || '',
//         countryName: data.countryName || '',
//         WorkAuthorization: data.workAuthorization || '',
//         EmploymentType: data.employmentType || '',
//         Skills: (data.skills || []).map(s => ({ SkillName: typeof s === 'string' ? s : s.skill_name || '', SkillType: 'HARD' })),
//         WorkExperience: (data.workExperience || []).map(exp => ({
//           Company: exp.company || '',
//           JobTitle: formatJobTitle(exp.jobTitle || ''),
//           StartDate: exp.startDate || '',
//           EndDate: exp.endDate || '',
//           IsCurrent: exp.isCurrent || false,
//           Description: exp.description || '',
//         })),
//         Education: (data.education || []).map(edu => ({
//           Institution: formatName(edu.institution || ''),
//           Degree: formatName(edu.degree || ''),
//           FieldOfStudy: edu.fieldOfStudy || '',
//           StartDate: edu.startDate || '',
//           EndDate: edu.endDate || '',
//           GPA: edu.gpa || '',
//         })),
//         Certifications: (data.certifications || []).map(cert => ({
//           CertificationName: formatName(cert.name || ''),
//           IssuingOrganization: cert.issuingOrg || '',
//           IssueDate: cert.issueDate || '',
//           ExpiryDate: cert.expiryDate || '',
//           CredentialId: cert.credentialId || '',
//           CredentialUrl: cert.credentialUrl || '',
//         })),
//         RawPayloadJson: JSON.stringify(data),
//         ParseStatus: data.parseStatus || data.parse_status || 'SUCCESS',
//         ParsedText: data.parsedText || data.parsed_text || '',
//         ParserVendor: data.vendor || 'llama-3.1-8b-instant',
//         ExtractedEmail: data.email || data.extracted_email || '',
//         ExtractedPhone: data.phone || data.mobile || data.extracted_phone || '',
//       };
//     } catch (error) {
//       console.error('Error parsing resume:', error);
//       Swal.fire({ title: 'Error', text: 'Failed to parse resume. Please fill the form manually.', icon: 'error' });
//       return null;
//     } finally {
//       setUploadingResume(false);
//     }
//   };

//   // ── Save candidate ──
//   const handleSaveCandidate = async (data) => {
//     try {
//       setUploadingResume(true);

//       if (data.currentLocation && data.currentLocation.trim()) {
//         const parts = data.currentLocation.split(',').map(s => s.trim()).filter(Boolean);
//         console.log(`📍 Location being saved: "${data.currentLocation}" (${parts.length} parts)`);
//       }

//       const isEditing = !!(editingCandidate?.CandidateId || data.candidateId);
//       const candidateId = editingCandidate?.CandidateId || data.candidateId;

//       const formData = new FormData();

//       const firstName = formatName(data.firstName || data.FirstName || '');
//       const lastName = formatName(data.lastName || data.LastName || '');
//       const middleName = formatName(data.middleName || data.MiddleName || '');
//       const jobTitle = formatJobTitle(data.jobTitle || data.JobTitle || '');

//       formData.append('FirstName', firstName);
//       formData.append('LastName', lastName);
//       formData.append('MiddleName', middleName);
//       formData.append('EmailID', (data.email || data.Email || '').trim());
//       formData.append('Phone', (data.phone || data.Phone || '').trim());
//       formData.append('Mobile', (data.mobile || data.Mobile || '').trim());
//       formData.append('JobTitle', jobTitle);
//       formData.append('YearsOfExperience', data.yearsOfExperience ?? data.YearsOfExperience ?? '');
//       formData.append('Gender', (data.gender || data.Gender || '').trim());
//       formData.append('ProfileSummary', (data.profileSummary || data.ProfileSummary || '').trim());
//       formData.append('LinkedInProfile', (data.linkedInUrl || data.LinkedInUrl || '').trim());
//       formData.append('GitHubUrl', (data.gitHubUrl || data.GitHubUrl || '').trim());
//       formData.append('TwitterUrl', (data.twitterUrl || data.TwitterUrl || '').trim());
//       formData.append('VideoResumeUrl', (data.videoResumeUrl || data.VideoResumeUrl || '').trim());
//       formData.append('CandidateStatus', data.candidateStatus || data.CandidateStatus || 'Available');
//       formData.append('RemoteStatus', data.remoteStatus || data.RemoteStatus || 'OnSite');
//       formData.append('CurrentLocation', (data.currentLocation || data.CurrentLocation || '').trim());

//       formData.append('WorkAuthorization', data.workAuthorization || data.WorkAuthorization || '');
//       formData.append('EmploymentType', data.employmentType || data.EmploymentType || '');
//       formData.append('SecurityClearance', data.securityClearance || data.SecurityClearance || '');
//       formData.append('WillingToRelocate', data.willingToRelocate ? 'true' : 'false');
//       formData.append('IsBench', data.isBench ? 'true' : 'false');
//       formData.append('ExpectedRateFrom', data.expectedRateFrom || data.ExpectedRateFrom || '');
//       formData.append('ExpectedRateTo', data.expectedRateTo || data.ExpectedRateTo || '');
//       formData.append('ExpectedRateType', data.expectedRateType || data.ExpectedRateType || 'Hourly');
//       formData.append('CurrentRate', data.currentRate || data.CurrentRate || '');
//       formData.append('CurrentRateType', data.currentRateType || data.CurrentRateType || 'Hourly');
//       formData.append('MaritalStatus', data.maritalStatus || data.MaritalStatus || '');
//       formData.append('Industry', data.industry || data.Industry || '');

//       const skillsList = (data.skills || data.Skills || []).map(s =>
//         typeof s === 'string' ? s : (s.SkillName || s.skillName || '')
//       ).filter(Boolean);
//       formData.append('Skills', JSON.stringify(skillsList));

//       const workList = (data.workExperience || data.WorkExperience || [])
//         .filter(w => (w.company || w.Company || '').trim() || (w.jobTitle || w.JobTitle || '').trim())
//         .map(exp => ({
//           Company: (exp.company || exp.Company || '').trim(),
//           JobTitle: formatJobTitle(exp.jobTitle || exp.JobTitle || ''),
//           StartDate: exp.startDate || exp.StartDate || '',
//           EndDate: exp.endDate || exp.EndDate || '',
//           IsCurrent: exp.isCurrent ?? exp.IsCurrent ?? false,
//           Description: (exp.description || exp.Description || '').trim(),
//         }));
//       formData.append('WorkExperience', JSON.stringify(workList));

//       const eduList = (data.education || data.Education || [])
//         .filter(e => (e.institution || e.Institution || '').trim() || (e.degree || e.Degree || '').trim())
//         .map(edu => ({
//           Institution: formatName(edu.institution || edu.Institution || ''),
//           Degree: formatName(edu.degree || edu.Degree || ''),
//           FieldOfStudy: (edu.fieldOfStudy || edu.FieldOfStudy || '').trim(),
//           StartDate: edu.startDate || edu.StartDate || '',
//           EndDate: edu.endDate || edu.EndDate || '',
//           GPA: (edu.gpa || edu.GPA || '').trim(),
//         }));
//       formData.append('Education', JSON.stringify(eduList));

//       const certList = (data.certifications || data.Certifications || [])
//         .filter(c => (c.name || c.CertificationName || '').trim())
//         .map(cert => ({
//           CertificationName: formatName(cert.name || cert.CertificationName || ''),
//           IssuingOrganization: (cert.issuingOrg || cert.IssuingOrganization || '').trim(),
//           IssueDate: cert.issueDate || cert.IssueDate || '',
//           ExpiryDate: cert.expiryDate || cert.ExpiryDate || '',
//           CredentialId: (cert.credentialId || cert.CredentialId || '').trim(),
//           CredentialUrl: (cert.credentialUrl || cert.CredentialUrl || '').trim(),
//         }));
//       formData.append('Certifications', JSON.stringify(certList));

//       if (data.ResumeFile) {
//         formData.append('ResumeUpload', data.ResumeFile);
//       }

//       if (data.RawPayloadJson) formData.append('RawPayloadJson', data.RawPayloadJson);
//       if (data.ParseStatus) formData.append('ParseStatus', data.ParseStatus);
//       if (data.ParsedText) formData.append('ParsedText', data.ParsedText);
//       if (data.ParserVendor) formData.append('ParserVendor', data.ParserVendor);
//       if (data.ExtractedEmail) formData.append('ExtractedEmail', data.ExtractedEmail);
//       if (data.ExtractedPhone) formData.append('ExtractedPhone', data.ExtractedPhone);

//       const additionalDocs = (data.documents || []).filter(d => d.file instanceof File);
//       let docIndex = 0;
//       for (const doc of additionalDocs) {
//         formData.append(`AdditionalDoc_${docIndex}`, doc.file);
//         formData.append(`AdditionalDoc_${docIndex}_Name`, doc.documentName || doc.file.name);
//         formData.append(`AdditionalDoc_${docIndex}_Type`, doc.documentType || 'Certificate');
//         docIndex++;
//       }
//       formData.append('AdditionalDocsCount', String(docIndex));

//       const url = isEditing
//         ? `${BASE_URL}/api/resumes/${candidateId}`
//         : `${BASE_URL}/api/resumes`;

//       const response = await fetch(url, {
//         method: isEditing ? 'PUT' : 'POST',
//         headers: getAuthHeaders(),
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.error || errorData.detail || 'Failed to save candidate');
//       }

//       _cachedCandidates = null;
//       await fetchCandidates(true);
//       setShowAddModal(false);
//       setEditingCandidate(null);
//       setParsedResumeData(null);
//       Swal.fire({ title: 'Success!', text: 'Candidate saved successfully.', icon: 'success', timer: 1800, showConfirmButton: false });

//     } catch (error) {
//       console.error('Error saving candidate:', error);
//       Swal.fire({ title: 'Error', text: error.message || 'Failed to save candidate', icon: 'error' });
//     } finally {
//       setUploadingResume(false);
//     }
//   };

//   const exportToExcel = () => {
//     setExporting(true);
//     const data = filteredCandidates.map(c => ({
//       'Candidate Code': c.CandidateCode,
//       'First Name': c.FirstName,
//       'Last Name': c.LastName,
//       'Middle Name': c.MiddleName || '',
//       'Job Title': c.JobTitle,
//       'Email': c.Contact?.Email || '',
//       'Phone': c.Contact?.Phone || '',
//       'Mobile': c.Mobile || '',
//       'Twitter URL': c.TwitterUrl || '',
//       'Video Resume URL': c.VideoResumeUrl || '',
//       'Years of Experience': c.YearsOfExperience,
//       'Gender': c.Gender,
//       'Candidate Status': c.CandidateStatus,
//       'Remote Status': c.RemoteStatus,
//       'Work Authorization': c.WorkAuthorization || '',
//       'Employment Type': c.EmploymentType || '',
//       'Security Clearance': c.SecurityClearance || '',
//       'Willing to Relocate': c.WillingToRelocate ? 'Yes' : 'No',
//       'Expected Rate From': c.ExpectedRateFrom || '',
//       'Expected Rate To': c.ExpectedRateTo || '',
//       'Expected Rate Type': c.ExpectedRateType || '',
//       'Current Rate': c.CurrentRate || '',
//       'Current Rate Type': c.CurrentRateType || '',
//       'Marital Status': c.MaritalStatus || '',
//       'Industry': c.Industry || '',
//       'LinkedIn': c.LinkedInUrl || '',
//       'GitHub': c.GitHubUrl || '',
//       'Location': c.CurrentLocation || '',
//       'Profile Summary': c.ProfileSummary || '',
//       'Skills': (c.Skills || []).map(s => s.SkillName || s).join(', '),
//       'Resume File': c.Document?.FileNameOriginal || '',
//       'Created Date': formatDate(c.CreatedDt),
//     }));
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Candidates');
//     XLSX.writeFile(wb, `candidates_${new Date().toISOString().split('T')[0]}.xlsx`);
//     setExporting(false);
//     Swal.fire({ title: 'Exported!', text: `${data.length} candidates exported.`, icon: 'success', timer: 1800, showConfirmButton: false });
//   };

//   if (loading) {
//     return (
//       <div className="cm-loading-container">
//         <div className="cm-loading-spinner"></div>
//         <p className="cm-loading-text">Loading candidates...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="cm-dashboard" style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: '24px' }}>
//       {/* Header Area */}
//       <div style={{ padding: '16px 32px 12px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px' }}>
//         <div>
//           <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#111827', margin: 0, lineHeight: 1.2 }}>
//             {currentView === 'sourcing' ? 'Sourcing' :
//               currentView === 'bench' ? 'Bench Candidates' :
//                 currentView === 'review' ? 'Need To Review' :
//                   'Candidates'}
//           </h1>
//           <p style={{ color: '#6b7280', fontSize: '14px', margin: '4px 0 0 0' }}>
//             {currentView === 'sourcing' ? 'Explore active sourcing candidates' :
//               currentView === 'bench' ? 'Manage bench candidates' :
//                 currentView === 'review' ? 'Review candidates with missing information' :
//                   'Manage and explore your candidate database'}
//           </p>
//         </div>

//         <div className="cm-toolbar-actions" style={{ flexWrap: 'wrap', borderBottom: 'none' }}>
//           {selectedCandidateIds.length > 0 && (
//             <button
//               className="cm-btn cm-btn-primary"
//               style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd', marginRight: '8px' }}
//               onClick={() => {
//                 const selectedCands = candidates.filter(c => selectedCandidateIds.includes(c.CandidateId));
//                 setShareModalCandidates(selectedCands);
//                 setShowShareModal(true);
//               }}
//             >
//               <Share2 size={16} /> Share Bulk Profile
//             </button>
//           )}

//           <button className="cm-btn cm-btn-primary" style={{ backgroundColor: '#3b5bfd', borderColor: '#3b5bfd' }} onClick={() => { setEditingCandidate(null); setParsedResumeData(null); setShowAddModal(true); }}>
//             <Plus size={16} /> Add Candidate
//           </button>
//           <button
//             className="cm-btn cm-btn-outline"
//             onClick={() => parseFileInputRef.current?.click()}
//             disabled={parsingFromToolbar}
//           >
//             {parsingFromToolbar
//               ? <><Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> Parsing...</>
//               : <><Upload size={16} /> Parse Resume</>}
//           </button>
//           <input
//             ref={parseFileInputRef}
//             type="file"
//             accept=".pdf,.doc,.docx,.txt"
//             style={{ display: 'none' }}
//             onChange={handleParseFileSelect}
//           />
//           <button className="cm-btn cm-btn-outline" onClick={exportToExcel} disabled={exporting}>
//             <Download size={16} /> {exporting ? 'Exporting...' : 'Export'}
//           </button>

//           <button className="cm-btn cm-btn-outline" title="Manage Columns" onClick={() => setShowColumnSidebar(true)} style={{ padding: '0 10px' }}>
//             <SlidersHorizontal size={16} />
//           </button>

//           <button
//             className={`cm-btn cm-btn-outline ${showFilterSidebar ? 'cm-btn-icon--active' : ''}`}
//             title={showFilterSidebar ? "Close Sidebar" : "Open Sidebar"}
//             onClick={() => setShowFilterSidebar(prev => !prev)}
//             style={{ padding: '0 10px' }}
//           >
//             {showFilterSidebar ? <Filter size={16} />: <Filter size={16} />}
//           </button>

//           {/* <button
//             className={`cm-btn cm-btn-outline ${advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? 'cm-btn-icon--active' : ''}`}
//             title="Filters"
//             onClick={() => setShowFilterModal(true)}
//             style={{
//               padding: '0 10px', ...(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ? {
//                 background: '#eff6ff', border: '1px solid #60a5fa', color: '#3b5bfd'
//               } : {})
//             }}
//           >
//             <Filter size={16} />
//             {advancedFilters.rows.filter(r => r.field && r.condition).length > 0 && (
//               <span style={{
//                 position: 'absolute', top: -4, right: -4,
//                 width: 16, height: 16, borderRadius: '50%',
//                 background: '#3b5bfd', color: '#fff',
//                 fontSize: 9, fontWeight: 800,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//               }}>
//                 {advancedFilters.rows.filter(r => r.field && r.condition).length}
//               </span>
//             )}
//           </button> */}

//           <button
//             className={`cm-ask-ai-btn ${showAiSidebar ? 'cm-ask-ai-btn--active' : ''}`}
//             title="Ask AI"
//             onClick={() => setShowAiSidebar(prev => !prev)}
//             style={{ marginLeft: '4px' }}
//           >
//             <Sparkles size={15} />
//             Ask AI
//           </button>
//         </div>
//       </div>

//       {/* Search & Saved Filters Area */}
//       <div style={{ margin: '0 32px 12px 32px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

//         {/* Top Row: Search Input */}
//         <div
//           className="cm-modern-search-bar"
//           style={{
//             display: 'flex', alignItems: 'center',
//             border: '1px solid #e2e8f0', borderRadius: '8px',
//             padding: '4px 8px 4px 16px', height: '40px',
//             transition: 'all 0.2s ease', background: '#fff',
//             boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
//           }}
//           onFocus={(e) => { e.currentTarget.style.borderColor = '#3b5bfd'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 91, 253, 0.15)'; }}
//           onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.02)'; }}
//         >
//           <div style={{ position: 'relative', display: 'flex', alignItems: 'center', marginRight: '10px', flexShrink: 0 }}>
//             <Search
//               size={17}
//               color={useAiSearch ? "#3b5bfd" : "#64748b"}
//               className={isAiSearching ? "cm-pulse" : ""}
//               style={{ cursor: 'pointer' }}
//               onClick={() => {
//                 if (useAiSearch) {
//                   handleAiSearch(searchTerm);
//                 } else {
//                   setAiSearchResults(null);
//                   setCurrentPage(1);
//                 }
//               }}
//               title={useAiSearch ? "Search with AI" : "Search by keyword"}
//             />
//             <Sparkles
//               size={8}
//               color="#3b5bfd"
//               style={{
//                 position: 'absolute', top: -3, right: -4,
//                 animation: 'cm-spin 4s linear infinite',
//                 opacity: 0.8
//               }}
//             />
//           </div>
//           <input
//             className="cm-search-input-modern"
//             placeholder={useAiSearch ? "Ask AI for semantic search..." : "Search by keyword..."}
//             value={searchTerm}
//             onChange={e => {
//               const val = e.target.value;
//               setSearchTerm(val);
//               if (!useAiSearch) {
//                 if (!val) setAiSearchResults(null);
//                 setCurrentPage(1);
//               }
//             }}
//             onKeyDown={e => {
//               if (e.key === 'Enter') {
//                 if (useAiSearch) {
//                   // Manual trigger if user hits enter early
//                   handleAiSearch(searchTerm);
//                 } else {
//                   setAiSearchResults(null);
//                   setCurrentPage(1);
//                 }
//               }
//             }}
//             style={{
//               border: 'none', outline: 'none', background: 'transparent',
//               flex: 1, fontSize: '14px', color: '#0f172a', height: '100%',
//               fontFamily: 'inherit'
//             }}
//           />
//           {isAiSearching && (
//             <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//               <Loader size={14} style={{ animation: 'cm-spin 1s linear infinite', color: '#3b5bfd' }} />
//             </div>
//           )}
//           <div style={{ width: '1px', height: '20px', background: '#e2e8f0', margin: '0 8px' }}></div>
//           <button
//             onClick={() => {
//               const next = !useAiSearch;
//               setUseAiSearch(next);
//               if (!next) setAiSearchResults(null);
//             }}
//             style={{
//               display: 'flex', alignItems: 'center', gap: '6px',
//               padding: '4px 12px', border: useAiSearch ? '1px solid #60a5fa' : '1px solid #e2e8f0',
//               borderRadius: '20px', background: useAiSearch ? '#eff6ff' : '#fff',
//               color: useAiSearch ? '#3b5bfd' : '#64748b', fontSize: '12px',
//               fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease',
//               marginRight: '8px'
//             }}
//           >
//             <Sparkles size={13} color={useAiSearch ? "#60a5fa" : "#94a3b8"} fill={useAiSearch ? "#60a5fa" : "none"} />
//             AI Search: {useAiSearch ? 'ON' : 'OFF'}
//           </button>
//           <button
//             onClick={handleSaveSearch}
//             className="cm-btn"
//             style={{
//               height: '28px', background: '#f8fafc', color: '#475569',
//               border: '1px solid transparent', borderRadius: '6px',
//               padding: '0 12px', fontWeight: 500, display: 'flex',
//               gap: '6px', alignItems: 'center', transition: 'all 0.2s',
//               flexShrink: 0, fontSize: '12.5px'
//             }}
//             onMouseOver={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#0f172a'; }}
//             onMouseOut={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#475569'; }}
//           >
//             <Bookmark size={14} /> Save
//           </button>
//         </div>

//         {/* Bottom Area: Saved Searches */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
//           <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none', flexShrink: 1, paddingBottom: '2px' }}>
//             {savedSearches.map((s) => {
//               const isActive = s.term === searchTerm && s.status === statusFilter;
//               return (
//                 <button
//                   key={s.id}
//                   onClick={() => handleLoadSearch(s)}
//                   style={{
//                     fontSize: '12.5px',
//                     padding: '0 8px 0 10px',
//                     height: '26px',
//                     borderRadius: '6px',
//                     border: '1px solid transparent',
//                     background: isActive ? '#3b5bfd' : '#f1f5f9',
//                     color: isActive ? '#fff' : '#475569',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '6px',
//                     whiteSpace: 'nowrap',
//                     transition: 'all 0.2s ease',
//                     fontWeight: isActive ? 500 : 400,
//                     flexShrink: 0
//                   }}
//                   title={`Load search: ${s.term || 'All'} in ${s.status}`}
//                   onMouseOver={(e) => { if (!isActive) { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; } }}
//                   onMouseOut={(e) => { if (!isActive) { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#475569'; } }}
//                 >
//                   <span>{s.term || 'All'} {s.status !== 'all' ? `(${s.status})` : ''}</span>
//                   <span
//                     onClick={(e) => { e.stopPropagation(); removeSavedSearch(s.id); }}
//                     style={{
//                       display: 'flex', alignItems: 'center', justifyContent: 'center',
//                       width: '18px', height: '18px', borderRadius: '4px', transition: 'all 0.2s',
//                       color: isActive ? '#fff' : '#94a3b8'
//                     }}
//                     onMouseOver={(e) => { e.currentTarget.style.background = isActive ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.05)'; e.currentTarget.style.color = isActive ? '#fff' : '#0f172a'; }}
//                     onMouseOut={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = isActive ? '#fff' : '#94a3b8'; }}
//                   >
//                     <X size={13} />
//                   </span>
//                 </button>
//               );
//             })}
//           </div>

//           {savedSearches.length > 0 && (
//             <button
//               onClick={() => { setSavedSearches([]); localStorage.removeItem('erp_saved_searches'); }}
//               style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '12px', color: '#cbd5e1', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', transition: 'color 0.2s', padding: 0 }}
//               onMouseOver={(e) => e.currentTarget.style.color = '#ef4444'}
//               onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
//             >
//               Clear
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Main Content Layout */}
//       <div style={{ display: 'flex', borderTop: '1px solid #e2e8f0', minHeight: 'calc(100vh - 180px)' }}>
//         {/* Left Sidebar Filter */}
//         {showFilterSidebar ? (
//           <CandidateFilterSidebar
//             totalCount={filteredCandidates.length}
//             overallTotal={candidates.length}
//             filters={sidebarFilters}
//             setFilters={setSidebarFilters}
//             onClearAll={handleResetFilters}
//             availableStatuses={availableStatuses}
//             availableWorkTypes={availableWorkTypes}
//             availableLocations={availableLocations}
//             availableSources={availableSources}
//             availableEmploymentTypes={availableEmploymentTypes}
//             availableIndustries={availableIndustries}
//             availableWorkAuths={availableWorkAuths}
//             availableGenders={availableGenders}
//             onClose={() => setShowFilterSidebar(false)}
//             visibleColumns={visibleSidebarFilters}
//             setVisibleColumns={setVisibleSidebarFilters}
//           />
//         ) : (
//           <div
//             className="cm-sidebar-reopen-strip"
//             onClick={() => setShowFilterSidebar(true)}
//             title="Open Filters"
//             style={{
//               width: '12px',
//               background: '#f1f5f9',
//               borderRight: '1px solid #e2e8f0',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               transition: 'all 0.2s ease',
//               position: 'relative',
//               zIndex: 10
//             }}
//             onMouseOver={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.width = '20px'; }}
//             onMouseOut={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.width = '12px'; }}
//           >
//             <div style={{
//               transform: 'rotate(90deg)',
//               whiteSpace: 'nowrap',
//               fontSize: '10px',
//               fontWeight: 700,
//               color: '#64748b',
//               letterSpacing: '0.1em',
//               textTransform: 'uppercase'
//             }}>
//               Filters
//             </div>
//           </div>
//         )}

//         {/* Right Content Area */}
//         <div style={{ flex: 1, minWidth: 0, padding: '0 0 24px 0' }}>
//           {/* AI Search Active Indicator */}
//           {aiSearchResults && (
//             <div style={{
//               padding: '10px 32px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px',
//               background: '#eff6ff',
//               borderBottom: '1px solid #bfdbfe',
//               animation: 'cm-slide-down 0.3s ease'
//             }}>
//               <Sparkles size={16} color="#3b5bfd" className="cm-pulse" />
//               <span style={{ fontSize: '13px', color: '#3b5bfd', fontWeight: 600 }}>
//                 AI-Powered Search Active
//               </span>
//               <span style={{ fontSize: '12.5px', color: '#475569' }}>
//                 — {aiSearchResults.length} candidates ranked by semantic relevance
//               </span>
//               <button
//                 onClick={() => { setAiSearchResults(null); setSearchTerm(''); }}
//                 style={{
//                   marginLeft: 'auto',
//                   background: '#fff',
//                   border: '1px solid #3b5bfd',
//                   color: '#3b5bfd',
//                   borderRadius: '6px',
//                   padding: '4px 12px',
//                   fontSize: '11.5px',
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                   transition: 'all 0.2s',
//                   boxShadow: '0 1px 2px rgba(59, 91, 253, 0.1)'
//                 }}
//                 onMouseOver={(e) => { e.currentTarget.style.background = '#3b5bfd'; e.currentTarget.style.color = '#fff'; }}
//                 onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#3b5bfd'; }}
//               >
//                 Clear AI Search
//               </button>
//             </div>
//           )}

//           {/* Active Filters Indicator */}
//           {(advancedFilters.rows.filter(r => r.field && r.condition).length > 0 ||
//             (sidebarFilters.status || []).length > 0 ||
//             (sidebarFilters.workType || []).length > 0 ||
//             sidebarFilters.country ||
//             sidebarFilters.state ||
//             sidebarFilters.city ||
//             (sidebarFilters.sources || []).length > 0 ||
//             (sidebarFilters.experience && sidebarFilters.experience !== 'all') ||
//             (sidebarFilters.isBench && sidebarFilters.isBench !== 'all') ||
//             (sidebarFilters.gender || []).length > 0 ||
//             (sidebarFilters.workAuth || []).length > 0 ||
//             (sidebarFilters.relocate && sidebarFilters.relocate !== 'all')) && (
//               <div style={{
//                 display: 'flex', alignItems: 'center', gap: 12,
//                 padding: '10px 32px', background: '#f8fafc',
//                 borderBottom: '1px solid #e2e8f0', fontSize: 13,
//                 flexWrap: 'wrap'
//               }}>
//                 <span style={{ fontWeight: 600, color: '#475569', display: 'flex', alignItems: 'center', gap: 4 }}>
//                   <Filter size={14} /> Active Filters:
//                 </span>

//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
//                   {(sidebarFilters.status || []).map(s => (
//                     <span key={s} style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{s}</span>
//                   ))}
//                   {(sidebarFilters.workType || []).map(w => (
//                     <span key={w} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{w}</span>
//                   ))}
//                   {sidebarFilters.country && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Country: {sidebarFilters.country}</span>
//                   )}
//                   {sidebarFilters.state && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>State: {sidebarFilters.state}</span>
//                   )}
//                   {sidebarFilters.city && (
//                     <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>City: {sidebarFilters.city}</span>
//                   )}
//                   {(sidebarFilters.workAuth || []).map(auth => (
//                     <span key={auth} style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Auth: {auth}</span>
//                   ))}
//                   {(sidebarFilters.employmentTypes || []).map(type => (
//                     <span key={type} style={{ background: '#ecfdf5', color: '#065f46', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{type}</span>
//                   ))}
//                   {(sidebarFilters.industries || []).map(ind => (
//                     <span key={ind} style={{ background: '#f8fafc', color: '#475569', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{ind}</span>
//                   ))}
//                   {sidebarFilters.experience && sidebarFilters.experience !== 'all' && (
//                     <span style={{ background: '#f3e8ff', color: '#6b21a8', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>Exp: {sidebarFilters.experience}</span>
//                   )}
//                   {sidebarFilters.isBench && sidebarFilters.isBench !== 'all' && (
//                     <span style={{ background: '#ffedd5', color: '#9a3412', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 500 }}>{sidebarFilters.isBench === 'bench' ? 'Bench Only' : 'Non-Bench'}</span>
//                   )}
//                 </div>

//                 <button
//                   onClick={handleResetFilters}
//                   style={{
//                     marginLeft: 'auto', background: 'none', border: 'none',
//                     color: '#ef4444', fontSize: 12, fontWeight: 600, cursor: 'pointer',
//                     display: 'flex', alignItems: 'center', gap: 4
//                   }}
//                 >
//                   Clear All
//                 </button>
//               </div>
//             )}

//           {/* Table or AI Loading */}
//           {isAiSearching ? (
//             <div className="cm-ai-search-loading">
//               <div className="cm-ai-search-loading-icon-wrapper">
//                 <Sparkles size={48} color="#3b5bfd" fill="#3b5bfd" className="cm-ai-loading-sparkles" />
//               </div>
//               <h2 className="cm-ai-search-loading-title">AI Is analyzing your database...</h2>
//               <p className="cm-ai-search-loading-subtitle">Finding the best matches based on semantic relevance</p>
//               <div className="cm-ai-search-loading-progress-container">
//                 <div className="cm-ai-search-loading-progress-bar"></div>
//               </div>
//             </div>
//           ) : (
//             <CandidateTable
//               candidates={paginatedCandidates}
//               isAiSearching={isAiSearching}
//               visibleColumns={visibleColumns}
//               sortConfig={sortConfig}
//               onSort={requestSort}
//               onView={viewCandidate}
//               onEdit={editCandidate}
//               onShare={(candidate) => {
//                 setShareModalCandidates([candidate]);
//                 setShowShareModal(true);
//               }}
//               onSchedule={(candidate) => {
//                 setScheduleCandidate(candidate);
//                 setShowJobsModal(true);
//               }}
//               onSubmitProfile={(candidate) => {
//                 setSubmitCandidate(candidate);
//                 setShowSubmitModal(true);
//               }}
//               onDelete={deleteCandidate}
//               currentPage={currentPage}
//               totalPages={totalPages}
//               totalCount={filteredCandidates.length}
//               onPageChange={setCurrentPage}
//               itemsPerPage={itemsPerPage}
//               onItemsPerPageChange={(newVal) => {
//                 setItemsPerPage(newVal);
//                 setCurrentPage(1);
//               }}
//               selectedRows={selectedCandidateIds}
//               onSelectionChange={setSelectedCandidateIds}
//             />
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       <ShareResumeModal
//         isOpen={showShareModal}
//         onClose={() => { setShowShareModal(false); setShareModalCandidates([]); }}
//         candidates={shareModalCandidates}
//       />

//       <CandidateJobsModal
//         isOpen={showJobsModal}
//         onClose={() => { setShowJobsModal(false); setScheduleCandidate(null); }}
//         candidate={scheduleCandidate}
//         onSelectJob={(job) => {
//           setSelectedJobForInterview(job);
//           setShowJobsModal(false);
//           setShowScheduleModal(true);
//         }}
//       />

//       <ScheduleInterviewModal
//         isOpen={showScheduleModal}
//         onClose={() => { setShowScheduleModal(false); setScheduleCandidate(null); setSelectedJobForInterview(null); }}
//         candidate={scheduleCandidate}
//         job={selectedJobForInterview}
//       />

//       <SubmitProfileModal
//         isOpen={showSubmitModal}
//         onClose={() => { setShowSubmitModal(false); setSubmitCandidate(null); }}
//         candidate={submitCandidate}
//       />

//       {showAddModal && (
//         <AddModal
//           candidate={editingCandidate}
//           onClose={() => { setShowAddModal(false); setEditingCandidate(null); setParsedResumeData(null); }}
//           onSave={handleSaveCandidate}
//           onResumeUpload={handleResumeUpload}
//           uploading={uploadingResume}
//           parsedData={parsedResumeData}
//           fetchFullCandidateDetails={getFullCandidate}
//         />
//       )}

//       <FilterModal
//         isOpen={showFilterModal}
//         onClose={() => setShowFilterModal(false)}
//         onApply={handleApplyFilters}
//         initialFilters={advancedFilters}
//       />

//       <ConfirmParseModal
//         isOpen={showConfirmParse}
//         onConfirm={handleConfirmParse}
//         onCancel={() => { setShowConfirmParse(false); setPendingParseFile(null); }}
//       />

//       <ParsingLoadingModal
//         isOpen={showParsingLoading}
//       />

//       <DuplicateResumeModal
//         isOpen={showDuplicateModal}
//         duplicateCandidate={duplicateCandidate}
//         onProceed={handleDuplicateAction}
//         onCancel={() => handleDuplicateAction('cancel')}
//       />

//       <ColumnFilterSidebar
//         availableColumns={availableColumns}
//         selectedColumns={visibleColumns}
//         setSelectedColumns={setVisibleColumns}
//         availableFilters={availableSidebarFilters}
//         selectedFilters={visibleSidebarFilters}
//         setSelectedFilters={setVisibleSidebarFilters}
//         onClose={() => setShowColumnSidebar(false)}
//         isOpen={showColumnSidebar}
//       />

//       {showAiSidebar && (
//         <div className="cm-ai-overlay" onClick={() => setShowAiSidebar(false)} />
//       )}
//       <AskAiSidebar
//         isOpen={showAiSidebar}
//         onClose={() => setShowAiSidebar(false)}
//         candidates={candidates}
//       />
//     </div>
//   );
// };

// export default ResumeDashboard;